import html2canvas from "html2canvas";
import SoundMeter from "./soundmeter";

import ConstCode from "./ConstCode";
import ConstData from "./ConstData";
import { getRelayCameraStream, relayLive } from "./relay/PentalkRelayCamera"; // 20261020 web-relay phase1 2차(개발 전용)
import { enTokenCMD, enFrame, enImage, enP2PMode, stTopKind, stTimeKind } from "./classTalk/CodeEnum";
import { ctTimerLv, enRbmqError } from "./ConstCommand";
import { startIOSRelaySession, stopIOSRelaySession, isIOSRelayCameraReady, switchIOSRelayVideo, isIOSRelayNativeMic, changeIOSRelayMyCam, clearIOSRelayMyCam } from "./iosRelay/IOSRelayLive"; // 20261022 [IOS-RELAY] iOS 앱 relay(개발 전용), 20261023 카메라 전환 추가

import {
    sendP2PSoundOff,
    sendMicVolumeLevel,
    sendP2PSoundReadyLocal,
    sendHandsUpInitDone,
    sendUpdateHandsUpImage,
    xmitCmd_AndroidMessage,
    getIsAlivePenCamService,
    xmitCmd_AndroidSmallGroupInfo,
    sendStartPentalkOnScreenForAndroid,
    sendStartPentalkOnScreenForIOS,
    xmitCmd_AndroidJsonMessage,
    sendP2PSoundOn,
    getRabbitMQTokenKey,
    onSuccessConnect,               // ▼ ios 관련 메소드들
    onSuccessConnectForMixedClass,
    onSuccessSubscribe,
    onSuccessUnsubscribe,
    onSuccessSubscribeLive,
    onSuccessUnsubscribeLive,
    onSuccessSubscribeSmallGroup,
    onSuccessUnsubscribeSmallGroup,
    onSuccessSubscribeForMixedClass,
    onSuccessSubscribeTempKeyForMixedClass,
    onSuccessUnsubscribeTempKeyForMixedClass,
    onMessageArrivedFromIOSWebView,
    setIsAlivePenCamService,
    onConnectionLost,
    xmitCmd_IosMessage,
    reconnectLive,
    setIsIntentionalDisconnect,
    syncIOSCameraStatePackets       // 261006 iOS Pro 카메라 중단/재개 패킷 등록
} from "./RabbitmqClient";

import {
    produceAudio,
    produceVideo,
    sendUnpublish,
    enableAudioTrack,
    disableAudioTrack,
    setSelectedMode,
    setUnselectedMode,
    handleP2PConsume,
    initHandsUpConsumeInfo,
    subscribeHandsUpP2P,
    subscribeHandsUpAudio,
    subscribeHandsUpAudioArray,
    unsubscribe,
    unsubscribeHandsUpAudio,
    unsubscribeHandsUpConsumeAll,
    controlSpeakerVolume,
    setVideoResolution,
    unsubscribeHandsUpConsume,
    sendAppConnectProducerTransport,
    sendAppProduce,
    sendAppEndProduceCallback,
    sendAppUnpublish,
    applyConfigFPS,
    runLiveSendExit,            // 20261028 학생 송출 종료 작업 (web-relay R-224)
    finishLiveSendExit,
    noteLiveSendRelayUnknown,
    openLiveSendOwner,
    deferLiveSendStart,
    beginLiveSendAcquire,       // 20261030 획득 2단계 (web-relay R-238~R-240·R-262·R-266)
    endLiveSendAcquire,
    isLiveSendIntentValid,
    reclaimLiveSendTrack,
    checkLiveReceiveAliveIOS    // 20261104 [iOS] 앱 복귀 시 선생님 영상 수신 연결 판단
} from "./MediaSoupClient";
import { isStartIntentValid } from "./mediasoup/sendExitGuard"; // 20261028 보류한 시작 재확인 (web-relay R-236)

import { 
    rcvCmd_AndroidMicStatus
} from "../lib/rbmq/rcvMsgFromRbmq";

import {
    rbmqServerConnected
} from "../modules/user";

import {
    changeHandsUpStatusInfo,
    mqHandsUpOff, 
    smallGroupStop
} from "../modules/live";

import { isDevVersion, isUsableArrayObj } from "./func/ExportFunction";
import { bindMixerInputOwner, createMixerInput, canReleaseMixerInput, releaseMixerInput, discardMixerInput, noteMixerCleanupFailure, replaceSystemMixerInputForScreen, replaceMicMixerInputForDevice } from "./helper/HandsUpMixerInputCleanup"; // 20261029 믹서 입력 clone·마이캠 캡처 반환 (web-relay R-246·R-247) // 20261030 교체 폐기 (R-249·R-263)
import { bindAcquireGuard, beginAcquire, endAcquire, isAcquireIntentOk, dropIfInvalid, stopAcquiredStream, requestLegacy } from "./helper/HandsUpAcquireGuard"; // 20261030 브라우저 획득 무효 결과 처리 (web-relay R-238~R-240·R-261·R-262)

const BandConstraints = {
    Camera: {
        width       : {
            min     : enImage.nHD.width,            // <nHD ... 640 x 360>
            ideal   : enImage.HD.width,             // <HD ... 1280 x 720>
            max     : enImage.HD.width              // <HD ... 1280 x 720>
        },
        height      : {
            min     : enImage.nHD.height,           // <nHD ... 640 x 360>
            ideal   : enImage.HD.height,            // <HD ... 1280 x 720>
            max     : enImage.HD.height             // <HD ... 1280 x 720>
        },
        frameRate   : {
            // min     : enFrame.SIXTEEN_FRAMES,       // 16 Frame
            // ideal   : enFrame.SIXTEEN_FRAMES,       // 16 Frame
            // max     : enFrame.SIXTEEN_FRAMES        // 16 Frame
            min     : enFrame.TWENTY_FOUR_FRAMES,   // 24 Frame
            ideal   : enFrame.TWENTY_FOUR_FRAMES,   // 24 Frame
            max     : enFrame.TWENTY_FOUR_FRAMES    // 24 Frame
        }
    },
    CameraForMyCam: {
        width       : {
            min     : enImage.qqHD.width,           // <qqHD ... 480 x 270>
            ideal   : enImage.nHD.width,            // <nHD ... 640 x 360>
            max     : enImage.nHD.width             // <nHD ... 640 x 360>
        },
        height      : {
            min     : enImage.qqHD.height,          // <qqHD ... 480 x 270>
            ideal   : enImage.nHD.height,           // <nHD ... 640 x 360>
            max     : enImage.nHD.height            // <nHD ... 640 x 360>
        },
        frameRate   : {
            min     : enFrame.SIXTEEN_FRAMES,       // 16 Frame
            ideal   : enFrame.SIXTEEN_FRAMES,       // 16 Frame
            max     : enFrame.SIXTEEN_FRAMES        // 16 Frame
            // min     : enFrame.TWENTY_FOUR_FRAMES,   // 24 Frame
            // ideal   : enFrame.TWENTY_FOUR_FRAMES,   // 24 Frame
            // max     : enFrame.TWENTY_FOUR_FRAMES    // 24 Frame
        }
    },
    Screen: {
        width       : {
            ideal   : enImage.FHD.width,            // <FHD ... 1920 x 1080>
            max     : enImage.FHD.width             // <FHD ... 1920 x 1080>
        },
        height      : {
            ideal   : enImage.FHD.height,           // <FHD ... 1920 x 1080>
            max     : enImage.FHD.height            // <FHD ... 1920 x 1080>
        },
        frameRate   : {
            // ideal   : enFrame.EIGHTEEN_FRAMES,      // 18 Frame
            // max     : enFrame.EIGHTEEN_FRAMES       // 18 Frame
            ideal   : enFrame.TWENTY_FOUR_FRAMES,   // 24 Frame
            max     : enFrame.TWENTY_FOUR_FRAMES    // 24 Frame
        }
    }
};

const lastUpdateMediaDevicesTime = 0;   // 20261204 ... iOS ondevicechange 이벤트 중복 호출 방지용 변수 추가 ... by ykhan

const timerProcDelayTime = 3000;        // 20251126 ... 타이머 딜레이 시간 2 -> 3초로 변경 & 변수 추가 ... by hjkim

let imageSendWidth              = 128;  // 1280
let imageSendHeight             = 72;   // 720
let imageQuality                = 0.7;
let imageType                   = "image/jpeg";
// let configFPS                   = 1;

let isReconnMode                = false;

let handsUpClientInfo           = {
    liveSeq                     : -1,
    teacherSeq                  : -1,
    userSeq                     : -1,
    userKind                    : null, // 로직 추가 필요(init)

    videoEl                     : null,
    imageEl                     : null,
    myCamEl                     : null,
    // audioEl                     : null,

    sendVideoStream             : null,
    sendAudioStream             : null,

    // 점유 상태 정리를 위한 원본 스트림 저장용 변수 추가 ... by hjkim 20260317
    rawVideoStream              : null,
    rawAudioStream              : null,

    audioContext                : null,
    audioSoundMeter             : null,

    canvasEl                    : null,
    contextEl                   : null,

    isAvailableAudio            : false,
    isMicOn                     : false,
    isMicDisable                : false,
    isSpeakingNow               : false,
    isVideoOn                   : false,
    isP2PMode                   : false,
    isPblGroupProAudioMode      : false,
    isSmallGroupMode            : false,
    isSelectedAudio             : false,
    isMuteMode                  : true,
    isImageProcRunning          : false,
    isMobile                    : false,    // smart phone, tablet 등 touch 가능한 device
    isAndroidDevice             : false,
    isWhaleBook                 : false,    // 20250701 Pentalk WiFi 버전과 맞추기 위해 WhaleBook 구분용 변수 추가 ... by hjkim
    isChromeOSBook              : false,    // 20250701 Pentalk WiFi 버전과 맞추기 위해 ChromeBook 구분용 변수 추가 ... by hjkim
    isEdgeBrowser               : false,    // 20250701 PC 브라우저 구분용 변수 추가 ... by hjkim
    isEOBrowser                 : false,    // 20250701 PC 브라우저 구분용 변수 추가 ... by hjkim
    isForPblModeBrowser         : false,    // 20250701 Pbl 모드 브라우저 구분용 변수 추가 ... by hjkim
    isForPblMode                : false,    // 20250701 Pbl 모드 브라우저 구분용 변수 추가 ... by hjkim
    isMixedClassMember          : false,

    isConnectediOSApp           : false,    // ios 네이티브 MQ 연결 여부 ... by ykhan
    isStreamingiOSApp           : false,    // ios 네이티브 mediasoup 송출 여부 ... by ykhan

    localStreamingMode          : enP2PMode.Thumbnail,
    topKind                     : stTopKind.All_Client,
    configFPS                   : 1,        // default는 None_SmartTV
    configFPSKind               : stTimeKind.EIGHT_FRAMES,

    audioVolume                 : 10,
    micVolume                   : 0,

    activeYn                    : "N",
    viewKind                    : null,
    beforeViewKind              : null,
    soundLevel                  : -1,   // pentalk handsup speak 이미지 갱신을 위해 초기값은 -1 by hjkim 20210104
    imageSendFileName           : null,

    imageSendTime               : ctTimerLv.LV_DEFAULT,
    imageSendProc               : null,
    micVolumeSendProc           : null,
    timerProc                   : null,
    tempTimerProc               : null,

    handsUpFunc                 : null,

    videoInputInfo              : {
        isMyCamRunning          : false,
        myCamIndex              : -1,
        myCamDeviceId           : null,
        selectedIndex           : -1,
        selectedDeviceId        : null,
        androidFacingMode       : null,      // 20260730 ... Android WebView 공유 카메라 전/후면 순환 상태 ... by hjkim
        androidDevicesRefreshed : false,     // 20260730 ... Android WebView 카메라 권한 획득 후 장치 목록 재조회 완료 여부 ... by hjkim
        androidFrontDeviceId    : null,      // 20260730 ... Android WebView에서 권한 획득에 성공한 전면 카메라 deviceId ... by hjkim
        iosDevicesRefreshed     : false,     // 20260805 ... iOS Webiew 카메라 권한 획득 후 장치 목록 재조회 완료 여부
        myCamMediaInfo          : { deviceId: null, groupId: null, label: null },
        selectedMediaInfo       : { deviceId: null, groupId: null, label: null },
        list_videoInput         : []
    },

    audioInputInfo              : {
        defaultAudioInput       : { deviceId: null, groupId: null, label: null },
        currentAudioInput       : { deviceId: null, groupId: null, label: null }
    },

    smallGroupInfo              : [],

    list_audioConsumeUserSeq    : [],

    /** for smartTV */
    isSmartTVMode               : false,
    list_smartTVKey             : [],
    smartTVP2PMode              : enP2PMode.Thumbnail,

    /** Audio Mixer */
    audioCtx                    : null,
    audioMerger                 : null,
    destination                 : null,

    // 20261001 일반 Pro PC는 기존 mixed audio track을 유지하고, 각 입력 포함 여부만 별도로 관리한다.
    microphoneIncluded          : true,
    systemAudioIncluded         : true,

    // -----------------------------------------------------------
    // 🎚️ Audio Mixer 동적 밸런싱 (Ducking) 설정
    // -----------------------------------------------------------
    isDuckingEnabled            : false,    // 20261015 ... 동적 밸런싱 비활성화 ... by hjkim
    isSpeaking                  : false,

    /**
     * 마이크로 말할 때/침묵할 때를 구분하기 위한 음성 감지 임계값 (동적 밸런싱 활성화 시 사용)
     * audioSoundMeter.instant 값과 비교해서 발화 여부를 판단.
     * 
     * @since 2025-11-06.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.02 -> 0.05 값 변경 (0.02는 너무 낮아서 배경 노이즈도 발화로 인식됨 → 시스템 오디오가 계속 줄어듦)
     *        ￮ 0.05: 실제 발화와 노이즈를 구분하기 좋음 (0.03~0.05 구간 추천)
     *        ￮ by hjkim
     *      • 2025-11-06:
     *        ￮ 음성 감지 임계값 변수 추가
     *        ￮ 0.02: 조용하게 말하는 것을 고려한 값으로 설정
     *        ￮ by hjkim
     */
    voiceThreshold              : 0.05,

    /**
     * 볼륨 전환 시간을 설정 (초 단위)
     * linearRampToValueAtTime의 duration 값.
     * 
     * @since 2025-11-06.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.3 -> 0.1 값 변경 (0.3은 볼륨 전환이 느려서 첫 음절이 묻힘)
     *        ￮ 0.1: 빠르게 전환해서 첫 음절부터 마이크가 선명하게 들림 (너무 짧으면(0.05 이하) 볼륨이 툭툭 튀는 느낌이 남)
     *        ￮ by hjkim
     *      • 2025-11-06:
     *        ￮ 볼륨 전환 시간 설정 변수 추가
     *        ￮ 0.3
     *        ￮ by hjkim
     */
    duckingFadeTime             : 0.1,

    /**
     * 침묵 시 전환 딜레이 시간을 설정 (밀리미터 초 단위)
     * 발화 감지 후 이 시간 동안 추가 발화가 없으면 침묵으로 판단.
     * 
     * @since 2025-11-06.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 500 -> 1000 값 변경 (500은 문장 사이 짧은 쉼표(pause)에도 침묵으로 판단 → 시스템 오디오가 들어오는 노이즈)
     *        ￮ 1000: 자연스러운 문장 호흡 (1초) 후 전환 (빠른 대화라면 800ms도 무방)
     *        ￮ by hjkim
     *      • 2025-11-06:
     *        ￮ 침묵 시 전환 딜레이 시간 설정 변수 추가
     *        ￮ 500
     *        ￮ by hjkim
     */
    voiceSilenceDelay           : 1000,

    voiceDetectionTimeout       : null,

    // -----------------------------------------------------------
    // 🎤 마이크 GainNode 설정
    // -----------------------------------------------------------
    micStreamSource             : null,
    micGainNode                 : null,     // 20251106 ... 마이크 오디오 스트림 소스 볼륨 조절을 위해 추가 ... by hjkim

    /**
     * 기본 마이크 게인 (동적 밸런싱 비활성화 시 사용)
     * 
     * @since 2025-11-06.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.3 (30%) -> 0.8 (80%) 값 변경
     *        ￮ 0.8 (80%): 마이크가 충분히 들리면서 시스템 오디오와 균형 유지
     *        ￮ by hjkim
     *      • 2025-11-06:
     *        ￮ 마이크 권장 볼륨 설정값 변수 추가
     *        ￮ 0.3 (30%): 마이크 기본값으로 사용
     *        ￮ by hjkim
     */
    micGainValue                : 0.8,

    /**
     * 말할 때 마이크 게인 (동적 밸런싱 활성화 시 사용)
     * 
     * @since 2025-11-11.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.5 (50%) -> 1.0 (100%) 값 변경 (0.5일 때 마이크가 절반밖에 안 들림)
     *        ￮ 1.0 (100%): 말할 때는 마이크를 최대로 올려야 선명하게 들림
     *        ￮ by hjkim
     *      • 2025-11-11:
     *        ￮ 말할 때 마이크 볼륨 설정값 변수 추가
     *        ￮ 0.5 (50%): 마이크/시스템 오디오가 적당히 균형을 이루도록 설정
     *        ￮ by hjkim
     */
    micGainWhenSpeaking         : 1.0,

    /**
     * 침묵 시 마이크 게인 (동적 밸런싱 활성화 시 사용)
     * 
     * @since 2025-11-11.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.2 (20%) -> 0.1 (10%) 값 변경 (0.2일 때 시스템 소리에 노이즈가 약간 발생함)
     *        ￮ 0.1 (10%): 침묵 시 마이크 노이즈를 최소화 (0.0으로 하면 아예 무음이라 좋지만, 말 시작 순간에 첫 음절이 잘릴 수 있어서 0.1 권장)
     *        ￮ by hjkim
     *      • 2025-11-11:
     *        ￮ 침묵 시 마이크 볼륨 설정값 변수 추가
     *        ￮ 0.2 (20%): 침묵 시 마이크 볼륨을 시스템 오디오가 더 잘 들리도록 설정
     *        ￮ by hjkim
     */
    micGainWhenSilent           : 0.1,

    isMicConnectFlag            : false,
    hasMicAudio                 : false,    // 20251105 ... 마이크 스트림을 가지고 있는지 여부 ... by hjkim

    // -----------------------------------------------------------
    // 🔊 시스템 오디오 GainNode 설정
    // -----------------------------------------------------------
    systemStreamSource          : null,
    systemGainNode              : null,     // 20251106 ... 시스템 오디오 스트림 소스 볼륨 조절을 위해 추가 ... by hjkim

    /**
     * 기본 시스템 오디오 게인 (동적 밸런싱 비활성화 시 사용)
     * 
     * @since 2025-11-06.
     * @lastModified 2025-11-06.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2025-11-06:
     *        ￮ 시스템 오디오 권장 볼륨 설정값 변수 추가
     *        ￮ 1.0 (100%): 시스템 오디오 소리가 배경으로 잘 들리도록(= 풀볼륨으로 잘 들리도록) 설정
     *        ￮ by hjkim
     */
    systemGainValue             : 1.0,

    /**
     * 말할 때 시스템 오디오 게인 (동적 밸런싱 활성화 시 사용)
     * 
     * @since 2025-11-11.
     * @lastModified 2026-03-27.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2026-03-27:
     *        ￮ 0.8 (80%) -> 0.3 (30%) 값 변경 (0.8은 말할 때도 시스템이 너무 커서 마이크 소리가 묻힘)
     *        ￮ 0.3 (30%): 말할 때 시스템 오디오를 확실히 줄여줘야 마이크가 들림 (0.2~0.4 범위 추천 (너무 공격적으로 줄이면 배경음이 완전히 끊기는 느낌))
     *        ￮ by hjkim
     *      • 2025-11-11:
     *        ￮ 말할 때 시스템 오디오 볼륨 설정값 변수 추가
     *        ￮ 0.8 (80%): 마이크로 말할 때 시스템 오디오 소리가 배경으로 적당히 들리도록 설정
     *        ￮ by hjkim
     */
    systemGainWhenSpeaking      : 0.3,

    /**
     * 침묵 시 시스템 오디오 게인 (동적 밸런싱 활성화 시 사용)
     * 
     * @since 2025-11-11.
     * @lastModified 2025-11-11.
     * @changelog
     * Note: 업데이트 기록
     *
     *      • 2025-11-11:
     *        ￮ 침묵 시 시스템 오디오 볼륨 설정값 변수 추가
     *        ￮ 1.0 (100%): 침묵 시에는 시스템 오디오를 원래대로 복원하도록 설정
     *        ￮ by hjkim
     */
    systemGainWhenSilent        : 1.0,

    isSysConnectFlag            : false,
    hasSystemAudio              : false,    // 20251105 ... 시스템 오디오 스트림을 가지고 있는지 여부 ... by hjkim
};
bindMixerInputOwner(() => handsUpClientInfo); // 20261029 캡처 입력 정리 helper 연결 (web-relay R-257)
bindAcquireGuard({ begin: beginLiveSendAcquire, end: endLiveSendAcquire, isValid: isLiveSendIntentValid, noteFailure: noteMixerCleanupFailure }); // 20261030 획득 ticket·intent 연결 (web-relay R-238·R-262)

/**
 * react component 제어를 위한 메서드.
 * 
 * @param {Function} imageProcess 
 */
export const initHandsUpFunc = (imageProcess) => {
    handsUpClientInfo.handsUpFunc = imageProcess;
}

/**
 * hands up 기본 정보 설정 초기화 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} tSeq - 선생님 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
const initHandsUpInfo = async (lSeq, tSeq, uSeq, activeYn) => {
    console.log(`initHandsUpInfo - liveSeq[${lSeq}], teacherSeq[${tSeq}], userSeq[${uSeq}], activeYn[${activeYn}]`);

    let store = window.hiclasstv.store;

    handsUpClientInfo.liveSeq = lSeq;
    handsUpClientInfo.teacherSeq = tSeq;
    handsUpClientInfo.userSeq = uSeq;
    handsUpClientInfo.activeYn = activeYn;
    // handsUpClientInfo.viewKind = vKind;

    // android webview에서 타이밍 이슈로 값이 없는 경우를 위해
    if (handsUpClientInfo.userSeq <= -1) {
        const { user } = store.getState();
        const { userSeq } = user;
        console.log("initHandsUpInfo - userSeq[" + userSeq + "]");
        handsUpClientInfo.userSeq = userSeq;
    }

    if (handsUpClientInfo.liveSeq <= -1) {
        const { live } = store.getState();
        const { performLiveInfo } = live;
        const liveSeq = performLiveInfo.liveSeq;
        const teacherSeq = performLiveInfo.teacher_info.userSeq;
        console.log("initHandsUpInfo - liveSeq[" + liveSeq + "], teacherSeq[" + teacherSeq + "]");
        handsUpClientInfo.liveSeq = liveSeq;
        handsUpClientInfo.teacherSeq = teacherSeq;
    }

    handsUpClientInfo.imageSendFileName = `img_${uSeq}.jpg`;

    /** init handsup default values */
    handsUpClientInfo.isMicDisable = false;
    handsUpClientInfo.isMuteMode = true;
    handsUpClientInfo.isMicOn = false;
    handsUpClientInfo.isP2PMode = false;
    handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
    handsUpClientInfo.topKind = stTopKind.All_Client;               // "all-client"
    handsUpClientInfo.isSmartTVMode = false;
    handsUpClientInfo.isSelectedAudio = false;

    handsUpClientInfo.audioInputInfo = {
        defaultAudioInput: { deviceId: null, groupId: null, label: null },
        currentAudioInput: { deviceId: null, groupId: null, label: null }
    };

    if (navigator) {
        if (navigator.userAgent) {
            let userAgent = navigator.userAgent.toLowerCase();
            console.log("initHandsUpInfo - userAgent[" + userAgent + "]");

            if (userAgent.indexOf("mobile") > -1 || userAgent.indexOf("iphone") > -1 || userAgent.indexOf("android") > -1
                || ((userAgent.indexOf("windows") > -1 || userAgent.indexOf("cros") > -1 || userAgent.indexOf("macintosh") > -1) && navigator.maxTouchPoints > 2)) {
                handsUpClientInfo.isMobile = true;
            }

            let isAndroid = userAgent.indexOf("android") > -1;
            if (isAndroid) {
                handsUpClientInfo.isAndroidDevice = true;
            }

            let isPentalkAndr = isAndroidWebView();
            if (isPentalkAndr) {
                console.log("Android WebView 페이지 로드 완료");
                handsUpClientInfo.isAndroidDevice = true;
            }

            // 20250701 Pentalk WiFi 버전과 맞추기 위해 ChromeBook 구분
            let isChromeOS = userAgent.indexOf("cros") > -1;
            if (isChromeOS) {
                handsUpClientInfo.isChromeOSBook = true;
            }

            // 20250701 Pentalk WiFi 버전과 맞추기 위해 WhaleBook 구분
            let isWhaleBrowser = userAgent.indexOf("whale") > -1;
            if (isChromeOS && isWhaleBrowser) {
                handsUpClientInfo.isWhaleBook = true;
            }

            /* // 20250701 Pbl 모드 브라우저 구분 ... by hjkim
            let isForPblBrowser = userAgent.indexOf("pbl") > -1;
            if (isForPblBrowser) {
                handsUpClientInfo.isForPblModeBrowser = true;
                handsUpClientInfo.isForPblMode = true;
            } */

            console.log("initHandsUpInfo - isMobile[" + handsUpClientInfo.isMobile + "]");
            console.log("initHandsUpInfo - isAndroidDevice[" + handsUpClientInfo.isAndroidDevice + "]");
            console.log("initHandsUpInfo - isPentalkAndr[" + isPentalkAndr + "]");
        }

        // 20250707 Pbl 모드가 아닐 경우에만 이벤트 등록
        if (!getIsForPblModeBrowser()) {
            if (navigator.mediaDevices) {
                window.isHandsUpInit = false;
                if (!isIOSWebView()) {
                    navigator.mediaDevices.ondevicechange = e => { 
                        // if (isIOSWebView()) {
                        //     const now = Date.now();
                        //     if (now - lastUpdateMediaDevicesTime < 300) {
                        //         console.log("[iOS] Duplicate devicehcnage event blocked");
                        //         return;
                        //     }
                        //     lastUpdateMediaDevicesTime = now;
                        // }

                        updateMediaDevices();
                        // testUpdate();
                    };
                }
            }
        }
    }

    await initHandsUpConsumeInfo(); // 혹시 모를... data clear...

    // Audio Mixer 초기화 메서드 호출 방식으로 수정 ... by hjkim 20251016
    initAudioMerger();
}

/**
 * audioCtx, audioMerger, destination 등 Audio Mixer를 위한
 * 변수들을 초기화하는 메서드.
 * 
 * @since 2025-10-16.
 * @lastModified 2025-11-06.
 * @changelog
 * Note: 업데이트 기록
 * 
 *     • 2025-11-06:
 *       ￮ 마이크/시스템 오디오 볼륨 설정 방식을 동적 밸런싱(Ducking)으로 설정하도록 수정
 *       ￮ by hjkim
 *     • 2025-10-16:
 *       ￮ 메서드 최초 구현
 *       ￮ audioMerger & destination 초기화 작업을 별도의 메서드로 분리 및 호출하는 방식으로 수정
 *       ￮ by hjkim
 *     • 2025-09-24:
 *       ￮ iOS device가 아닌 경우도 확인하도록 if 조건문 수정
 *       ￮ 최종적으로 android & iOS device가 아닌 경우에만 audioMerger & destination 초기화하도록 수정
 *       ￮ by ykhan
 *     • 2025-09-09:
 *       ￮ android device가 아닌 경우에만 audioMerger & destination 초기화하도록 수정
 *       ￮ by hjkim
 */
const initAudioMerger = () => {
    // android & iOS device가 아닌 경우에만 audioMerger & destination 초기화하도록 수정 ... by hjkim 20250909 & by ykhan 20250924
    if (!isAndroidWebView() && !isIOSWebView()) {
        // 레거시 브라우저를 위해
        const AudioContext = window.AudioContext || window.webkitAudioContext;

        /** Audio Mixer - Audio Context 초기화 */
        handsUpClientInfo.audioCtx = new AudioContext();

        /** Audio Mixer - GainNode 생성 */
        // 마이크용 GainNode
        handsUpClientInfo.micGainNode = handsUpClientInfo.audioCtx.createGain();
        // 20261001 장치 변경 등으로 mixer를 다시 만들더라도 사용자가 제외한 마이크 입력은 무음으로 유지한다.
        handsUpClientInfo.micGainNode.gain.value = handsUpClientInfo.microphoneIncluded ? handsUpClientInfo.micGainValue : 0;

        // 시스템 오디오용 GainNode
        handsUpClientInfo.systemGainNode = handsUpClientInfo.audioCtx.createGain();
        // 20261001 장치 변경 등으로 mixer를 다시 만들더라도 사용자가 제외한 시스템 소리 입력은 무음으로 유지한다.
        handsUpClientInfo.systemGainNode.gain.value = handsUpClientInfo.systemAudioIncluded ? handsUpClientInfo.systemGainValue : 0;

        /** Audio Mixer - Channel Merger 생성 */
        handsUpClientInfo.audioMerger = handsUpClientInfo.audioCtx.createChannelMerger(2);

        /** Audio Mixer - Destination 생성 */
        handsUpClientInfo.destination = handsUpClientInfo.audioCtx.createMediaStreamDestination();

        /** Audio Mixer - 연결: GainNode → ChannelMerger → Destination */
        handsUpClientInfo.micGainNode.connect(handsUpClientInfo.audioMerger, 0, 0);
        handsUpClientInfo.systemGainNode.connect(handsUpClientInfo.audioMerger, 0, 1);
        handsUpClientInfo.audioMerger.connect(handsUpClientInfo.destination);

        console.log("✅ Audio Mixer initialized with gain control");
        console.log("   - Mic gain:", handsUpClientInfo.micGainNode.gain.value);
        console.log("   - System gain:", handsUpClientInfo.systemGainNode.gain.value);
    }
}

/**
 * 마이크와 시스템 오디오를 동시에 조절하는 메서드.
 * - 마이크와 시스템 오디오 볼륨을 부드럽게 조절한다.
 * 
 * @param {Number} micGain - 마이크 게인 노드 레벨 조절 값
 * @param {Number} systemGain - 시스템 오디오 게인 노드 조절 값
 * @param {Number} duration - 변하는 데 걸리는 시간
 * @since 2025-11-11.
 */
const fadeAudioLevels = (micGain, systemGain, duration = 0.3) => {
    if (!handsUpClientInfo.audioCtx) return;

    const currentTime = handsUpClientInfo.audioCtx.currentTime;

    // 마이크 볼륨 조절
    if (handsUpClientInfo.micGainNode) {
        const micNode = handsUpClientInfo.micGainNode;
        micNode.gain.cancelScheduledValues(currentTime);
        micNode.gain.setValueAtTime(micNode.gain.value, currentTime);
        micNode.gain.linearRampToValueAtTime(micGain, currentTime + duration);
    }

    // 시스템 오디오 볼륨 조절
    if (handsUpClientInfo.systemGainNode) {
        const sysNode = handsUpClientInfo.systemGainNode;
        sysNode.gain.cancelScheduledValues(currentTime);
        sysNode.gain.setValueAtTime(sysNode.gain.value, currentTime);
        sysNode.gain.linearRampToValueAtTime(systemGain, currentTime + duration);
    }

    console.log(`🎚️ Audio levels: Mic ${(micGain * 100).toFixed(0)}% | System ${(systemGain * 100).toFixed(0)}%`);
}

// 20261001 입력 제외 상태에서도 ducking이 해당 gain을 다시 올리지 않도록 최종 mixed audio gain을 계산한다.
const applyAudioSourceSettingsToMixer = (duration = handsUpClientInfo.duckingFadeTime) => {
    const micGain = handsUpClientInfo.microphoneIncluded
        ? (handsUpClientInfo.isDuckingEnabled
            ? (handsUpClientInfo.isSpeaking ? handsUpClientInfo.micGainWhenSpeaking : handsUpClientInfo.micGainWhenSilent)
            : handsUpClientInfo.micGainValue)
        : 0;
    const systemGain = handsUpClientInfo.systemAudioIncluded
        ? (handsUpClientInfo.isDuckingEnabled
            ? (handsUpClientInfo.isSpeaking ? handsUpClientInfo.systemGainWhenSpeaking : handsUpClientInfo.systemGainWhenSilent)
            : handsUpClientInfo.systemGainValue)
        : 0;

    fadeAudioLevels(micGain, systemGain, duration);
}

/**
 * 음성 감지 및 밸런싱 메서드.
 * 
 * @param {Number} level - 보이스 레벨
 * @since 2025-11-11.
 */
const checkVoiceActivityAndBalance = async (level) => {
    if (!handsUpClientInfo.isDuckingEnabled) return;
    if (!handsUpClientInfo.micGainNode || !handsUpClientInfo.systemGainNode) return;

    const isVoiceDetected = level > handsUpClientInfo.voiceThreshold;
    console.log("checkVoiceActivityAndBalance - isVoiceDetected[", isVoiceDetected, "], level[", level, "], voiceThreshold[", handsUpClientInfo.voiceThreshold, "]");

    if (isVoiceDetected) {
        // 음성 감지됨 - 말하는 중
        if (!handsUpClientInfo.isSpeaking) {
            handsUpClientInfo.isSpeaking = true;

            // 말할 때: 마이크 올리고, 시스템 약간 줄임
            applyAudioSourceSettingsToMixer(handsUpClientInfo.duckingFadeTime);

            console.log(`🎤 Speaking: Mic UP (${(handsUpClientInfo.micGainWhenSpeaking * 100).toFixed(0)}%), System DOWN (${(handsUpClientInfo.systemGainWhenSpeaking * 100).toFixed(0)}%)`);
        }

        // 타이머 리셋
        await clearVoicDetectionTimeout();

        // 침묵 감지 타이머
        handsUpClientInfo.voiceDetectionTimeout = setTimeout(() => {
            handsUpClientInfo.isSpeaking = false;

            // 침묵 시: 마이크 줄이고, 시스템 올림
            applyAudioSourceSettingsToMixer(handsUpClientInfo.duckingFadeTime);

            console.log(`🔇 Silent: Mic DOWN (${(handsUpClientInfo.micGainWhenSilent * 100).toFixed(0)}%), System UP (${(handsUpClientInfo.systemGainWhenSilent * 100).toFixed(0)}%)`);
        }, handsUpClientInfo.voiceSilenceDelay);
    }
}

/**
 * 동적 밸런싱 활성화/비활성화 여부를 설정하는 메서드.
 * 
 * @param {Boolean} enabled - 활성화/비활성화 여부
 * @since 2025-11-11.
 */
export const setDynamicBalancingEnabled = (enabled) => {
    handsUpClientInfo.isDuckingEnabled = enabled;
    console.log(`🎚️ Dynamic balancing ${enabled ? 'enabled' : 'disabled'}`);

    // 20261001 밸런싱 전환 뒤에도 사용자가 제외한 입력은 무음 상태를 유지한다.
    applyAudioSourceSettingsToMixer(0.5);
}

/**
 * 밸런싱 설정 변경 메서드.
 * 
 * @param {Object} config - 설정값 객체
 * @since 2025-11-11.
 */
export const configureBalancing = (config = {}) => {
    if (config.voiceThreshold !== undefined) {
        handsUpClientInfo.voiceThreshold = Math.max(0.01, Math.min(0.1, config.voiceThreshold));
    }

    // 말할 때 설정
    if (config.micGainWhenSpeaking !== undefined) {
        handsUpClientInfo.micGainWhenSpeaking = Math.max(0.1, Math.min(1.0, config.micGainWhenSpeaking));
    }
    if (config.systemGainWhenSpeaking !== undefined) {
        handsUpClientInfo.systemGainWhenSpeaking = Math.max(0.1, Math.min(1.0, config.systemGainWhenSpeaking));
    }

    // 침묵 시 설정
    if (config.micGainWhenSilent !== undefined) {
        handsUpClientInfo.micGainWhenSilent = Math.max(0.0, Math.min(1.0, config.micGainWhenSilent));
    }
    if (config.systemGainWhenSilent !== undefined) {
        handsUpClientInfo.systemGainWhenSilent = Math.max(0.1, Math.min(1.0, config.systemGainWhenSilent));
    }

    if (config.duckingFadeTime !== undefined) {
        handsUpClientInfo.duckingFadeTime = Math.max(0.1, Math.min(1.0, config.duckingFadeTime));
    }
    if (config.voiceSilenceDelay !== undefined) {
        handsUpClientInfo.voiceSilenceDelay = Math.max(100, Math.min(2000, config.voiceSilenceDelay));
    }

    console.log("🎚️ Balancing config updated:", {
        voiceThreshold: handsUpClientInfo.voiceThreshold,
        speaking: {
            mic: handsUpClientInfo.micGainWhenSpeaking,
            system: handsUpClientInfo.systemGainWhenSpeaking
        },
        silent: {
            mic: handsUpClientInfo.micGainWhenSilent,
            system: handsUpClientInfo.systemGainWhenSilent
        },
        fadeTime: handsUpClientInfo.duckingFadeTime,
        silenceDelay: handsUpClientInfo.voiceSilenceDelay
    });
}

/**
 * 현재 상태 확인 메서드.
 * 
 * @returns {Object} 현재 상태 객체
 * @since 2025-11-11.
 */
export const getBalancingStatus = () => {
    return {
        enabled: handsUpClientInfo.isDuckingEnabled,
        isSpeaking: handsUpClientInfo.isSpeaking,
        currentMicGain: handsUpClientInfo.micGainNode?.gain.value || 0,
        currentSystemGain: handsUpClientInfo.systemGainNode?.gain.value || 0,
        micLevel: handsUpClientInfo.audioSoundMeter?.instant || 0,
        voiceThreshold: handsUpClientInfo.voiceThreshold
    };
}

/**
 * 일반 Pro PC mixed audio track에 포함할 입력 상태를 반환한다.
 * Android/iOS는 각 앱 Bridge의 결과를 사용한다.
 *
 * @returns {Object} 현재 마이크/시스템 소리 포함 상태
 * @since 2026-10-01.
 */
export const getAudioSourceSettings = () => ({
    microphoneIncluded: handsUpClientInfo.microphoneIncluded,
    systemAudioIncluded: handsUpClientInfo.systemAudioIncluded,
    supportedSources: (!isAndroidWebView() && !isIOSWebView()) ? ["microphone", "system"] : []
});

/**
 * 일반 Pro PC의 기존 mixed audio track을 유지한 채 입력 포함 여부만 변경한다.
 *
 * @param {Object} settings 마이크/시스템 소리 포함 여부
 * @returns {Object} 적용 결과
 * @since 2026-10-01.
 */
export const setAudioSourceSettings = (settings = {}) => {
    if (isAndroidWebView() || isIOSWebView() || !handsUpClientInfo.destination) {
        return { success: false, reason: "native_bridge_required" };
    }

    if (typeof settings.microphoneIncluded === "boolean") {
        handsUpClientInfo.microphoneIncluded = settings.microphoneIncluded;
    }
    if (typeof settings.systemAudioIncluded === "boolean") {
        handsUpClientInfo.systemAudioIncluded = settings.systemAudioIncluded;
    }

    // 20261001 producer/track을 재생성하지 않고 기존 mixer 입력 gain만 즉시 반영한다.
    applyAudioSourceSettingsToMixer();
    return { success: true, ...getAudioSourceSettings() };
}

/**
 * 핸즈업용 시스템 마이크 스트림 준비를 위한 메서드.
 * 
 * @param {Boolean} isHandsUpInit - 핸즈업 최초 접속 여부
 * @returns {Promise<Boolean>} - 핸즈업 시스템 마이크 스트림 준비 여부
 */
export const initHandsUpMic = async (isHandsUpInit) => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log(`initHandsUpMic - isHandsUpInit[${isHandsUpInit}], isMicOn[${handsUpClientInfo.isMicOn}], activeYn[${handsUpClientInfo.activeYn}]`);
            // window.isHandsUpInit = isHandsUpInit;
            if (handsUpClientInfo.activeYn === "Y") {
                if (isHandsUpInit) {
                    // 20250915 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 마이크 produce 하도록 수정 ... by hjkim
                    // 20251105 ... 안드로이드가 아닌 경우에는 기존 코드대로 동작(조건문 오류 수정) ... by hjkim
                    // 20260220 ... ios가 아닌 경우에 기존 코드대로 동작 ... by ykhan
                    // 20251105 ... camera 모드인 경우에는 접속 기기 값과 상관없이 기존 코드대로 동작 ... by hjkim
                    if (handsUpClientInfo.viewKind === "CAMERA") { // 기존 코드 동작
                        console.log("case 1:) initHandsUpMic - all device & camera mode ...");

                        // 20260313 isHandsUpInit 값이 true인 경우 기본값 설정 그대로 사용하도록 주석 처리 ... by hjkim
                        // if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;
                        await setUpMicAudioStream(isHandsUpInit);
                    } else {
                        if (isAndroidWebView()) {
                            console.log("case 2-1:) initHandsUpMic - android webview device & screen mode ...");
                            console.log("don't request mic stream...");

                            /* // 20260310 만약 isHandsUpInit 에서 micEnable 수신 시 마이크를 켜야한다면 ... by hjkim
                            xmitCmd_AndroidMessage("ct_MicOn", enTokenCMD.NULL);

                            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                            } */
                        } else if (isIOSWebView()) {
                            console.log("case 2-2:) initHandsUpMic - ios webview device & screen mode ...");
                            console.log("don't request mic stream...");

                            /* // 20260310 만약 isHandsUpInit 에서 micEnable 수신 시 마이크를 켜야한다면 ... by hjkim
                            xmitCmd_IosMessage("ct_MicOn", enTokenCMD.NULL);

                            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                            } */
                        } else { // 기존 코드 동작
                            console.log("case 2-3:) initHandsUpMic - not android/ios webview device & screen mode ...");

                            // 20260313 isHandsUpInit 값이 true인 경우 기본값 설정 그대로 사용하도록 주석 처리 ... by hjkim
                            // if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;
                            await setUpMicAudioStream(isHandsUpInit);
                        }
                    }
                } else {
                    // 20260310 수정 코드 ... by hjkim
                    // 20251105 ... 안드로이드가 아닌 경우에는 기존 프로세스대로 동작 ... by hjkim 20251105
                    // 20251105 ... camera 모드인 경우에는 devVersion 값과 상관없이 기존 코드대로 동작 ... by hjkim
                    console.log("initHandsUpMic - isMicOn[", handsUpClientInfo.isMicOn, "], isMuteMode[", handsUpClientInfo.isMuteMode, "]");
                    if (handsUpClientInfo.viewKind === "CAMERA") {  // 기존 코드 동작
                        if (handsUpClientInfo.isMicOn) { // ondevicechange event 발생하면 mic 사용 중이었던 경우에만 처리하기 위해... by hjkim 20220315
                            console.log("case 3-1:) initHandsUpMic - all device & camera mode ... isMicOn is true.");

                            await clearMicVolumeSendProc();
                            await clearMicStreamSource(); // 마이크 스트림 소스 정리 추가 ... by hjkim
                        } else {
                            // 20251030 ... 크롬 업데이트 이슈로 인해 임시로 isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                            // handsUpClientInfo.isMuteMode = true; // 대신 mute 모드로 설정(?)
                            console.log("(case 3-2:) initHandsUpMic - all device & camera mode ... isMicOn is false.");
                        }

                        await setUpMicAudioStream(isHandsUpInit);
                    } else {
                        if (isAndroidWebView()) {
                            console.log("case 4-1:) initHandsUpMic - android webview device & screen mode ...");
                            console.log("don't request mic stream...");

                            /* // 20260310 만약 이벤트 발생 시 마이크를 켜야한다면 ... by hjkim
                            xmitCmd_AndroidMessage("ct_MicOn", enTokenCMD.NULL);

                            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                            } */
                        } else if (isIOSWebView()) {
                            console.log("case 4-2:) initHandsUpMic - ios webview device & screen mode ...");
                            console.log("don't request mic stream...");

                            /* // 20260310 만약 이벤트 발생 시 마이크를 켜야한다면 ... by hjkim
                            xmitCmd_IosMessage("ct_MicOn", enTokenCMD.NULL);

                            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                            } */
                        } else { // 기존 코드 동작
                            if (handsUpClientInfo.isMicOn) { // ondevicechange event 발생하면 mic 사용 중이었던 경우에만 처리하기 위해... by hjkim 20220315
                                console.log("case 4-3:) initHandsUpMic - all device & camera mode ... isMicOn is true.");

                                await clearMicVolumeSendProc();
                                await clearMicStreamSource(); // 마이크 스트림 소스 정리 추가 ... by hjkim
                            } else {
                                // 20251030 ... 크롬 업데이트 이슈로 인해 임시로 isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                                // handsUpClientInfo.isMuteMode = true; // 대신 mute 모드로 설정(?)
                                console.log("(case 4-4:) initHandsUpMic - all device & camera mode ... isMicOn is false.");
                            }

                            await setUpMicAudioStream(isHandsUpInit);
                        }
                    }
                }

                resolve(true);
            } else {
                resolve(false);
            }
        } catch (err) {
            handleDOMException("initHandsUpMic() - isHandsUpInit[" + isHandsUpInit + "]", err);
            resolve(false);
        }

        // 20260310 기존 코드 주석 처리
        /* try {
            console.log(`initHandsUpMic - isHandsUpInit[${isHandsUpInit}], isMicOn[${handsUpClientInfo.isMicOn}], activeYn[${handsUpClientInfo.activeYn}]`);
            // window.isHandsUpInit = isHandsUpInit;
            if (handsUpClientInfo.activeYn === "Y") {
                if (isHandsUpInit) {
                    // 20250915 ... by hjkim
                    // 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 마이크 produce 하도록 수정
                    // 20251105 ... 안드로이드가 아닌 경우에는 기존 코드대로 동작(조건문 오류 수정) ... by hjkim
                    // 20260220 ... ios가 아닌 경우에 기존 코드대로 동작 ... by ykhan
                    if (!getIsAndroidDevice() && !isAndroidWebView() && !isIOSWebView()) {
                        console.log("not android & ios device ...");

                        if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;
                        await setUpMicAudioStream(isHandsUpInit);

                        // if (!handsUpClientInfo.isMicOn) {
                        //     handsUpClientInfo.isMicOn = true;
                        //     await setUpMicAudioStream(isHandsUpInit);
                        // }
                    } else {
                        // 20251105 ... camera 모드인 경우에는 devVersion 값과 상관없이 기존 코드대로 동작 ... by hjkim
                        if (handsUpClientInfo.viewKind === "CAMERA") {
                            console.log("android/ios device & camera mode ...");

                            if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;
                            await setUpMicAudioStream(isHandsUpInit);
                        } else { // viewKind === "SCREEN"
                            // 20260202 ... 안드로이드에서 screen 모드인 경우, android webview인지 여부 값에 따라 구분하도록 수정 ... by hjkim
                            // 20260220 ... ios에서 screen 모드인 경우, ios webview인지 여부 값에 따라 구분하도록 수정 ... by ykhan
                            // if (!isDevVersion()) { // 이거 활성화 할 경우 영경이한테 알려주기.. ios에서 영향을 받음 ... by ykhan 20260220
                            if (!isAndroidWebView() && !isIOSWebView()) {
                                // 20251105 ... devVersion이 아니고, screen 모드인 경우, 기존 코드대로 동작하도록 수정 ... by hjkim
                                console.log("[not devVersion] ... android/ios device & screen mode ...");

                                if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;
                                await setUpMicAudioStream(isHandsUpInit);
                            } else {
                                // 20251103 ... devVersion이고, screen 모드인 경우, 안드로이드에서는 마이크 produce 하지 않도록 수정 ... by hjkim
                                console.log("[devVersion] ... android/ios device & screen mode ...");
                                console.log("don't request mic stream...");
                            }
                        }
                    }
                } else {
                    // 수정 코드 ... by hjkim 20251105
                    // 20251105 ... 안드로이드가 아닌 경우에는 기존 프로세스대로 동작 ... by hjkim 20251105
                    if (!getIsAndroidDevice() && !isAndroidWebView() && !isIOSWebView()) {
                        if (handsUpClientInfo.isMicOn) { // ondevicechange event 발생하면 mic 사용 중이었던 경우에만 처리하기 위해... by hjkim 20220315
                            console.log("not android/ios device ...");

                            await clearMicVolumeSendProc();
                            await clearMicStreamSource(); // 마이크 스트림 소스 정리 추가 ... by hjkim
                        } else {
                            // 20251030 ... 크롬 업데이트 이슈로 인해 임시로 isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                            // handsUpClientInfo.isMuteMode = true; // 대신 mute 모드로 설정(?)
                            console.log("(2) not android/ios device ...");
                        }

                        await setUpMicAudioStream(isHandsUpInit);
                    } else {
                        if (handsUpClientInfo.isMicOn) { // ondevicechange event 발생하면 mic 사용 중이었던 경우에만 처리하기 위해... by hjkim 20220315
                            // 20251105 ... camera 모드인 경우에는 devVersion 값과 상관없이 기존 코드대로 동작 ... by hjkim
                            if (handsUpClientInfo.viewKind === "CAMERA") {
                                console.log("(2) android/ios device & camera mode ...");
                                await clearMicVolumeSendProc();

                                // 20251105 ... 안드로이드인 경우에는 시스템 오디오 스트림이 당연히 없으므로 sendAudioStream을 기존 코드처럼 정리한다 ... by hjkim
                                if (handsUpClientInfo.sendAudioStream !== undefined && handsUpClientInfo.sendAudioStream !== null) {
                                    handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                                        track.stop();
                                    });

                                    handsUpClientInfo.sendAudioStream = null;
                                    handsUpClientInfo.hasMicAudio = false;
                                }

                                await setUpMicAudioStream(isHandsUpInit);
                            } else { // viewKind === "SCREEN"
                                // 20260202 ... 안드로이드에서 screen 모드인 경우, android webview인지 여부 값에 따라 구분하도록 수정 ... by hjkim
                                // if (!isDevVersion()) {
                                if (!isAndroidWebView() && !isIOSWebView()) {
                                    // 20251105 ... devVersion이 아니고, screen 모드인 경우, 기존 코드대로 동작하도록 수정 ... by hjkim
                                    console.log("(2) [not devVersion] ... android/ios device & screen mode ...");
                                    await clearMicVolumeSendProc();

                                    // 20251105 ... 안드로이드인 경우에는 시스템 오디오 스트림이 당연히 없으므로 sendAudioStream을 기존 코드처럼 정리한다 ... by hjkim
                                    if (handsUpClientInfo.sendAudioStream !== undefined && handsUpClientInfo.sendAudioStream !== null) {
                                        handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                                            track.stop();
                                        });

                                        handsUpClientInfo.sendAudioStream = null;
                                        handsUpClientInfo.hasMicAudio = false;
                                    }

                                    await setUpMicAudioStream(isHandsUpInit);
                                } else {
                                    // 20251103 ... devVersion이고, screen 모드인 경우, 안드로이드에서는 마이크 produce 하지 않도록 수정 ... by hjkim
                                    console.log("(2) [devVersion] ... android/ios device & screen mode ...");
                                    console.log("(2) don't request mic stream...");
                                }
                            }
                        } else {
                            // 20251105 ... camera 모드인 경우에는 devVersion 값과 상관없이 기존 코드대로 동작 ... by hjkim
                            if (handsUpClientInfo.viewKind === "CAMERA") {
                                // 20251030 ... 크롬 업데이트 이슈로 인해 임시로 isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                                // handsUpClientInfo.isMuteMode = true; // 대신 mute 모드로 설정(?)
                                console.log("(3) android device & camera mode ...");

                                await setUpMicAudioStream(isHandsUpInit);
                            } else { // viewKind === "SCREEN"
                                // 20260202 ... 안드로이드에서 screen 모드인 경우, android webview인지 여부 값에 따라 구분하도록 수정 ... by hjkim
                                // if (!isDevVersion()) {
                                if (!isAndroidWebView() && !isIOSWebView()) {
                                    // 20251105 ... devVersion이 아니고, screen 모드인 경우, 기존 코드대로 동작하도록 수정 ... by hjkim
                                    console.log("(3) [not devVersion] ... android device & screen mode ...");

                                    await setUpMicAudioStream(isHandsUpInit);
                                } else {
                                    // 20251103 ... devVersion이고, screen 모드인 경우, 안드로이드에서는 마이크 produce 하지 않도록 수정 ... by hjkim
                                    console.log("(3) [devVersion] ... android device & screen mode ...");
                                    console.log("(3) don't request mic stream...");
                                }
                            }
                        }
                    }
                }

                resolve(true);
            } else {
                resolve(false);
            }
        } catch (err) {
            handleDOMException("initHandsUpMic() - isHandsUpInit[" + isHandsUpInit + "]", err);
            resolve(false);
        } */
    });
}

/**
 * sound meter 와 audio stream 연결 및 volume catch process 시작
 */
const initHandsUpMicVolumeSendProc = () => {
    // console.log("initHandsUpMicVolumeSendProc() --- 000");

    // ✅ 측정 대상을 GainNode 이전 원본 스트림으로 변경
    // rawAudioStream: setUpMicAudioStream()에서 저장한 마이크 원본 스트림
    // sendAudioStream: GainNode → ChannelMerger → Destination을 거친 최종 스트림 (측정에 사용 불가)
    const targetStream = handsUpClientInfo.rawAudioStream || handsUpClientInfo.sendAudioStream;
    //                   ↑ 우선 rawAudioStream 사용, 없으면 기존 방식 fallback

    if (targetStream instanceof MediaStream) {
        // 레거시 브라우저를 위해
        const AudioContext = window.AudioContext || window.webkitAudioContext;

        handsUpClientInfo.audioContext = new AudioContext();
        handsUpClientInfo.audioSoundMeter = new SoundMeter(handsUpClientInfo.audioContext);

        handsUpClientInfo.audioSoundMeter.connectToSource(targetStream, function (e) {
            if (e) {
                alert(e);
                return;
            }

            startHandsUpMicVolumeSendProc();
        });
    }
}

/**
 * video element src 설정 및 video element 캡처 process 시작
 */
const initVideoStreamImageSendProc = () => {
    if (handsUpClientInfo.sendVideoStream instanceof MediaStream) {
        setUpImageSendSize(handsUpClientInfo.sendVideoStream.getVideoTracks()[0].getSettings());

        handsUpClientInfo.videoEl.srcObject = handsUpClientInfo.sendVideoStream;
        handsUpClientInfo.videoEl.play().catch(err => {
            if (err.name !== "AbortError") handleDOMException("initVideoStreamImageSendProc() - videoEl.play()", err);
        });

        if (handsUpClientInfo.activeYn === "Y") {
            startVideoStreamImageSendProc();
        }
    }
}

/**
 * myCam video element src 설정 및 play 시작
 * 
 * @param {MediaStream} stream 
 */
const initMyCamDisplayProc = (stream) => {
    if (stream instanceof MediaStream) {
        // setUpImageSendSize(stream.getVideoTracks()[0].getSettings());

        handsUpClientInfo.myCamEl.srcObject = stream;
        handsUpClientInfo.myCamEl.play();
    }
}

/**
 * hands up send image size 세팅
 * 
 * @param {MediaTrackSettings} settings 
 */
const setUpImageSendSize = (settings) => {
    if (settings !== undefined && settings !== null) {
        let isPortrait = false;
        let div = document.getElementById("live-area");

        if (div !== undefined && div !== null) {
            if (div.classList.contains("ios")) {
                if (window.screen !== undefined && window.screen !== null) {
                    if (window.innerWidth < window.innerHeight) {
                        isPortrait = true;
                    }
                }
            } else {
                if (window.screen.orientation.type === "portrait-primary" || window.screen.orientation.type === "portrait-secondary") {
                    isPortrait = true;
                }
            }
        }

        if (ConstData.IS_LOCAL_VERSION) { // local version에서는 더 자주 보낸다... by hjkim 20220622
            if (isPortrait) {
                imageSendWidth = 135;
                imageSendHeight = 240;
            } else {
                imageSendWidth = 240;
                imageSendHeight = 135;
            }

            handsUpClientInfo.imageSendTime = ctTimerLv.LV_HIGH_MID;
        } else {
            if (isPortrait) {
                imageSendWidth = 135;
                imageSendHeight = 240;
            } else {
                imageSendWidth = 240;
                imageSendHeight = 135;
            }

            handsUpClientInfo.imageSendTime = ctTimerLv.LV_DEFAULT;
        }

        // console.log("setting info => ", `width[${settings.width}], height[${settings.height}], frameRate[${settings.frameRate}]`);
        console.log("settings info => ", settings);
        console.log(`setUpImageSendSize - imageSendWidth[${imageSendWidth}], imageSendHeight[${imageSendHeight}], imageSendTime[${handsUpClientInfo.imageSendTime}]`);

        if (handsUpClientInfo.canvasEl === null) {
            handsUpClientInfo.canvasEl = window.canvas = document.createElement("canvas");
            handsUpClientInfo.canvasEl.width = imageSendWidth;
            handsUpClientInfo.canvasEl.height = imageSendHeight;
            handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
        } else {
            handsUpClientInfo.canvasEl.width = imageSendWidth;
            handsUpClientInfo.canvasEl.height = imageSendHeight;
            handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
        }
    }
}

/**
 * change hands up send image size
 * 
 * @param {Boolean} isVerticalMode 
 */
export const changeImageSize = (isVerticalMode) => {
    // alert(isVerticalMode);
    if (isVerticalMode) {
        if (ConstData.IS_LOCAL_VERSION) {
            imageSendWidth = 135;
            imageSendHeight = 240;
        } else {
            imageSendWidth = 135;
            imageSendHeight = 240;
        }
    } else {
        if (ConstData.IS_LOCAL_VERSION) {
            imageSendWidth = 240;
            imageSendHeight = 135;
        } else {
            imageSendWidth = 240;
            imageSendHeight = 135;
        }
    }

    if (handsUpClientInfo.canvasEl === null) {
        handsUpClientInfo.canvasEl = window.canvas = document.createElement("canvas");
        handsUpClientInfo.canvasEl.width = imageSendWidth;
        handsUpClientInfo.canvasEl.height = imageSendHeight;
        handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
    } else {
        handsUpClientInfo.canvasEl.width = imageSendWidth;
        handsUpClientInfo.canvasEl.height = imageSendHeight;
        handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
    }
}

/**
 * 500ms 마다 mic sound level 체크
 */
const startHandsUpMicVolumeSendProc = () => {
    if (handsUpClientInfo.micVolumeSendProc && (handsUpClientInfo.micVolumeSendProc.current === undefined || handsUpClientInfo.micVolumeSendProc.current === null)) {
        handsUpClientInfo.micVolumeSendProc.current = setInterval(() => {
            try {
                if (handsUpClientInfo.audioSoundMeter) {
                    let curLevel = handsUpClientInfo.audioSoundMeter.instant.toFixed(2);

                    // ✅ 동적 밸런싱 체크
                    checkVoiceActivityAndBalance(parseFloat(curLevel));

                    // console.log(`micVolumeSendProc - curLevel[${curLevel}], soundLevel[${handsUpClientInfo.soundLevel}]`);
                    if (curLevel !== handsUpClientInfo.soundLevel) {
                        if (0 <= curLevel && curLevel <= 0.05) { // speak 이미지 갱신 문제로 case 수정 by hjkim 20210104
                            sendMicVolumeLevel(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, ConstCode.LIVE_SOUND_LEVEL_1);
                        } else if (0.05 < curLevel && curLevel <= 0.1) {
                            sendMicVolumeLevel(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, ConstCode.LIVE_SOUND_LEVEL_2);
                        } else if (0.1 < curLevel && curLevel <= 0.15) {
                            sendMicVolumeLevel(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, ConstCode.LIVE_SOUND_LEVEL_3);
                        } else if (0.15 < curLevel && curLevel <= 0.2) {
                            sendMicVolumeLevel(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, ConstCode.LIVE_SOUND_LEVEL_4);
                        } else if (0.25 < curLevel && curLevel <= 0.3) {
                            sendMicVolumeLevel(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, ConstCode.LIVE_SOUND_LEVEL_5);
                        }

                        handsUpClientInfo.soundLevel = curLevel;

                        // 학생이 말하는 동안 학생 스피커에 선생님 목소리 작게 들리게 하기 위해 ... by hjkim 20231114
                        // 우선은 주석처리.. 나중에 의견나오면 다시 살리기 ... by hjkim 20231114
                        /* if (handsUpClientInfo.soundLevel > 0) {
                            controlSpeakerVolume(0.3);
                        } else {
                            controlSpeakerVolume(1.0);
                        } */
                    }
                }
            } catch (err) {
                console.log("startHandsUpMicVolumeSendProc - err => ", err);
            }
        }, 500);
    }
}

/**
 * handsUpClientInfo.imageSendTime 마다 video element 캡처
 */
const startVideoStreamImageSendProc = async () => {
    await clearImgSendProc(); // test용 clear... 

    imageSendWidth = 240;
    imageSendHeight = 135;

    let div = document.getElementById("live-area");
    if (div !== undefined && div !== null) {
        if (div.classList.contains("ios")) {
            if (window.screen !== undefined && window.screen !== null) {
                if (window.innerWidth < window.innerHeight) {
                    imageSendWidth = 135;
                    imageSendHeight = 240;
                }
            }
        } else {
            if (window.screen.orientation.type === "portrait-primary" || window.screen.orientation.type === "portrait-secondary") {
                imageSendWidth = 135;
                imageSendHeight = 240;
            }
        }
    }

    if (handsUpClientInfo.videoEl !== undefined && handsUpClientInfo.videoEl !== null) {
        if (handsUpClientInfo.imageSendProc !== undefined && (handsUpClientInfo.imageSendProc.current === undefined || handsUpClientInfo.imageSendProc.current === null)) {
            handsUpClientInfo.imageSendProc.current = setInterval(() => { sendVideoStreamImage(); }, handsUpClientInfo.imageSendTime);
        }
    }
}

/**
 * handsUpClientInfo.imageSendTime 마다 image element 캡처
 */
const startCanvasImageSendProc = async () => {
    await clearImgSendProc(); // test용 clear... 

    imageSendWidth = 240;
    imageSendHeight = 135;

    let div = document.getElementById("live-area");
    if (div !== undefined && div !== null) {
        if (div.classList.contains("ios")) {
            if (window.screen !== undefined && window.screen !== null) {
                if (window.innerWidth < window.innerHeight) {
                    imageSendWidth = 135;
                    imageSendHeight = 240;
                }
            }
        } else {
            if (window.screen.orientation.type === "portrait-primary" || window.screen.orientation.type === "portrait-secondary") {
                imageSendWidth = 135;
                imageSendHeight = 240;
            }
        }
    }

    handsUpClientInfo.imageSendTime = ctTimerLv.LV_DEFAULT;

    if (handsUpClientInfo.canvasEl === null) {
        handsUpClientInfo.canvasEl = window.canvas = document.createElement("canvas");
        handsUpClientInfo.canvasEl.width = imageSendWidth;
        handsUpClientInfo.canvasEl.height = imageSendHeight;
        handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
    } else {
        handsUpClientInfo.canvasEl.width = imageSendWidth;
        handsUpClientInfo.canvasEl.height = imageSendHeight;
        handsUpClientInfo.contextEl = handsUpClientInfo.canvasEl.getContext("2d");
    }

    if (handsUpClientInfo.imageSendProc !== undefined && (handsUpClientInfo.imageSendProc.current === undefined || handsUpClientInfo.imageSendProc.current === null)) {
        handsUpClientInfo.imageSendProc.current = setInterval(() => { sendCanvasImage(); }, handsUpClientInfo.imageSendTime);
    }
}

/**
 * video element를 캡처하여 전송
 */
const sendVideoStreamImage = () => {
    if (handsUpClientInfo.videoEl !== undefined && handsUpClientInfo.videoEl !== null) {
        handsUpClientInfo.contextEl.drawImage(handsUpClientInfo.videoEl, 0, 0, imageSendWidth, imageSendHeight);
        handsUpClientInfo.canvasEl.toBlob((blob) => {
            sendUpdateHandsUpImage(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, blob);
        }, imageType, imageQuality);
    }
}

/**
 * image element를 캡처하여 전송
 */
const sendCanvasImage = () => {
    html2canvas(document.body)
    .then((canvasEl) => {
        handsUpClientInfo.contextEl.drawImage(canvasEl, 0, 0, canvasEl.width, canvasEl.height, 0, 0, imageSendWidth, imageSendHeight);
        handsUpClientInfo.canvasEl.toBlob((blob) => {
            sendUpdateHandsUpImage(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, blob);
            if (handsUpClientInfo.imageEl) {
                let url = URL.createObjectURL(blob);
                handsUpClientInfo.imageEl.src = url;
                handsUpClientInfo.imageEl.onload = function () {
                    URL.revokeObjectURL(url);   // cleanup.
                }
            }
        }, imageType, imageQuality);
    })
    .catch((err) => {
        handleDOMException("sendCanvasImage()", err);
    });
}

const base64ToBlob = (base64Data, contentType = 'image/jpeg') => {
    if (base64Data.startsWith('data:')) {
        const base64 = base64Data.split(',')[1];
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    } else { // 순수 base64 문자열인 경우
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
}

const sendCanvasImageFromIOSApp = (imgData) => {
    try {
        const imageBlob = base64ToBlob(imgData, 'image/jpeg');
        sendUpdateHandsUpImage(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, imageBlob);

        console.log("ios base64 이미지 전송 완료");
    } catch (error) {
        console.error("base 64 처리 오류: ", error);
    }
}

const convertDataURIToBinary = (dataURI) => {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    var bb = new Blob([ab], { "type": mimeString });

    return bb;
}

/**
 * 핸즈업 모드를 시작하는 메서드.
 * 
 * @param {Number} lSeq 
 * @param {Number} tSeq 
 * @param {Number} uSeq 
 * @param {String} vKind 
 * @param {Element} vElm 
 * @param {Element} iElm 
 * @param {Element} myCamElm 
 * @param {Object} interval 
 * @param {Object} volumeInterval 
 */
export const startHandsUpMode = (lSeq, tSeq, uSeq, activeYn, vElm, iElm, myCamElm, interval, volumeInterval) => {
    if (deferLiveSendStart(() => startHandsUpMode(lSeq, tSeq, uSeq, activeYn, vElm, iElm, myCamElm, interval, volumeInterval), () => isStartIntentValid(window.hiclasstv.store.getState(), { lSeq, uSeq, elements: [vElm, iElm, myCamElm] }))) return; // 20261028 송출 정리 중이면 보류, 끝난 뒤 재확인 후 실행 (web-relay R-224·R-236)
    openLiveSendOwner(lSeq, uSeq); // 20261028 유효한 새 시작에서만 송출 owner 를 연다 (web-relay R-224)
    console.log(`startHandsUpMode - lSeq[${lSeq}], uSeq[${uSeq}], activeYn[${activeYn}]`);
    initHandsUpInfo(lSeq, tSeq, uSeq, activeYn);

    handsUpClientInfo.videoEl = vElm;
    handsUpClientInfo.imageEl = iElm;
    handsUpClientInfo.myCamEl = myCamElm;

    handsUpClientInfo.imageSendProc = interval;
    handsUpClientInfo.micVolumeSendProc = volumeInterval;

    // 20250707 Pbl 모드가 아닐 경우에만 Produce 로직 호출
    if (!getIsForPblModeBrowser()) {
        window.isHandsUpInit = true;
        updateMediaDevices(true);
    } else {
        // 20260917 PBL Group은 audio producer 생성 완료 후 INIT_DONE을 보내 현재 학생 소리 상태를 실제 track에 적용한다.
        window.isHandsUpInit = true;
    }

    console.log("call changeHandsUpStatusInfo case 29");
    let store = window.hiclasstv.store;
    store.dispatch(changeHandsUpStatusInfo({ kind: "connect" }));
}

/**
 * 핸즈업 모드를 종료하는 메서드
 * 
 * @param {Number} lSeq 
 * @param {Number} uSeq 
 * @param {Boolean} isClickBtn 
 * @param {Boolean} isNeedMuteAudio
 */
// 20261028 종료 작업 공유·첫 await 전 종료 표시·정리 끝난 뒤 시작 (web-relay R-224)
export const stopHandsUpMode = (lSeq, uSeq, isClickBtn, isNeedMuteAudio) => runLiveSendExit("stopHandsUpMode", lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq, (exitToken) => stopHandsUpModeBody(lSeq, uSeq, isClickBtn, isNeedMuteAudio, exitToken));
const stopHandsUpModeBody = async (lSeq, uSeq, isClickBtn, isNeedMuteAudio, exitToken) => { // 20261028 기존 종료 본문 (web-relay R-224)
    console.log(`stopHandsUpMode - lSeq[${lSeq}], uSeq[${uSeq}], isClickBtn[${isClickBtn}], isNeedMuteAudio[${isNeedMuteAudio}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        try { await relayLive.close(); } catch (err) { noteLiveSendRelayUnknown(exitToken, err); } // 20261020 공유 종료 시 역할/FGS 실제 정리 확인 / 20261028 실패해도 기존 정리 계속 (web-relay R-224)
        // 261006 HandsUp 종료 시 iOS 네이티브에 맡긴 카메라 중단/재개 패킷 해제
        syncIOSCameraStatePackets(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, false);
        await clearImgSendProc();
        await clearMicVolumeSendProc();
        await clearVoicDetectionTimeout();

        if (isAndroidWebView()) {
            xmitCmd_AndroidMessage("ct_StopHandsUp", enTokenCMD.NULL);
        } else if (isIOSWebView()) {
            xmitCmd_IosMessage("stop-handsUp", "ALL"); // ios에서 unpublish 할 수 있게 이벤트 전송 ... by ykhan 20260212
            stopIOSRelaySession("stopHandsUpMode"); // 20261022 [IOS-RELAY] 로컬 연결 정리
        }

        // 20260313 unpublish 하기 전에 마이크 상태값을 먼저 초기화하도록 수정 ... by hjkim
        handsUpClientInfo.isMicOn = false;
        handsUpClientInfo.isMuteMode = true; // handsup 종료된 경우 mute 값 초기화.. by hjkim 20220315

        window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
        sendUnpublish("ALL");
        await finishLiveSendExit(exitToken); // 20261028 MQ 응답을 기다리지 않고 로컬 송출 정리 (web-relay R-224)

        if (handsUpClientInfo.isP2PMode || handsUpClientInfo.isSelectedAudio) {
            await unsubscribeHandsUpConsumeAll(false);       // audio, p2p consume 모두 unsubscribe by hjkim 20220225
            await setUnselectedMode(isNeedMuteAudio);   // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215

            handsUpClientInfo.isP2PMode = false;
            handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
            handsUpClientInfo.topKind = stTopKind.All_Client;               // "all-client"
            handsUpClientInfo.isSelectedAudio = false;
        }

        if (handsUpClientInfo.imageEl && handsUpClientInfo.imageEl.src) {
            handsUpClientInfo.imageEl.src = null;
        }

        if (handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
            handsUpClientInfo.videoInputInfo.list_videoInput = [];
            handsUpClientInfo.videoInputInfo.selectedIndex = -1;
            handsUpClientInfo.videoInputInfo.myCamIndex = -1;
        }

        handsUpClientInfo.liveSeq = -1;
        handsUpClientInfo.userSeq = -1;

        if (ConstData.IS_LOCAL_VERSION || handsUpClientInfo.isMixedClassMember) {
            handsUpClientInfo.viewKind = "SCREEN";
        } else {
            handsUpClientInfo.viewKind = "CAMERA";
        }

        // handsUpClientInfo.viewKind = "SCREEN";

        handsUpClientInfo.list_audioConsumeUserSeq = [];
        handsUpClientInfo.smallGroupInfo = [];

        handsUpClientInfo.audioInputInfo = {
            defaultAudioInput: { deviceId: null, groupId: null, label: null },
            currentAudioInput: { deviceId: null, groupId: null, label: null }
        };

        if (navigator && navigator.mediaDevices) {
            navigator.mediaDevices.ondevicechange = null;
        }

        if (isClickBtn) {
            console.log("call changeHandsUpStatusInfo case 30-1");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "disconnect" }));
        } else {
            console.log("call changeHandsUpStatusInfo case 30-2");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "disable" }));
        }

        isReconnMode = false;
    }
}

/**
 * 클래스 중에 "끝내기"로 나가는 경우 핸즈업 모드를 정리하는 메서드.
 */
// 20261028 종료 작업 공유·첫 await 전 종료 표시·정리 끝난 뒤 시작 (web-relay R-224)
export const clearHandsUpMode = () => runLiveSendExit("clearHandsUpMode", handsUpClientInfo.liveSeq > -1 && handsUpClientInfo.userSeq > -1, (exitToken) => clearHandsUpModeBody(exitToken));
const clearHandsUpModeBody = async (exitToken) => { // 20261028 기존 종료 본문 (web-relay R-224)
    try { await relayLive.close(); } catch (err) { noteLiveSendRelayUnknown(exitToken, err); } // 20261020 같은 문서 수업 종료도 세션 실제 정리 확인 / 20261028 실패해도 기존 정리 계속 (web-relay R-224)
    return new Promise((resolve, reject) => { (async () => { // 20261028 내부 오류를 바깥 Promise 로 전달 (web-relay R-237)
      console.log(`clearHandsUpMode - liveSeq[${handsUpClientInfo.liveSeq}], userSeq[${handsUpClientInfo.userSeq}]`);
        if (handsUpClientInfo.liveSeq > -1 && handsUpClientInfo.userSeq > -1) {
            await clearImgSendProc();
            await clearMicVolumeSendProc();
            // await clearStreamSource();
            await clearVoicDetectionTimeout();
            if (isIOSWebView()) stopIOSRelaySession("clearHandsUpMode"); // 20261022 [IOS-RELAY] 로컬 연결 정리

            if (!isAndroidWebView() && !isIOSWebView()) {
                // ios에 unpublish 이벤트 전송 ... by ykhan 20260212
                // ios case 안드로이드랑 같이 처리하는 부분으로 옮기기 ... by ykhan 20260306
                // console.log("끝내기 할 때 여기 확인하기~~!");
                // if (isIOSWebView()) {
                //     xmitCmd_IosMessage("stop-handsup", "ALL"); 
                // }

                // 수정 코드 ... by hjkim 20251106
                // cleanup 시 GainNode를 고려하도록 수정 ... by hjkim 20251106
                if ((await clearMicStreamSource()) === false) noteMixerCleanupFailure("clearMicStreamSource"); // 20261029 내부 false 를 종료 결과까지 전달 (R-252)
                if ((await clearSystemStreamSource()) === false) noteMixerCleanupFailure("clearSystemStreamSource"); // 20261029 (R-252)

                // 원본 스트림도 정리
                if (handsUpClientInfo.rawAudioStream instanceof MediaStream) {
                    console.log("(1) clearHandsUpMode() - try clear rawAudioStream");
                    handsUpClientInfo.rawAudioStream.getTracks().forEach(track => {
                        console.log("(1) clearHandsUpMode() - audio track.stop()");
                        track.stop();
                    });

                    handsUpClientInfo.rawAudioStream = null;
                }

                // audioMerger cleanup
                if (handsUpClientInfo.audioMerger) {
                    handsUpClientInfo.audioMerger.disconnect(handsUpClientInfo.destination);
                    handsUpClientInfo.audioMerger = null;
                }

                // GainNode cleanup 추가
                if (handsUpClientInfo.micGainNode) {
                    handsUpClientInfo.micGainNode.disconnect();
                    handsUpClientInfo.micGainNode = null;
                }

                if (handsUpClientInfo.systemGainNode) {
                    handsUpClientInfo.systemGainNode.disconnect();
                    handsUpClientInfo.systemGainNode = null;
                }

                // destination cleanup
                if (handsUpClientInfo.destination) {
                    if (handsUpClientInfo.destination.stream) {
                        handsUpClientInfo.destination.stream.getTracks().forEach(track => {
                            track.stop();
                        });
                    }

                    handsUpClientInfo.destination = null;
                }

                // audioCtx cleanup
                if (handsUpClientInfo.audioCtx) {
                    if (handsUpClientInfo.audioCtx.state !== "closed") {
                        await handsUpClientInfo.audioCtx.close();
                    }

                    handsUpClientInfo.audioCtx = null;
                }
            } else {
                if (handsUpClientInfo.sendAudioStream) {
                    if (handsUpClientInfo.sendAudioStream) {
                        handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                            track.stop();
                        });
                    }

                    handsUpClientInfo.sendAudioStream = null;
                    handsUpClientInfo.hasMicAudio = false;
                    handsUpClientInfo.hasSystemAudio = false;
                }

                // 원본 스트림도 정리
                if (handsUpClientInfo.rawAudioStream instanceof MediaStream) {
                    console.log("(2) clearHandsUpMode() - try clear rawAudioStream");
                    handsUpClientInfo.rawAudioStream.getTracks().forEach(track => {
                        console.log("(2) clearHandsUpMode() - audio track.stop()");
                        track.stop();
                    });

                    handsUpClientInfo.rawAudioStream = null;
                }

                if (isAndroidWebView()) {
                    xmitCmd_AndroidMessage("ct_StopHandsUp", enTokenCMD.NULL);
                } else if (isIOSWebView()) {
                    xmitCmd_IosMessage("stop-handsup", "ALL"); 
                }
            }

            // 20260313 unpublish 하기 전에 마이크 상태값을 먼저 초기화하도록 수정 ... by hjkim
            handsUpClientInfo.isMicOn = false;
            handsUpClientInfo.isMuteMode = true; // handsup 종료된 경우 mute 값 초기화.. by hjkim 20220315

            window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
            sendUnpublish("ALL");
            await finishLiveSendExit(exitToken); // 20261028 MQ 응답을 기다리지 않고 로컬 송출 정리 (web-relay R-224)

            if (handsUpClientInfo.isP2PMode || handsUpClientInfo.isSelectedAudio) {
                await unsubscribeHandsUpConsumeAll(false);       // audio, p2p consume 모두 unsubscribe by hjkim 20220225
                await setUnselectedMode(true);   // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215

                handsUpClientInfo.isP2PMode = false;
                handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
                handsUpClientInfo.topKind = stTopKind.All_Client;               // "all-client"
                handsUpClientInfo.isSelectedAudio = false;
            }

            if (handsUpClientInfo.imageEl && handsUpClientInfo.imageEl.src) {
                handsUpClientInfo.imageEl.src = null;
            }

            if (handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
                handsUpClientInfo.videoInputInfo.list_videoInput = [];
                handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                handsUpClientInfo.videoInputInfo.myCamIndex = -1;
            }

            handsUpClientInfo.liveSeq = -1;
            handsUpClientInfo.userSeq = -1;

            if (ConstData.IS_LOCAL_VERSION || handsUpClientInfo.isMixedClassMember) {
                handsUpClientInfo.viewKind = "SCREEN";
            } else {
                handsUpClientInfo.viewKind = "CAMERA";
            }

            // handsUpClientInfo.viewKind = "SCREEN";

            handsUpClientInfo.list_audioConsumeUserSeq = [];
            handsUpClientInfo.smallGroupInfo = [];

            handsUpClientInfo.audioInputInfo = {
                defaultAudioInput: { deviceId: null, groupId: null, label: null },
                currentAudioInput: { deviceId: null, groupId: null, label: null }
            };

            if (navigator && navigator.mediaDevices) {
                navigator.mediaDevices.ondevicechange = null;
            }

            console.log("call changeHandsUpStatusInfo case 31");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "disable" }));
        }
        
        resolve(true);
    })().catch(reject); }); // 20261028 내부 오류를 바깥 Promise 로 전달 (web-relay R-237)
}

/**
 * 핸즈업 모드를 active로 설정하는 메서드.
 * - active 일 경우 image / mic level 전송.
 * - active 일 경우 unpublish 했던 video, audio를 publish 해야함. (선생님, 스몰그룹 멤버 모두)
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpActive = async (lSeq, uSeq) => {
    console.log(`setHandsUpActive(1) - lSeq[${lSeq}], uSeq[${uSeq}], activeYn[${handsUpClientInfo.activeYn}]`);
    console.log(`setHandsUpActive(1) - handsUpClientInfo.liveSeq[${handsUpClientInfo.liveSeq}], uSeq[${handsUpClientInfo.userSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        if (handsUpClientInfo.activeYn === "N") {
            handsUpClientInfo.activeYn = "Y";

            if (!getIsForPblModeBrowser()) {
                console.log("setHandsUpActive - Pbl mode is false!! default case!!");

                // if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true; // local 버전과 cloud 버전 구별 위해 주석 처리 ... by hjkim 20231011
                // if (!handsUpClientInfo.isMuteMode) handsUpClientInfo.isMuteMode = true;

                // 20260313 active/inactive 시에는 기본값으로 설정 ... by hjkim
                handsUpClientInfo.isMicOn = false;
                handsUpClientInfo.isMuteMode = true;

                // setUpMicAudioStream(false);
                // initHandsUpMic(false);

                // 20260310 수정 코드 ... by hjkim
                if (handsUpClientInfo.viewKind === "CAMERA") { // 기존 코드 동작
                    // 20251106 ... camera 모드인 경우에는 sendAudioStream 값 유무 확인 후 마이크 오디오 스트림 요청할 것 ... by hjkim
                    if (handsUpClientInfo.micStreamSource === null && !handsUpClientInfo.isMicConnectFlag) {
                        // 20251106 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 & isMicDisable/isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                        console.log("(1-1) setHandsUpActive - all device & camera mode ... sendAudioStream is null ... call initHandsUpMic(false)");
                        await initHandsUpMic(false);
                    } else {
                        console.log("(1-2) setHandsUpActive - all device & camera mode ... already has micStreamSource ... ", handsUpClientInfo.micStreamSource);
                    }
                } else {
                    if (isAndroidWebView()) {
                        // 20251106 ... android webview & screen mode인 경우, 마이크 오디오 스트림 요청하지 않음 ... by hjkim
                        console.log("(2-1) setHandsUpActive - android webview device & screen mode ...");
                        console.log("(2-1) setHandsUpActive - don't request mic stream...");

                        /* // 20260310 만약 마이크를 켜야한다면 ... by hjkim
                        xmitCmd_AndroidMessage("ct_MicOn", enTokenCMD.NULL);

                        if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                            handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                            return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                        } */
                    } else if (isIOSWebView()) {
                        // 20251106 ... ios webview & screen mode인 경우, 마이크 오디오 스트림 요청하지 않음 ... by hjkim
                        console.log("(2-2) setHandsUpActive - android webview device & screen mode ...");
                        console.log("(2-2) setHandsUpActive - don't request mic stream...");

                        /* // 20260310 만약 마이크를 켜야한다면 ... by hjkim
                        xmitCmd_IosMessage("ct_MicOn", enTokenCMD.NULL);

                        if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                            handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                            return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
                        } */
                    } else { // 기존 코드 동작
                        // 20251106 ... devVersion이 아니고, screen 모드인 경우, sendAudioStream 값 유무 확인 후 마이크 오디오 스트림 요청할 것 ... by hjkim
                        if (handsUpClientInfo.sendAudioStream === null) {
                            // 20251106 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 & isMicDisable/isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                            console.log("(2-3) setHandsUpActive - not android/ios webview device & screen mode ... sendAudioStream is null ... call initHandsUpMic(false)");
                            await initHandsUpMic(false);
                        } else {
                            console.log("(2-4) setHandsUpActive - not android/ios webview device & screen mode ... already has sendAudioStream ... ", handsUpClientInfo.sendAudioStream);
                        }
                    }
                }

                // 20260310 기존 코드 주석 처리
                /* // 수정 코드 ... by hjkim 20251106
                // 안드로이드가 아닌 경우에는 micStreamSource 유무 & isMicConnectFlag 값 체크하도록 수정 ... by hjkim 20251106
                if (!getIsAndroidDevice() && !isAndroidWebView() && !isIOSWebView()) {
                    if (handsUpClientInfo.micStreamSource === null && !handsUpClientInfo.isMicConnectFlag) {
                        // 20251106 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 & isMicDisable/isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                        console.log("(1) setHandsUpActive - not android device ... call initHandsUpMic(false)");
                        await initHandsUpMic(false);
                    } else {
                        console.log("(2) setHandsUpActive - not android device ... already has micStreamSource ... ", handsUpClientInfo.micStreamSource);
                    }
                } else {
                    // 20251106 ... camera 모드인 경우에는 sendAudioStream 값 유무 확인 후 마이크 오디오 스트림 요청할 것 ... by hjkim
                    if (handsUpClientInfo.viewKind === "CAMERA") {
                        if (handsUpClientInfo.sendAudioStream === null) {
                            // 20251106 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 & isMicDisable/isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                            console.log("(3) setHandsUpActive - android device & camera mode ... call initHandsUpMic(false)");
                            await initHandsUpMic(false);
                        } else {
                            console.log("(4) setHandsUpActive - android device & camera mode ... already has sendAudioStream ... ", handsUpClientInfo.sendAudioStream);
                        }
                    } else { // viewKind === "SCREEN"
                        // 20260202 ... 안드로이드에서 screen 모드인 경우, android webview인지 여부 값에 따라 구분하도록 수정 ... by hjkim
                        // if (!isDevVersion()) {
                        if (!isAndroidWebView() && !isIOSWebView()) {
                            // 20251106 ... devVersion이 아니고, screen 모드인 경우, sendAudioStream 값 유무 확인 후 마이크 오디오 스트림 요청할 것 ... by hjkim
                            if (handsUpClientInfo.sendAudioStream === null) {
                                // 20251106 ... 크롬 업데이트 이슈로 인해 임시로 로컬 버전에서도 & isMicDisable/isMicOn = false로 마이크가 꺼져있어도 produce 하도록 수정 ... by hjkim
                                console.log("(5) setHandsUpActive - [not devVersion] ... android device & screen mode ... call initHandsUpMic(false)");
                                await initHandsUpMic(false);
                            } else {
                                console.log("(6) setHandsUpActive - [not devVersion] ... android device & screen mode ... already has sendAudioStream ... ", handsUpClientInfo.sendAudioStream);
                            }
                        } else {
                            // 20251106 ... devVersion이고, screen 모드인 경우, 안드로이드에서는 마이크 오디오 스트림 요청하지 않음 ... by hjkim
                            console.log("(7) setHandsUpActive - [devVersion] ... android device & screen mode ...");
                            console.log("(7) setHandsUpActive - don't request mic stream...");
                        }
                    }
                } */

                // 마이크 스트림 먼저 처리하도록 위치 이동 ... by hjkim 20251031
                if (handsUpClientInfo.sendVideoStream instanceof MediaStream) {
                    // startVideoStreamImageSendProc();
                    if (handsUpClientInfo.viewKind === "SCREEN") {
                        gotVideoStream(false, false);
                    } else {
                        gotVideoStream(false, true);
                    }
                } else {
                    if (checkAndroidScreenValue()) {
                        console.log("sendStartPentalkOnScreenForAndroid called ... case 1");
                        sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, false, handsUpClientInfo.configFPSKind);
                    } else if (isIOSWebView()) {
                        sendStartPentalkOnScreenForIOS(handsUpClientInfo.isP2PMode, handsUpClientInfo.configFPSKind);
                    } else {
                        // 20251106 ... 주석 처리 ... by hjkim
                        // 이제 이미지를 보내는게 아니라 비디오 스트림을 보내는 방식인데 왜 이걸 부르지..?
                        // startCanvasImageSendProc();

                        setUpVideoStream(false);
                    }
                }
            } else {
                console.log("setHandsUpActive - Pbl mode is true!! Pbl case!!");
            }
        }
    }
}

/**
 * 핸즈업 모드를 inactive로 설정하는 메서드.
 * - inactive 일 경우 image / mic level 전송 안 함.
 * - inactive 일 경우 publish 하던 video, audio를 unpublish 해야함. (선생님, 스몰그룹 멤버 모두)
 * - inactive 일 경우 consume 하던 audio, p2p 모두 clear 해야함. (스몰그룹 멤버 모두)
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpInactive = async (lSeq, uSeq) => {
    console.log(`setHandsUpInactive(1) - lSeq[${lSeq}], uSeq[${uSeq}], activeYn[${handsUpClientInfo.activeYn}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        if (handsUpClientInfo.activeYn === "Y") {
            handsUpClientInfo.activeYn = "N";
            await clearImgSendProc();
            await clearMicVolumeSendProc();

            if (checkAndroidScreenValue()) {
                xmitCmd_AndroidMessage("ct_StopScreenCapture", enTokenCMD.NULL);
            }

            if (isIOSWebView() && handsUpClientInfo.viewKind === "SCREEN") {
                xmitCmd_IosMessage("stop-screenCapture", "ALL"); 
            }

            // 20260313 active/inactive 시에는 기본값으로 설정 & unpulish 보내기 전에 마이크 상태값 초기화하도록 수정 ... by hjkim
            handsUpClientInfo.isMicOn = false;
            handsUpClientInfo.isMuteMode = true;

            if (handsUpClientInfo.isMicOn || handsUpClientInfo.sendAudioStream) {
                window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                sendUnpublish("audio");
            }

            if (handsUpClientInfo.sendVideoStream) {
                window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                sendUnpublish("video");
            }

            if (handsUpClientInfo.isP2PMode || handsUpClientInfo.isSelectedAudio || handsUpClientInfo.isSmallGroupMode) {
                // if (handsUpClientInfo.isP2PMode) {
                // window.isNeedCallOnScreen = false;
                // sendUnpublish("video");
                // }

                await unsubscribeHandsUpConsumeAll(false);   // audio, p2p consume 모두 unsubscribe by hjkim 20220225
                await setUnselectedMode();              // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215

                handsUpClientInfo.isP2PMode = false;
                handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
                handsUpClientInfo.topKind = stTopKind.All_Client;               // "all-client"
                handsUpClientInfo.isSelectedAudio = false;
                handsUpClientInfo.isSmallGroupMode = false;
            }

            handsUpClientInfo.list_audioConsumeUserSeq = [];
            handsUpClientInfo.smallGroupInfo = [];

            console.log("call changeHandsUpStatusInfo case 1");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
            store.dispatch(smallGroupStop());
        }
    }
}

let handsUpP2PRequestSeq = 0; // 20260804 늦게 끝난 이전 P2P 요청이 최신 해상도를 덮어쓰지 않도록 순서를 구분한다.

/**
 * P2P 모드 컨트롤하는 메서드.
 * 
 * @param {String} topKind - p2p 모드 문자열 // all-client, 1-top-client, 2-top-client, 4-top-client, 6-top-client, 8-top-client, 9-top-client, present-client
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Array} list_user - 사용자 시퀀스 번호 배열
 */
export const handleHandsUpP2PMode_new = async (topKind, lSeq, list_user) => {
    console.log(`handleHandsUpP2PMode_new topKind[${topKind}], lSeq[${lSeq}], list_user => `, list_user);
    if (lSeq === handsUpClientInfo.liveSeq) {
        const requestSeq = ++handsUpP2PRequestSeq; // 20260804 현재 클래스의 P2P 요청만 최신 순서에 반영한다.
        if (list_user && list_user.length > 0) { // list_user 가 있는 경우 p2p 대상들이 있는 case by hjkim 20220224
            const user_info = list_user.find(uSeq => uSeq === handsUpClientInfo.userSeq);
            const members_info = list_user.filter(uSeq => uSeq !== handsUpClientInfo.userSeq);

            if (user_info !== undefined && user_info !== null) { // list_user 에 내가 포함된 case by hjkim 20220224
                console.log("handleHandsUpP2PMode_new case 1 [list_user에 내가 포함된 case (=p2p consume 시작)]");
                try {
                    await clearImgSendProc(); // 1초에 4번 이미지 보내던 process 종료

                    if (handsUpClientInfo.isSelectedAudio || handsUpClientInfo.isP2PMode) { // 기존에 듣고 있던 audio, p2p consume check by hjkim 20220224
                        await handleP2PConsume(list_user, false);
                    }

                    // uSeq가 일치하는 경우 선생님 mic를 들어야한다 by hjkim 20210315
                    await setSelectedMode();    // 선생님 audio mute, mic listen ** 중요 by hjkim 20220215
                } catch (err) {
                    handleDOMException("handleHandsUpP2PMode_new(case-1)", err);
                } finally {
                    // 20260804 최신 종료 요청 이후 완료된 과거 시작 요청은 P1P 모드를 다시 적용하지 않는다.
                    if (requestSeq !== handsUpP2PRequestSeq) return;
                    if (handsUpClientInfo.isP2PMode === false) { // p2p가 시작될 경우 video stream을 publish 해야함 by hjkim 20210316
                        handsUpClientInfo.isP2PMode = true;
                        handsUpClientInfo.topKind = topKind;

                        if (topKind === stTopKind.All_Client) {                         // "all-client"
                            console.log("handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail 여기를 타는 경우가 있나..? ");
                            handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail; // 0 ... Thumbnail ( 640 x 360 ) mode
                        } else if (topKind === stTopKind.P2P_Top_Client) {              // "2-top-client"
                            handsUpClientInfo.localStreamingMode = enP2PMode.P2P;       // 2 ... 2명 보기 mode ( 1280 x 720 )
                        } else if (topKind === stTopKind.P1P_Top_Client 
                            || topKind === stTopKind.Presentation_Client) {             // "1-top-client" or "present-client"
                            handsUpClientInfo.localStreamingMode = enP2PMode.P1P;       // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                        } else {                                                        // "4-top-client" or "6-top-client" or "8-top-client" or "9-top-client"
                            handsUpClientInfo.localStreamingMode = enP2PMode.P4P;       // 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                        }

                        /** android 용 screen capture 프로그램 실행을 위해서 따로 처리.. by hjkim 20211108 */
                        if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261021 C3 보기는 기존 웹 영상 설정으로 처리
                            if (handsUpClientInfo.localStreamingMode === enP2PMode.Thumbnail) {     // 0 ... Thumbnail ( 640 x 360 ) mode
                                console.log("localStreamingMode === enP2PMode.Thumbnail 여기를 타는 경우가 있나..? ");
                                // window.setThumbnailMode();
                            } else if (handsUpClientInfo.localStreamingMode === enP2PMode.P1P) {    // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                                // xmitCmd_AndroidMessage("ct_StartP1P", enTokenCMD.NULL);
                                window.setP1PMode();
                            } else if (handsUpClientInfo.localStreamingMode === enP2PMode.P2P) {    // 2 ... 2명 보기 mode ( 1280 x 720 )
                                // xmitCmd_AndroidMessage("ct_StartP2P", enTokenCMD.NULL);
                                window.setP2PMode();
                            } else {                                                                // 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                                // xmitCmd_AndroidMessage("ct_StartP4P", enTokenCMD.NULL);
                                window.setP4PMode();
                            }
                        } else if (isIOSWebView()) {
                            xmitCmd_IosMessage("p2p", handsUpClientInfo.localStreamingMode);
                        } else {
                            try {
                                if (handsUpClientInfo.sendVideoStream === null) {
                                    setUpVideoStream(false);
                                } else {
                                    // const vTrack = handsUpClientInfo.sendVideoStream.getVideoTracks()[0];
                                    // await produceVideo(vTrack.clone());
                                    console.log("handsUpClientInfo.videoInputInfo.selectedIndex - ", handsUpClientInfo.videoInputInfo.selectedIndex);
                                    console.log("handsUpClientInfo.viewKind - ", handsUpClientInfo.viewKind);

                                    let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                                    let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                                    console.log(`handleHandsUpP2PMode_new(start-1) - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                                    let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                                    await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);
                                }
                            } catch (err) {
                                handleDOMException("handleHandsUpP2PMode_new(start-1-1)", err);
                            }
                        }
                    } else {
                        // 이미 isP2PMode 인 경우 topKind 종류에 따라서 이미지 해상도 다르게 처리! ... by hjkim 20240710
                        if (handsUpClientInfo.topKind !== topKind) {
                            handsUpClientInfo.topKind = topKind;

                            if (topKind === stTopKind.All_Client) {                         // "all-client"
                                console.log("handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail 여기를 타는 경우가 있나..? ");
                                handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail; // 0 ... Thumbnail ( 640 x 360 ) mode
                            } else if (topKind === stTopKind.P2P_Top_Client) {              // "2-top-client"
                                handsUpClientInfo.localStreamingMode = enP2PMode.P2P;       // 2 ... 2명 보기 mode ( 1280 x 720 )
                            } else if (topKind === stTopKind.P1P_Top_Client 
                                || topKind === stTopKind.Presentation_Client) {             // "1-top-client" or "present-client"
                                handsUpClientInfo.localStreamingMode = enP2PMode.P1P;       // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                            } else {                                                        // "4-top-client" or "6-top-client" or "8-top-client" or "9-top-client"
                                handsUpClientInfo.localStreamingMode = enP2PMode.P4P;       // 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                            }

                            if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261021 C3 보기는 기존 웹 영상 설정으로 처리
                                if (handsUpClientInfo.localStreamingMode === enP2PMode.Thumbnail) {     // 0 ... Thumbnail ( 640 x 360 ) mode
                                    console.log("localStreamingMode === enP2PMode.Thumbnail 여기를 타는 경우가 있나..? ");
                                    // window.setThumbnailMode();
                                } else if (handsUpClientInfo.localStreamingMode === enP2PMode.P1P) {    // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                                    window.setP1PMode();
                                } else if (handsUpClientInfo.localStreamingMode === enP2PMode.P2P) {    // 2 ... 2명 보기 mode ( 1280 x 720 )
                                    window.setP2PMode();
                                } else {                                                                // 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                                    window.setP4PMode();
                                }
                            } else if (isIOSWebView()) {
                                xmitCmd_IosMessage("p2p", handsUpClientInfo.localStreamingMode);
                            } else {
                                console.log("handsUpClientInfo.videoInputInfo.selectedIndex - ", handsUpClientInfo.videoInputInfo.selectedIndex);
                                console.log("handsUpClientInfo.viewKind - ", handsUpClientInfo.viewKind);

                                let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                                let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                                console.log(`handleHandsUpP2PMode_new(start-1-3) - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                                let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                                await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);
                            }
                        }
                    }

                    if (members_info !== undefined && members_info !== null && members_info.length > 0) {
                        try {
                            const promises = members_info.map((uSeq, idx) => subscribeHandsUpP2P(uSeq, idx));
                            await Promise.all(promises);
                        } catch (err) {
                            handleDOMException("handleHandsUpP2PMode_new(start-1-2)", err);
                        }
                    }
                }
            } else { // list_user 에 내가 포함되지 않은 case by hjkim 20220224
                console.log("handleHandsUpP2PMode_new case 2 [list_user에 내가 포함되지 않은 case (=p2p consume 종료)]");
                try {
                    if (handsUpClientInfo.isSelectedAudio || handsUpClientInfo.isP2PMode) { // 기존에 듣고 있던 audio, p2p consume check by hjkim 20220224
                        await handleP2PConsume([], false);
                    }
                } catch (err) {
                    handleDOMException("handleHandsUpP2PMode_new(stop-2)", err);
                } finally {
                    // 20260804 최신 요청이 바뀐 경우 과거 종료 작업의 해상도 변경을 건너뛴다.
                    if (requestSeq !== handsUpP2PRequestSeq) return;
                    handsUpClientInfo.isP2PMode = false;
                    handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
                    handsUpClientInfo.topKind = stTopKind.All_Client;               // "all-client"

                    /** android 용 screen capture 프로그램 실행을 위해서 따로 처리.. by hjkim 20211108 */
                    if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261021 C3 보기는 기존 웹 영상 설정으로 처리
                        xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);      // 0 ... Thumbnail ( 640 x 360 ) mode
                    } else if (isIOSWebView()) {
                        xmitCmd_IosMessage("p2p", handsUpClientInfo.localStreamingMode);
                    } else {
                        if (handsUpClientInfo.sendVideoStream === null) {
                            console.log(`handleHandsUpP2PMode_new(stop-2-1) - sendVideoStream is null.`);
                            setUpVideoStream(false);
                        } else {
                            let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                            let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                            console.log(`handleHandsUpP2PMode_new(stop-2-2) - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                            let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                            await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);
                        }
                    }

                    // 내가 p2p list에 포함되지 않은 경우여도 다른 p2p 학생들의 소리를 들어야하므로 선생님 audio를 listen 해야한다 by hjkim 20210315
                    try {
                        await setUnselectedMode();          // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215
                    } catch (err) {
                        handleDOMException("handleHandsUpP2PMode_new(stop-2-3)", err);
                    }
                }
            }
        } else { // list_user 가 없는 경우 p2p 종료 case by hjkim 20220224
            console.log("handleHandsUpP2PMode_new case 3 [list_user가 없는 case (=p2p consume 종료)]");
            try {
                /* if (handsUpClientInfo.isP2PMode) {
                    window.isNeedCallOnScreen = false;
                    sendUnpublish("video");
                } */

                /* let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                console.log(`handleHandsUpP2PMode_new(stop-3-1) - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode); */

                if (handsUpClientInfo.isSelectedAudio || handsUpClientInfo.isP2PMode) {
                    await handleP2PConsume(list_user, true);
                }
            } catch (err) {
                handleDOMException("handleHandsUpP2PMode_new(stop-3-1)", err);
            } finally {
                // 20260804 최신 요청이 바뀐 경우 과거 종료 작업의 해상도 변경을 건너뛴다.
                if (requestSeq !== handsUpP2PRequestSeq) return;
                handsUpClientInfo.isP2PMode = false;
                handsUpClientInfo.localStreamingMode = enP2PMode.Thumbnail;     // 0 ... Thumbnail ( 640 x 360 ) mode
                handsUpClientInfo.topKind = stTopKind.All_Client;

                /** android 용 screen capture 프로그램 실행을 위해서 따로 처리.. by hjkim 20211108 */
                if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261021 C3 보기는 기존 웹 영상 설정으로 처리
                    // xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);
                    window.setThumbnailMode();

                    /* if (isAndroidWebView()) {
                        // xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);
                        window.setThumbnailMode();
                    } else {
                        xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);
                    } */
                } else if (isIOSWebView()) {
                    xmitCmd_IosMessage("p2p", handsUpClientInfo.localStreamingMode);
                } else {
                    // startVideoStreamImageSendProc();
                    /* if (handsUpClientInfo.viewKind === "SCREEN") {
                        gotVideoStream(false);
                    } else {
                        gotVideoStream(true);
                    } */

                    if (handsUpClientInfo.sendVideoStream === null) {
                        console.log(`handleHandsUpP2PMode_new(stop-3-2) - sendVideoStream is null.`);
                        setUpVideoStream(false);
                    } else {
                        let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                        let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                        console.log(`handleHandsUpP2PMode_new(stop-3-3) - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                        let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                        await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);
                    }
                }

                if (handsUpClientInfo.isSelectedAudio) { // audio가 select된 경우 다시 선생님 mic를 들어야한다 by hjkim 20210315
                    await setSelectedMode();            // 선생님 audio mute, mic listen ** 중요 by hjkim 20220215
                } else { // p2p가 종료된 경우 audio select가 아니면 선생님 audio를 들어야한다 by hjkim 20210315
                    await setUnselectedMode();          // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215
                }
            }
        }
    }
}

/**
 * P2P 모드를 재시작하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Array} list_user - 사용자 시퀀스 번호 배열
 */
export const restartHandsUpP2PMode = async (lSeq, list_user) => {
    // handleHandsUpP2PMode(lSeq, list_user);
    handleHandsUpP2PMode_new(getTopKind(), lSeq, list_user);
}

/**
 * SmartTV와의 연결을 컨트롤하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {Boolean} isSmartTVMode - 스마트TV 연결 여부
 * @param {Number} localStreamingMode - p2p모드
 * @param {String} smartTVTempKey - 스마트TV 임시 라우팅키
 */
export const handleHandsUpSmartTVMode = async (lSeq, uSeq, isSmartTVMode, localStreamingMode, smartTVTempKey) => {
    console.log(`handleHandsUpSmartTVMode - lSeq[${lSeq}], uSeq[${uSeq}], isSmartTVMode[${isSmartTVMode}], localStreamingMode[${localStreamingMode}], smartTVTempKey[${smartTVTempKey}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        try {
            console.log("list_smartTVKey => ", handsUpClientInfo.list_smartTVKey, ", indexOf => ", handsUpClientInfo.list_smartTVKey.indexOf(smartTVTempKey));
            if (isSmartTVMode) {
                if (handsUpClientInfo.list_smartTVKey.indexOf(smartTVTempKey) === -1) { // list에 없는 경우 추가해야 함
                    handsUpClientInfo.list_smartTVKey.push(smartTVTempKey);
                } else { // list에 있는 경우 무시
                    console.log("already pushed in list. - smartTVTempKey => ", smartTVTempKey);
                }
            } else {
                if (handsUpClientInfo.list_smartTVKey.indexOf(smartTVTempKey) === -1) { // list에 없는 경우 무시
                    console.log("already poped in list. - smartTVTempKey => ", smartTVTempKey);
                } else { // list에 있는 경우 list에서 빼야 함
                    handsUpClientInfo.list_smartTVKey = handsUpClientInfo.list_smartTVKey.filter(key => key !== smartTVTempKey);
                }
            }

            // handsUpClientInfo.isSmartTVMode = isSmartTVMode;
            handsUpClientInfo.isSmartTVMode = handsUpClientInfo.list_smartTVKey.length > 0;
            console.log(`isSmartTVMode[${handsUpClientInfo.isSmartTVMode}], list_smartTVKey => `, handsUpClientInfo.list_smartTVKey);
            // 20260804 로그아웃 후 다른 화면의 요청 키가 남아 있으면 기존 고화질 모드를 유지한다.
            if (isSmartTVMode) {
                handsUpClientInfo.smartTVP2PMode = localStreamingMode;
            } else if (!handsUpClientInfo.isSmartTVMode) {
                handsUpClientInfo.smartTVP2PMode = enP2PMode.Thumbnail;
            }

            if (isAndroidWebView()) {
                const data = {
                    // 20260804 개별 명령값이 아니라 남아 있는 전체 SmartTV 요청 키 상태를 Android에 전달한다.
                    isSmartTVMode: handsUpClientInfo.isSmartTVMode,
                    localStreamingMode: handsUpClientInfo.smartTVP2PMode
                };

                window.switchVideoResolution(JSON.stringify(data));
            } else {
                if (handsUpClientInfo.isP2PMode) { // p2p 모드일 경우 이미 고화질로 보내기 때문에 smartv mode 값 세팅 후 아무것도 하지 않는다 ... by hjkim 20231109
                    console.log("handleHandsUpSmartTVMode - already high quality video.");
                    let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                    let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                    console.log(`handleHandsUpSmartTVMode - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                    let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                    await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);
                } else { // p2p 모드가 아닌 경우 저화질로 보내고 있기 때문에 smartv mode 값 세팅 후 고화질로 변경해준다 ... by hjkim 20231109 
                    console.log("handleHandsUpSmartTVMode - setting high quality video.");
                    if (checkAndroidScreenValue()) {
                        // 스마트TV 연결 모드일 때 어떻게 해야할지 생각해봐야함. 앱이 명령을 직접 받던가..? by hjkim
                        /* if (isAndroidWebView()) {
                            if (handsUpClientInfo.isSmartTVMode) {
                                // xmitCmd_AndroidMessage("ct_StartP2P", enTokenCMD.NULL);
                                window.setP1PMode();
                            } else {
                                // xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);
                                window.setThumbnailMode();
                            }
                        } else {
                            // if (handsUpClientInfo.isSmartTVMode) {
                            //     xmitCmd_AndroidMessage("ct_StartP2P", enTokenCMD.NULL);
                            // } else {
                            //     xmitCmd_AndroidMessage("ct_StopP2P", enTokenCMD.NULL);
                            // }
                        } */
                    } else {
                        if (handsUpClientInfo.sendVideoStream === null) {
                            setUpVideoStream(false);
                        } else {
                            let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                            let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                            console.log(`handleHandsUpSmartTVMode - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                            let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);

                            await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode);

                            /* let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser();
                            let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
                            console.log(`handleHandsUpSmartTVMode - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);
                            let localStreamingMode = currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode);
    
                            await setVideoResolution(isHighQualityMode, isCameraStream, getIsForPblModeBrowser(), localStreamingMode); */
                        }
                    }
                }
            }
        } catch (err) {
            handleDOMException("handleHandsUpSmartTVMode()", err);
        }
    }
}

/**
 * 소그룹 멤버별 videoEl 및 콜백 메서드 설정
 * 
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {Element} videoEl - HTML 비디오 요소 객체
 * @param {Function} imageProcess - 콜백 메서드
 * @param {Object | null} member_info - 멤버 정보 객체
 */
export const initSmallGroupFunc = async (uSeq, videoEl, imageProcess, member_info) => {
    console.log("initSmallGroupFunc - uSeq[", uSeq, "], member_info => ", member_info);
    const smallGroupInfo = handsUpClientInfo.smallGroupInfo;
    console.log("initSmallGroupFunc - smallGroupInfo => ", smallGroupInfo);
    if (isUsableArrayObj(smallGroupInfo)) {
        // 20251212 ... imageProcess가 null인 경우 해당 멤버 unsubscribe해야함 ... by hjkim
        if (imageProcess === null) {
            handsUpClientInfo.smallGroupInfo = smallGroupInfo.filter(mem => mem.userSeq !== uSeq); // 해당 멤버 small group 정보에서 제외
            console.log("initSmallGroupFunc - unsubscribeHandsUpConsume(false, uSeq[", uSeq, "])");
            await unsubscribeHandsUpConsume(false, uSeq);
        } else {
            const sMem_info = smallGroupInfo.find(mem => mem.userSeq === uSeq);
            if (sMem_info) {
                // 기존 코드
                smallGroupInfo.forEach(mem => {
                    if (mem.userSeq === uSeq) {
                        mem.el = videoEl;
                        mem.func = imageProcess;
                    }
                });

                console.log("initSmallGroupFunc - 기존 코드 케이스! uSeq[", uSeq, "]) - 기존 스몰 그룹용(pbl 아님)");
            } else {
                // 20251212 ... 가지고 있던 small group member 배열에 해당 멤버가 없는 경우 배열에 추가 & consume 요청해야 함 ... by hjkim
                if (member_info) {
                    smallGroupInfo.push({
                        userSeq: member_info.userSeq,
                        isMixedClassMember: member_info.isMixedClassMember,
                        el: videoEl,
                        func: imageProcess
                    });

                    console.log("(1) initSmallGroupFunc - 수정 코드 케이스! uSeq[", uSeq, "])");

                    // consume 요청
                    startSmallGroupAudioCosume(smallGroupInfo);
                }
            }
        }
    } else {
        if (member_info) {
            // 20251212 ... 가지고 있던 small group member 배열의 길이가 0인 경우 해당 멤버 배열에 추가 & consume 요청해야 함 ... by hjkim
            smallGroupInfo.push({
                userSeq: member_info.userSeq,
                isMixedClassMember: member_info.isMixedClassMember,
                el: videoEl,
                func: imageProcess
            });

            console.log("(2) initSmallGroupFunc - 수정 코드 케이스! uSeq[", uSeq, "])");

            // consume 요청
            startSmallGroupAudioCosume(smallGroupInfo);
        }
    }
}

/**
 * 소그룹 멤버별 videoEl, audioEl 설정
 * 
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {Element} videoEl - HTML 비디오 요소 객체
 * @param {Element} audioEl - HTML 오디오 요소 객체
 */
/* export const setElementForSmallGroup = (uSeq, videoEl, audioEl) => {
    if (handsUpClientInfo.smallGroupInfo && handsUpClientInfo.smallGroupInfo.length > 0) {
        handsUpClientInfo.smallGroupInfo.forEach(mem => {
            if (mem.userSeq === uSeq) {
                mem.videoEl = videoEl;
                mem.audioEl = audioEl;
            }
        });
    }
} */

/**
 * 소그룹 멤버 화면 업데이트
 * 
 * @param {String} status - 상태
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {ArrayBuffer} imageData - 이미지 데이터
 */
export const updateSmallGroupImage = (status, lSeq, uSeq, imageData) => {
    // console.log(`updateSmallGroupImage - lSeq[${lSeq}], handsUpClientInfo.liveSeq[${handsUpClientInfo.liveSeq}], handsUpClientInfo.smallGroupInfo => `, handsUpClientInfo.smallGroupInfo);
    if (lSeq === handsUpClientInfo.liveSeq && handsUpClientInfo.smallGroupInfo && handsUpClientInfo.smallGroupInfo.length > 0) {
        let member = handsUpClientInfo.smallGroupInfo.find(info => info.userSeq === uSeq);
        if (member && member.func) {
            member.func(status, imageData);
        }
    }
}

/**
 * HiclassTV Pencam 창에서 Group Study (모둠학습) 시작 시, 
 * [내 얼굴 / 내 화면] -> 펜톡 모니터창으로 전송 (restAPI) 
 * [내 화면] -> Pencam창으로 전송 (MQ)
 * 
 * @param {Boolean} status - 상태값
 * @param {Array} list_user - 사용자 시퀀스 번호 배열
 * @param {String | undefined | null} sendKey - MQ RoutingKey
 */
export const handleGroupStudyMode = async (status, list_user, sendKey) => {
    let members_info = [];

    if (status) {
        if (list_user && list_user.length > 0) {
            list_user.forEach(info => {
                if (info.userSeq !== handsUpClientInfo.userSeq) {
                    members_info.push({
                        userSeq: info.userSeq,
                        isMixedClassMember: info.isMixedClassMember,
                        el: null,
                        func: null
                    });
                }
            });

            startSmallGroupAudioCosume(list_user);
        }

        if (isAndroidWebView()) {
            window.setSmallGroupInfo(JSON.stringify({
                groupSendKey: sendKey
            }));
        }/*  else {
            if (handsUpClientInfo.isAndroidDevice) {
                xmitCmd_AndroidSmallGroupInfo("android", "ct_SmallGroupInfo", sendKey);
            }
        } */
        
    } else {
        stopSmallGroupAudioConsume();

        if (isAndroidWebView()) {
            window.setSmallGroupInfo(JSON.stringify({
                groupSendKey: null
            }));
        }/*  else {
            if (handsUpClientInfo.isAndroidDevice) {
                xmitCmd_AndroidSmallGroupInfo("android", "ct_SmallGroupInfo", null);
            }
        } */
    }

    handsUpClientInfo.isSmallGroupMode = status;
    handsUpClientInfo.smallGroupInfo = members_info;
}

/**
 * HiclassTV Pentalk - HandsUp 창에서 Small Group (소그룹활동) 시작 시,
 * [내 얼굴/화면] -> 펜톡 모니터창으로 전송, 멤버들에게 전송 (restAPI)
 * [멤버 음성] consume 
 * 
 * @param {Array} list_user - 사용자 시퀀스 번호 배열
 */
export const startSmallGroupAudioCosume = async (list_user) => {
    console.log(`startSmallGroupAudioCosume - isP2PMode[${handsUpClientInfo.isP2PMode}], isSelectedAudio[${handsUpClientInfo.isSelectedAudio}], list_user => `, list_user);
    if (list_user && list_user.length > 0) {
        const user_info = list_user.find(info => info.userSeq === handsUpClientInfo.userSeq);
        console.log("user_info => ", user_info);
        const audioUser_info = list_user.filter(info => info.userSeq !== handsUpClientInfo.userSeq);
        console.log("audioUser_info => ", audioUser_info);
        handsUpClientInfo.list_audioConsumeUserSeq = audioUser_info === undefined || audioUser_info === null ? [] : audioUser_info;
        console.log("handsUpClientInfo.list_audioConsumeUserSeq => ", handsUpClientInfo.list_audioConsumeUserSeq);
        if (user_info) {
            try {
                await setSelectedMode();        // 선생님 audio mute, mic listen ** 중요 by hjkim 20220215
            } catch (err) {
                handleDOMException("startSmallGroupAudioCosume(start-1)", err);
            } finally {
                if (audioUser_info && audioUser_info.length > 0) {
                    try {
                        console.log("(1) const promises = audioUser_info.map(info => subscribeHandsUpAudio(info.userSeq, info.isMixedClassMember, 'video'))");
                        const promises = audioUser_info.map(info => subscribeHandsUpAudio(info.userSeq, info.isMixedClassMember, "video"));
                        await Promise.all(promises);
                    } catch (err) {
                        handleDOMException("startSmallGroupAudioCosume(start-2)", err);
                    }
                }
            }
        } else {
            if (getIsForPblModeBrowser()) {
                console.log("startSmallGroupAudioCosume - user_info 없음! & pbl 케이스! consume 요청하기!");
                if (audioUser_info && audioUser_info.length > 0) {
                    try {
                        console.log("(2) const promises = audioUser_info.map(info => subscribeHandsUpAudio(info.userSeq, info.isMixedClassMember, 'video'))");
                        const promises = audioUser_info.map(info => subscribeHandsUpAudio(info.userSeq, info.isMixedClassMember, "video"));
                        await Promise.all(promises);
                    } catch (err) {
                        handleDOMException("startSmallGroupAudioCosume(start-2)", err);
                    }
                }
            }
        }
    }
}

/**
 * HiclassTV Pentalk - HandsUp 창에서 Small Group (소그룹활동) 종료 시,
 * [내 얼굴/화면] 멤버들에게 전송 취소
 * [멤버 음성] unsubsribe 
 */
export const stopSmallGroupAudioConsume = async () => {
    // console.log(`stopSmallGroupAudioConsume - isP2PMode[${handsUpClientInfo.isP2PMode}], isSelectedAudio[${handsUpClientInfo.isSelectedAudio}]`);
    try {
        await unsubscribeHandsUpConsumeAll(false);
        await setUnselectedMode();      // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215
    } catch (err) {
        handleDOMException("stopSmallGroupAudioConsume()", err);
    } finally {
        handsUpClientInfo.list_audioConsumeUserSeq = [];
    }
}

/**
 * 클래스 핸즈업 멤버들의 오디오 consume 시작을 관리하는 메서드.
 * ※ me == uSeq(handsUpClientInfo.userSeq)로 가정함.
 * - list_user 배열의 길이가 0보다 큰 경우
 *   => list_user 배열에서 uSeq를 제외한 결과인 audioUser_info를 list_audioConsumeUserSeq에 저장
 * - list_user 배열에 uSeq가 포함된 경우
 *   => isSelectedAudio 설정(isSelectedAudio = true) 및 list_audioConsumeUserSeq에 저장된 모든 오디오 consume 시작해야 함.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Array} list_user - 사용자 시퀀스 번호 배열
 */
export const initHandsUpAudioConsume = async (lSeq, list_user) => {
    console.log(`initHandsUpAudioConsume - handsUpClientInfo.liveSeq[${handsUpClientInfo.liveSeq}], lSeq[${lSeq}], list_user => `, list_user);
    if (lSeq === handsUpClientInfo.liveSeq) {
        if (list_user && list_user.length > 0) {
            const user_info = list_user.find(uSeq => uSeq === handsUpClientInfo.userSeq);
            const audioUser_info = list_user.filter(uSeq => uSeq !== handsUpClientInfo.userSeq);
            handsUpClientInfo.list_audioConsumeUserSeq = audioUser_info === undefined || audioUser_info === null ? [] : audioUser_info;
            if (user_info) {
                try {
                    await setSelectedMode();        // 선생님 audio mute, mic listen ** 중요 by hjkim 20220215
                } catch (err) {
                    handleDOMException("initHandsUpAudioConsume()", err);
                } finally {
                    handsUpClientInfo.isSelectedAudio = true;

                    let store = window.hiclasstv.store;
                    store.dispatch(mqHandsUpOff({ liveSeq: lSeq, userSeq: user_info }));

                    if (audioUser_info && audioUser_info.length > 0) {
                        try {
                            const promises = audioUser_info.map(uSeq => subscribeHandsUpAudio(uSeq, false));
                            await Promise.all(promises);
                        } catch (err) {
                            handleDOMException("initHandsUpAudioConsume()", err);
                        }
                    }
                }
            }
        }
    }
}

/**
 * 클래스 핸즈업 멤버의 오디오 consume 시작을 관리하는 메서드.
 * - me != uSeq일 경우
 *   => 해당 uSeq에 대해 오디오 consume 시작.
 * - me == uSeq일 경우
 *   => isSelectedAudio 설정(isSelectedAudio = true) 및 list_audioConsumeUserSeq에 저장된 모든 오디오 consume 시작해야 함.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const startHandsUpAudioConsume = async (lSeq, uSeq) => {
    console.log(`startHandsUpAudioConsume - lSeq[${lSeq}], uSeq[${uSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq) {
        if (uSeq === handsUpClientInfo.userSeq) {
            try {
                await subscribeHandsUpAudioArray(handsUpClientInfo.list_audioConsumeUserSeq);   // audio select list에 저장된 user들 모두 subscribe by hjkim 20210325
                await setSelectedMode();        // 선생님 audio mute, mic listen ** 중요 by hjkim 20220215
            } catch (err) {
                handleDOMException("startHandsUpAudioConsume()", err);
            } finally {
                handsUpClientInfo.isSelectedAudio = true;

                let store = window.hiclasstv.store;
                store.dispatch(mqHandsUpOff({ liveSeq: lSeq, userSeq: uSeq }));
            }
        } else {
            if (uSeq !== undefined && uSeq !== null && uSeq >= 0) {
                handsUpClientInfo.list_audioConsumeUserSeq.push(uSeq);  // audio select user list 에 저장하기 by hjkim 20210325
                if (handsUpClientInfo.isSelectedAudio) { // 내가 이미 audio select 되었을 경우에만 subscribe ... by hjkim 20210315
                    try {
                        await subscribeHandsUpAudio(uSeq, false);
                    } catch (err) {
                        handleDOMException("startHandsUpAudioConsume()", err);
                    }
                }
            }
        }
    }
}

/**
 * 클래스 핸즈업 멤버의 오디오 consume 종료를 관리하는 메서드.
 * - me != uSeq일 경우
 *   => 해당 uSeq에 대해 오디오 consume 종료.
 * - me == uSeq일 경우
 *   => isSelectedAudio 해제(isSelectedAudio = false) 및 모든 오디오 consume 종료해야 함.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const stopHandsUpAudioConsume = async (lSeq, uSeq) => {
    // console.log(`stopHandsUpAudioConsume - lSeq[${lSeq}], uSeq[${uSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq) {
        if (uSeq === handsUpClientInfo.userSeq) {
            try {
                await unsubscribeHandsUpAudio();    // audio select 해제인 경우이기 때문에 모두 unsubscribe한다 by hjkim 20210315
                if (!handsUpClientInfo.isP2PMode) {
                    await setUnselectedMode();      // 선생님 audio listen, mic mute ** 중요 by hjkim 20220215
                }
            } catch (err) {
                handleDOMException("stopHandsUpAudioConsume()", err);
            } finally {
                handsUpClientInfo.isSelectedAudio = false;
            }
        } else {
            if (uSeq !== undefined && uSeq !== null && uSeq >= 0) {
                handsUpClientInfo.list_audioConsumeUserSeq = handsUpClientInfo.list_audioConsumeUserSeq.filter(userSeq => userSeq !== uSeq); // audio select user list 에서 빼기 by hjkim 20210325
                if (handsUpClientInfo.isSelectedAudio) {    // audio가 이미 select되었을 경우에만... by hjkim 20210315
                    try {
                        await unsubscribeHandsUpAudio(uSeq, false);
                    } catch (err) {
                        handleDOMException("stopHandsUpAudioConsume()", err);
                    }
                }
            }
        }
    }
}

/**
 * 마이캠(MyCam)용 비디오 스트림 입력을 변경하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {Boolean} status - 상태값
 */
export const changeMyCamViewInput = (lSeq, uSeq, status) => {
    // console.log(`changeMyCamViewInput - lSeq[${lSeq}], uSeq[${uSeq}], status[${status}]`);
    if (isIOSWebView() && changeIOSRelayMyCam({ info: handsUpClientInfo, setScreenImage: setScreenModeImage }, lSeq, uSeq, status)) return; // 20261026 [IOS-RELAY] iOS 앱 relay 중이면 앱 카메라 MyCam
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        if (status) {
            if (handsUpClientInfo.videoInputInfo.list_videoInput.length <= 0) {
                alert("사용 가능한 카메라가 없어 마이 캠을 실행할 수 없습니다. (Code.HC265.4)");
                return;
            }

            handsUpClientInfo.videoInputInfo.isMyCamRunning = true;
            setUpMyCamStream();
        } else {
            if (handsUpClientInfo.videoInputInfo.isMyCamRunning) handsUpClientInfo.videoInputInfo.isMyCamRunning = false;

            if (handsUpClientInfo.myCamEl !== undefined && handsUpClientInfo.myCamEl !== null) {
                if (handsUpClientInfo.myCamEl.srcObject !== undefined && handsUpClientInfo.myCamEl.srcObject !== null) {
                    handsUpClientInfo.myCamEl.srcObject.getTracks().forEach(track => {
                        track.stop();
                    });

                    handsUpClientInfo.myCamEl.srcObject = null;
                }
            }

            handsUpClientInfo.videoInputInfo.myCamIndex = -1;
            handsUpClientInfo.videoInputInfo.myCamMediaInfo = { deviceId: null, groupId: null, label: null };

            handsUpClientInfo.handsUpFunc("myCam_invisible");

            // 앱 연결 이미지 표기를 위해 한번 더 호출
            if (isAndroidWebView() || isIOSWebView()) {
                setScreenModeImage("connect");
            }
        }
    }
}

/**
 * 마이캠(MyCam)용 카메라 비디오 스트림을 정리하는 메서드.
 * 
 * @since 2025-10-29.
 */
export const clearMyCamViewInput = () => {
    if (isIOSWebView() && clearIOSRelayMyCam(handsUpClientInfo)) return; // 20261026 [IOS-RELAY] 앱 카메라 MyCam 은 트랙을 멈추지 않고 정리
    if (handsUpClientInfo.videoInputInfo.isMyCamRunning) {
        handsUpClientInfo.videoInputInfo.isMyCamRunning = false;
        if (handsUpClientInfo.myCamEl.srcObject !== undefined && handsUpClientInfo.myCamEl.srcObject !== null) {
            handsUpClientInfo.myCamEl.srcObject.getTracks().forEach(track => {
                track.stop();
            });

            handsUpClientInfo.myCamEl.srcObject = null;
        }

        // ★ myCamIndex 초기화 추가
        // changeMyCamViewInput(false)와 동일하게 -1로 리셋해야
        // 다음 마이캠 실행 시 올바른 인덱스(0부터)로 카메라를 선택함
        handsUpClientInfo.videoInputInfo.myCamIndex = -1;
        handsUpClientInfo.videoInputInfo.myCamMediaInfo = { deviceId: null, groupId: null, label: null };
    }
}

/**
 * 공유 화면 바꿈 버튼의 disabled 상태를 변경한다.
 * 
 * @param {Boolean} disabled - 비활성화 여부
 * @since 2025-10-29.
 */
const handleHandsUpVideoBtn = (disabled) => {
    const changeButton = document.getElementById("btnChangeViewKind");
    if (disabled) {
        if (changeButton && changeButton.disabled) {
            console.log("already disabled........ button..");
            return;
        }
    }

    if (changeButton) changeButton.disabled = disabled;
}

/**
 * 공유할 핸즈업 비디오 스트림 입력을 변경하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const changeHandsUpVideoInput = async (lSeq, uSeq) => {
    if (relayLive.changeVideo(handsUpClientInfo, lSeq, uSeq, handleHandsUpVideoBtn, clearMyCamViewInput)) return; // 20261020 C3는 세션을 유지하고 영상 입력만 교체
    // console.log(`changeHandsUpVideoInput - lSeq[${lSeq}], uSeq[${uSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        // 20260203 ... 안드로이드 웹뷰 모드 구분하는 로직으로 수정 ... by hjkim
        if (isAndroidWebView() || isIOSWebView()) { // for Android Pentalk Browser Pro 앱
            handsUpClientInfo.beforeViewKind = handsUpClientInfo.viewKind;

            // 20261023 [IOS-RELAY] iOS 앱 relay 연결 중이면 앱 카메라로 전환(스크린>전면>후면>스크린), 아니면 아래 기존 경로
            if (isIOSWebView() && isIOSRelayCameraReady() && await switchIOSRelayVideo({ info: handsUpClientInfo, setBtnDisabled: handleHandsUpVideoBtn, clearMyCam: clearMyCamViewInput, setScreenImage: setScreenModeImage, syncCameraPackets: syncIOSCameraStatePackets })) return;

            handleHandsUpVideoBtn(true); // 공유 화면 버튼 disabled 처리
            clearMyCamViewInput(); // 마이캠뷰 클리어

            console.log("changeHandsUpVideoInput - isDevVersion[" + isDevVersion() + "], checkAndroidCameraValue[" + checkAndroidCameraValue() + "]");

            // 수정 코드 ... by hjkim 20251103
            let idx = handsUpClientInfo.videoInputInfo.selectedIndex;

            // 20260730 ... Android WebView는 카메라를 하나의 논리 장치로 제공하므로 facingMode로 전면 -> 후면 -> 스크린 순서를 관리 ... by hjkim
            if (isAndroidWebView()) {
                if (handsUpClientInfo.beforeViewKind === "SCREEN") {
                    idx = 0; // 마이캠과 동일하게 0번 전면 카메라 우선
                    handsUpClientInfo.videoInputInfo.androidFacingMode = "user";
                } else if (handsUpClientInfo.beforeViewKind === "CAMERA" && handsUpClientInfo.videoInputInfo.androidFacingMode !== "environment") {
                    const frontDeviceId = handsUpClientInfo.videoInputInfo.androidFrontDeviceId;
                    const rearIndex = handsUpClientInfo.videoInputInfo.list_videoInput.findIndex(info => info.deviceId && info.deviceId !== frontDeviceId);
                    idx = rearIndex > -1 ? rearIndex : 0; // 재조회된 목록에서 전면과 deviceId가 다른 첫 번째 후면 장치 요청
                    handsUpClientInfo.videoInputInfo.androidFacingMode = "environment";
                } else {
                    idx = handsUpClientInfo.videoInputInfo.list_videoInput.length; // 아래 기존 범위 체크에서 스크린으로 전환
                    handsUpClientInfo.videoInputInfo.androidFacingMode = null;
                }
            } else {
                idx++;
            }

            isReconnMode = false;

            // iOS는 기기에 따라 카메라가 3개 이상 잡히는 경우가 있어(전면/후면/전면-확대 등),
            // 전면 -> 후면 -> 스크린 순서가 되도록 최대 2개(전면/후면)까지만 사용한다.
            const maxCameraCount = isIOSWebView() ?
                Math.min(2, handsUpClientInfo.videoInputInfo.list_videoInput.length)
                : handsUpClientInfo.videoInputInfo.list_videoInput.length;

            if (idx < maxCameraCount) {
                handsUpClientInfo.videoInputInfo.selectedIndex = idx;
                handsUpClientInfo.viewKind = "CAMERA";
            } else {
                handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                handsUpClientInfo.viewKind = "SCREEN";
            }

            await clearVideoInput(); // 비디오 소스 클리어

            // ✅ 중요: 카메라 하드웨어 리소스 완전 해제 대기
            // Android 카메라 HAL이 리소스를 완전히 해제하는 시간 확보
            const cameraReleaseDelay = isIOSWebView() ? 100 : 300;
            console.log(`⏳ 카메라 리소스 해제 대기 중 (${cameraReleaseDelay}ms)...`);
            await new Promise(resolve => setTimeout(resolve, cameraReleaseDelay));
            console.log("✅ 카메라 리소스 해제 대기 완료");

            // 20251014 ... 임시 처리 --- 리얼 commit용과 테스트용 구분을 위해 추가 ... by hjkim
            // viewKind 값을 바꿨는데, 기존 viewKind 값과 같은 것이 만족한다는 건 아직 camera 차례라는 뜻
            // 현재 카메라 모드이고, Android 앱이 사용 가능한 상태일 경우
            // 아직 테스트 단계에서만 해당 코드 실행되도록 수정 ... by hjkim 20251029
            // viewKind 값을 바꿨는데, 기존 viewKind 값과 같은 것이 만족한다는 건 아직 camera 차례라는 뜻
            console.log("changeHandsUpVideoInput - viewKind[" + handsUpClientInfo.viewKind + "], beforeViewKind[" + handsUpClientInfo.beforeViewKind + "], checkAndroidCameraValue[" + checkAndroidCameraValue() + "]");
            if (handsUpClientInfo.viewKind === handsUpClientInfo.beforeViewKind && handsUpClientInfo.viewKind === "CAMERA") { // 기존 & 현재 동일하고, 다음도 카메라 모드인 경우
                // unpublish 하지 않고, replace되도록 기존 로직 호출
                console.log("(1) call setUpVideoStream");
                handsUpClientInfo.beforeViewKind = null; // 초기화

                // ✅ 카메라 간 전환도 약간의 지연 필요
                await new Promise(resolve => setTimeout(resolve, 100));
                setUpVideoStream(false);
            } else {
                if (handsUpClientInfo.viewKind !== handsUpClientInfo.beforeViewKind) {
                    // 기존 screen이고, 다음 viewKind가 camera인 경우 여기서 호출하지 않고, 미디어 서버에서 callback 받은 후 카메라 스트림 호출하도록 처리하기
                    if (handsUpClientInfo.beforeViewKind === "SCREEN") {
                        console.log("(1) changeHandsUpVideoInput - stream 체크 필요 없음!");

                        window.isHandsUpInit = false;
                        window.isNeedCallOnScreen = false;

                        console.log("setUpVideoStream call after media server callback.");
                        console.log("changeHandsUpVideoInput - send ct_StopScreenCapture");

                        // ✅ 스크린 캡처 중지 명령 전송
                        if (isAndroidWebView()) {
                            xmitCmd_AndroidMessage("ct_StopScreenCapture", enTokenCMD.NULL);
                        } else if (isIOSWebView()) {
                            sendChangeViewKindToApp();
                        }

                        // ✅ 중요: 스크린 캡처 서비스가 완전히 중지될 때까지 대기
                        // Native 코드에서 VirtualDisplay, MediaProjection 해제 시간 확보
                        const screenStopDelay = isIOSWebView() ? 150 : 400;
                        console.log(`⏳ 스크린 캡처 중지 대기 중 (${screenStopDelay}ms)...`);
                        await new Promise(resolve => setTimeout(resolve, screenStopDelay));
                        console.log("✅ 스크린 캡처 중지 완료");

                        // ✅ 카메라 스트림은 unpublish 콜백에서 시작됨
                    } else {
                        // 기존 카메라이고, 다음 viewKind가 screen인 경우
                        if (handsUpClientInfo.sendAudioStream || handsUpClientInfo.sendVideoStream) {
                            // 여기서 호출하지않고, unpublish 하고, 미디어서버에서 callback 받은 후 앱 호출하도록 처리하기
                            console.log("setUpVideoStream call after media server callback.");
                            handsUpClientInfo.beforeViewKind = null; // 초기화

                            window.isNeedCallOnScreen = true;
                            window.isHandsUpInit = false;

                            console.log("changeHandsUpVideoInput - call sendUnpublish('ALL')");

                            // ✅ unpublish 호출
                            await sendUnpublish("ALL"); // 모든 stream 정리

                            // ✅ 중요: unpublish가 서버에서 처리될 때까지 대기
                            console.log("⏳ unpublish 서버 처리 대기 중 (200ms)...");
                            await new Promise(resolve => setTimeout(resolve, 200));
                            console.log("✅ unpublish 처리 완료");
                        } else {
                            // 기존 로직 호출되어야 할 듯...
                            window.isHandsUpInit = false;
                            window.isNeedCallOnScreen = false;

                            console.log("(3) call setUpVideoStream");
                            handsUpClientInfo.beforeViewKind = null; // 초기화

                            // ✅ 약간의 안전 지연
                            await new Promise(resolve => setTimeout(resolve, 100));
                            setUpVideoStream(false);
                        }
                    }
                } else {
                    // 동일한 viewKind (거의 발생 안 함)
                    console.log("(4) viewKind 변경 없음 - 기존 로직");

                    // 이런 경우가 있을까..?ㅁ? 혹시 모르니 기존 로직 호출
                    window.isHandsUpInit = false;
                    window.isNeedCallOnScreen = false;

                    console.log("(5) call setUpVideoStream");
                    handsUpClientInfo.beforeViewKind = null; // 초기화

                    await new Promise(resolve => setTimeout(resolve, 100));
                    setUpVideoStream(false);
                }
            }
        } else { // PC or 크롬 접속 (기존 코드)
            handleHandsUpVideoBtn(true); // 공유 화면 버튼 disabled 처리
            clearMyCamViewInput(); // 마이캠뷰 클리어

            // await clearImgSendProc();

            let idx = handsUpClientInfo.videoInputInfo.selectedIndex;
            idx++;

            isReconnMode = false;

            if (idx < handsUpClientInfo.videoInputInfo.list_videoInput.length) {
                handsUpClientInfo.videoInputInfo.selectedIndex = idx;
                handsUpClientInfo.viewKind = "CAMERA";
            } else {
                handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                handsUpClientInfo.viewKind = "SCREEN";
            }

            // 20260313 viewKind를 바꾸는 경우, sendAudioStream이 null이 아니면 시스템 오디오 소리를 항상 정리하도록 수정 ... by hjkim
            console.log("changeHandsUpVideoInput - handsUpClientInfo.isSysConnectFlag[", handsUpClientInfo.isSysConnectFlag, "]");
            if (handsUpClientInfo.isSysConnectFlag) {
                // 먼저 시스템 오디오 리소스를 정리
                await clearSystemStreamSource();

                console.log(`changeHandsUpVideoInput - isMicOn[${handsUpClientInfo.isMicOn}], isMicConnectFlag[${handsUpClientInfo.isMicConnectFlag}], hasMicAudio[${handsUpClientInfo.hasMicAudio}]`);
                if (handsUpClientInfo.isMicOn && handsUpClientInfo.isMicConnectFlag) {
                    await gotAudioStream("mic");
                } else {
                    await gotAudioStream("empty");
                }
            }

            await clearVideoInput(); // 비디오 소스 클리어

            // ✅ 중요: 카메라 하드웨어 리소스 완전 해제 대기
            // 카메라 리소스를 완전히 해제하는 시간 확보
            console.log("⏳ 카메라 리소스 해제 대기 중 (300ms)...");
            await new Promise(resolve => setTimeout(resolve, 300));
            console.log("✅ 카메라 리소스 해제 대기 완료");

            console.log(`changeHandsUpVideoInput - viewKind[${handsUpClientInfo.viewKind}], selectedIndex[${handsUpClientInfo.videoInputInfo.selectedIndex}], list_videoInput => `, handsUpClientInfo.videoInputInfo.list_videoInput);
            setUpVideoStream(false);
        }
    }
}

/**
 * 핸즈업 화면 공유 유형(viewKind) 변경 메서드.
 * 
 * @param {String} viewKind - 화면 공유 유형
 */
export const changeViewKind = (viewKind) => {
    // console.log(`changeViewKind - viewKind[${viewKind}], handsUpClientInfo.viewKind[${handsUpClientInfo.viewKind}]`);
    handsUpClientInfo.viewKind = viewKind;
}

/**
 * 현재 viewKind 값을 반환하는 메서드.
 * 
 * @returns {String} viewKind 문자열
 * @since 2025-12-19.
 */
export const getViewKind = () => {
    console.log(`getViewKind - handsUpClientInfo.viewKind[${handsUpClientInfo.viewKind}]`);
    return handsUpClientInfo.viewKind;
}

/**
 * HandsUp 클라이언트에 저장된 클래스 번호 시퀀스를 반환하는 메서드.
 * 
 * @returns {Number} 클래스 번호 시퀀스
 * @since 2025-12-19.
 */
export const getHandsUpLiveSeq = () => {
    return handsUpClientInfo.liveSeq;
}

/**
 * HandsUp 클라이언트에 저장된 사용자 번호 시퀀스를 반환하는 메서드.
 * 
 * @returns {Number} 사용자 번호 시퀀스
 * @since 2025-12-19.
 */
export const getHandsUpUserSeq = () => {
    return handsUpClientInfo.userSeq;
}

/**
 * HandsUp 클라이언트에 저장된 현재 P2P 스트리밍 모드를 반환
 * 
 * @returns {Number} P2P 스트리밍 모드를 반환
 * @since 2025-12-24.
 */
export const getLocalStreamingMode = () => {
    return handsUpClientInfo.localStreamingMode;
}

/**
 * 핸즈업 마이크 켜기/끄기 모드 설정 메서드.
 * 
 * @param {Boolean} isMicOn - 핸즈업 마이크 켜기/끄기 여부
 */
export const changeHandsUpMicMode = (isMicOn) => {
    console.log(`changeHandsUpMicMode - isMicOn[${isMicOn}], handsUpClientInfo.isMicOn[${handsUpClientInfo.isMicOn}]`);
    handsUpClientInfo.isMicOn = isMicOn;
}

/**
 * 재연결 모드 여부인지 아닌지 설정 메서드.
 * 
 * @param {Boolean} isReconn - 재연결 모드인지 여부
 */
export const updateReconnMode = (isReconn) => {
    // console.log(`updateReconnMode - isReconnMode[${isReconnMode}], isReconnMode[${isReconn}]`);
    isReconnMode = isReconn;
}

/**
 * 마이크 켜기 / 마이크 오디오 스트림 활성화 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpMicOn = async (lSeq, uSeq) => {
    console.log(`setHandsUpMicOn() - lSeq[${lSeq}], uSeq[${uSeq}]`);
    console.log(`setHandsUpMicOn() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq && !handsUpClientInfo.isMicOn) {
        if (handsUpClientInfo.isMicDisable) return;

        // 20260313 마이크 on/off 버튼을 클릭한 경우만 isMicOn = true, isMuteMode = false 로 설정
        handsUpClientInfo.isMicOn = true;
        handsUpClientInfo.isMuteMode = false;
        if (relayLive.sound(true, enableAudioTrack, disableAudioTrack)) { await setHandsUpMicStatus(lSeq, uSeq, true); return; } // 20261020 기존 소리 공유 전체 on/off

        if (handsUpClientInfo.isPblGroupProAudioMode) {
            // 20260910 PBLGroup: 일반 RBMQ 상태 수신 시 PBL Group producer track만 제어한다.
            console.log("setHandsUpMicOn case 2-1 - call setPblGroupAudioTrackEnabled(true)");
            await setPblGroupAudioTrackEnabled(true);

            console.log("setHandsUpMicOn case 2-2 - call sendP2PSoundOn(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOn(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 켜진 것처럼 선생님께 메시지는 그대로 보냄

            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
            return;
        }

        // handsUpClientInfo.isMicOn = true;
        // if (!handsUpClientInfo.isMuteMode) handsUpClientInfo.isMuteMode = true;

        // 20260310 마이크 on/off 값 일관성을 위해 viewKind 값과 상관없이 항상 전송하도록 수정 ... by hjkim
        if (isAndroidWebView()) {
            xmitCmd_AndroidMessage("ct_MicOn", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
            }
        } else if (isIOSWebView()) {
            xmitCmd_IosMessage("ct_MicOn", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
            }
        }

        // 20260313 sendAudioStream 이 null 이 아닌 경우 audio track 을 enabled 해야 한다.
        if (handsUpClientInfo.isMicConnectFlag && handsUpClientInfo.micStreamSource !== null && handsUpClientInfo.sendAudioStream !== null) {
            console.log("/////// 처음으로 마이크 on/off 버튼을 클릭한 경우에만 불리나요? //////");

            // enableAudioTrack();

            // 시스템 오디오 리소스를 가지고 있다면 다시 연결
            if (handsUpClientInfo.hasSystemAudio) {
                await gotAudioStream("mic+display");
            } else {
                await gotAudioStream("mic");
            }

            // 20260313 isMuteMode = false인 경우 마이크 상태값도 보내야 한다 ... by hjkim
            console.log("setHandsUpMicOn case 1-1 - call enableAudioTrack()");
            initHandsUpMicVolumeSendProc(handsUpClientInfo.sendAudioStream);

            console.log("setHandsUpMicOn case 1-2 - call sendP2PSoundOn(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOn(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 켜진 것처럼 선생님께 메시지는 그대로 보냄

            // 현재 마이크 상태에 맞는 마이크 UI 업데이트 요청
            console.log("call changeHandsUpStatusInfo case 3");

            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
        } else {
            console.log("/////// 처음 마이크 on/off 버튼을 클릭한 경우가 아닐때만 불리나요? //////");

            console.log("setHandsUpMicOn case 2 - call setUpMicAudioStream(false)");
            await setUpMicAudioStream(false);
        }

        /* if (handsUpClientInfo.isMicDisable) {
            console.log("call changeHandsUpStatusInfo case 2");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "muteDisable" }));
        } else {
            console.log("call changeHandsUpStatusInfo case 3");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
        } */
    }
}

/**
 * 마이크 끄기 / 마이크 오디오 스트림 비활성화 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpMicOff = async (lSeq, uSeq) => {
    console.log(`setHandsUpMicOff() - lSeq[${lSeq}], uSeq[${uSeq}]`);
    console.log(`setHandsUpMicOff() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq && handsUpClientInfo.isMicOn) {
        if (handsUpClientInfo.isMicDisable) return;

        // 20260313 마이크 on/off 버튼을 클릭한 경우만 isMicOn = false, isMuteMode = true로 설정
        handsUpClientInfo.isMicOn = false;
        handsUpClientInfo.isMuteMode = true; // mic를 끄는 경우 mute값 초기화
        if (relayLive.sound(false, enableAudioTrack, disableAudioTrack)) { await setHandsUpMicStatus(lSeq, uSeq, false); return; } // 20261020 기존 소리 공유 전체 on/off

        if (handsUpClientInfo.isPblGroupProAudioMode) {
            // 20260910 PBLGroup: 일반 RBMQ 상태 수신 시 producer를 유지하고 track만 끈다.
            console.log("setHandsUpMicOff case 2-1 - call setPblGroupAudioTrackEnabled(false)");
            await setPblGroupAudioTrackEnabled(false);

            // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄
            console.log("setHandsUpMicOff case 2-2 - call sendP2PSoundOff(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq);

            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
            return;
        }

        await clearMicVolumeSendProc(); // 공통

        // 20260310 마이크 on/off 값 일관성을 위해 viewKind 값과 상관없이 항상 전송하도록 수정 ... by hjkim
        if (isAndroidWebView()) {
            xmitCmd_AndroidMessage("ct_MicOff", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
            }
        } else if (isIOSWebView()) {
            xmitCmd_IosMessage("ct_MicOff", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 sendUnpublish 호출되지 않도록 반환 ... by hjkim
            }
        }

        /* window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
        sendUnpublish("audio");
        sendP2PSoundOff(lSeq, uSeq); */

        console.log("setHandsUpMicOff - call disableAudioTrack()");
        disableAudioTrack(); // 기존처럼 unpublish 하지 않고, audioTrack을 enabled = false로 설정

        sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄

        console.log("call changeHandsUpStatusInfo case 5");
        let store = window.hiclasstv.store;
        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));

        /* if (handsUpClientInfo.isMicDisable) {
            console.log("call changeHandsUpStatusInfo case 4");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
        } else {
            console.log("call changeHandsUpStatusInfo case 5");
            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
        } */
    }
}

/**
 * isAndroidWebView 또는 isIOSWebView 로 접속한 경우,
 * 앱의 마이크(시스템 오디오 포함) 상태에 맞춰서
 * 마이크 버튼 UI 상태 설정 및 선생님에게 메시지를 전송하는 메서드.
 * - 앱에서 마이크 상태 설정 후 웹의 콜백 호출 시 실행됨.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {Boolean} status - 상태값
 */
export const setHandsUpMicStatus = async (lSeq, uSeq, status) => {
    console.log(`setHandsUpMicStatus() - lSeq[${lSeq}], uSeq[${uSeq}], status[${status}]`);
    console.log(`setHandsUpMicStatus() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq) {
        relayLive.sound(status, enableAudioTrack, disableAudioTrack); // 20261020 앱/선생님 소리 상태도 기존 전체 track 제어
        // 20260310 수정 코드
        // if (handsUpClientInfo.isMicDisable) return;

        // 20250220 혹시 모르니 mic volume 보내는 process 멈춤 ... by hjkim
        // isAndroidWebView 또는 isIOSWebView 인 경우 스크린 모드에서 mic volume 프로세스 필요없음
        await clearMicVolumeSendProc();

        let store = window.hiclasstv.store;

        if (handsUpClientInfo.isMicDisable) { // 비활성화 상태인 경우
            // handsUpClientInfo.isMicOn = false;
            // handsUpClientInfo.isMuteMode = true;    // 비활성화 상태인 경우, 항상 초기화 ... by hjkim 20260310

            // 비활성화 상태인 경우, 항상 mic off 상태라고 알림 ... by hjkim 20260310
            console.log("setHandsUpMicStatus case 1 - call sendP2PSoundOff(" + lSeq + ", " + uSeq + ")");
            sendP2PSoundOff(lSeq, uSeq); // 선생님께 앱의 마이크가 꺼졌다고 알림

            // 비활성화 상태인 경우에도 마이크 상태 UI는 전달받은 status 값에 따라 달라야 함 ... by hjkim 20260310
            if (status) {
                console.log("call changeHandsUpStatusInfo case 6");
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "muteDisable" }));
            } else {
                console.log("call changeHandsUpStatusInfo case 7");
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
            }
        } else {
            // 활성화 상태인 경우, 전달받은 status 값에 따라 다르게 동작해야 함 ... by hjkim
            if (status) {
                // handsUpClientInfo.isMicOn = true;
                // handsUpClientInfo.isMuteMode = false;   // 앱에서 마이크가 켜졌고, track을 mute 하지도 않음

                console.log("setHandsUpMicStatus case 2 - call sendP2PSoundOn(" + lSeq + ", " + uSeq + ")");
                sendP2PSoundOn(lSeq, uSeq); // 선생님께 앱의 마이크가 켜졌다고 알림

                console.log("call changeHandsUpStatusInfo case 8");
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
            } else {
                // handsUpClientInfo.isMicOn = false;
                // handsUpClientInfo.isMuteMode = true; // mic를 끄는 경우 mute값 초기화

                sendP2PSoundOff(lSeq, uSeq); // 선생님께 앱의 마이크가 꺼졌다고 알림

                console.log("call changeHandsUpStatusInfo case 9");
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
            }
        }
    }
}

/**
 * 마이크 버튼 비활성화 설정 메서드.
 * - 만약 오디오 프로듀서에서 오디오 트랙을 가지고 있다면, 비활성화하도록 설정해야 함.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpMicDisable = async (lSeq, uSeq) => {
    console.log(`setHandsUpMicDisable() - lSeq[${lSeq}], uSeq[${uSeq}], isHandsUpInit[${window.isHandsUpInit}]`);
    console.log(`setHandsUpMicDisable() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);
    if (lSeq === handsUpClientInfo.liveSeq) {

        // 크롬 업데이트 이슈로 audio stream이 없는 경우, 화면 공유 모드 전환 시 오류가 발생하므로
        // 기존처럼 sendUnpublish("audio")를 하면 안 됨 ... by hjkim 20251017
        handsUpClientInfo.isMicDisable = true;

        // isMicDisable = true 이면 마이크 상태 값을 초기화
        handsUpClientInfo.isMicOn = false;
        handsUpClientInfo.isMuteMode = true;

        if (handsUpClientInfo.isPblGroupProAudioMode) {
            // 20260910 PBLGroup: DISABLE_MIC은 기존 producer를 유지한 채 track만 끈다.
            await setPblGroupAudioTrackEnabled(false);

            console.log("setHandsUpMicDisable case 2-2 - call sendP2PSoundOff(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄

            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
            return;
        }

        await clearMicVolumeSendProc(); // 실제로 마이크가 꺼진 것처럼 mic volume 보내는 process도 멈춤

        // 20260310 마이크 on/off 값 일관성을 위해 viewKind 값과 상관없이 항상 전송하도록 수정 ... by hjkim
        if (isAndroidWebView()) {
            xmitCmd_AndroidMessage("ct_MicOff", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 setUpMicAudioStream 호출되지 않도록 반환 ... by hjkim
            }
        } else if (isIOSWebView()) {
            xmitCmd_IosMessage("ct_MicOff", enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 sendUnpublish 호출되지 않도록 반환 ... by hjkim
            }
        }

        if (handsUpClientInfo.sendAudioStream != null) {
            console.log("setHandsUpMicDisable - call disableAudioTrack()");
            disableAudioTrack(); // 기존처럼 unpublish 하지 않고, audioTrack을 enabled = false로 설정
        }

        console.log("setHandsUpMicDisable case 2-1 - call sendP2PSoundOff(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
        sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄

        console.log("call changeHandsUpStatusInfo case 10");
        let store = window.hiclasstv.store;
        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
        // store.dispatch(changeHandsUpStatusInfo({ kind: "mic-mode", status: "disable" }));
    }
}

/**
 * 마이크 버튼 활성화 설정 메서드.
 * - 만약 오디오 프로듀서에서 오디오 트랙을 가지고 있다면, 다시 활성화하도록 설정해야 함.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
export const setHandsUpMicEnable = async (lSeq, uSeq) => {
    console.log(`setHandsUpMicEnable() - lSeq[${lSeq}], uSeq[${uSeq}], isHandsUpInit[${window.isHandsUpInit}]`);
    console.log(`setHandsUpMicEnable() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);
    if (lSeq === handsUpClientInfo.liveSeq) {
        // 20260310 수정 코드
        handsUpClientInfo.isMicDisable = false;

        // isMicOn & isMuteMode 은 mic on/off 버튼 클릭 시에 값 바꾸도록 수정
        // handsUpClientInfo.isMuteMode = false;
        // handsUpClientInfo.isMicOn = true;

        if (handsUpClientInfo.isPblGroupProAudioMode) {
            // 20260917 track을 enable 처리하지 않고, off 상태를 유지하도록 수정
            if (handsUpClientInfo.isMicOn) {
                handsUpClientInfo.isMicOn = false;
                handsUpClientInfo.isMuteMode = true;

                await setPblGroupAudioTrackEnabled(false);
            }

            console.log("setHandsUpMicDisable case 2-3 - call sendP2PSoundOff(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄

            let store = window.hiclasstv.store;
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
            return;
        }

        let store = window.hiclasstv.store;
        let action = handsUpClientInfo.isMicOn ? "ct_MicOn" : "ct_MicOff";
        console.log("setHandsUpMicEnable() - action[", action, "]");

        // 20260310 마이크 on/off 값 일관성을 위해 viewKind 값과 상관없이 항상 전송하도록 수정 ... by hjkim
        if (isAndroidWebView()) {
            xmitCmd_AndroidMessage(action, enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 sendAudioStream 체크하지 않도록 반환 ... by hjkim
            }
        } else if (isIOSWebView()) {
            xmitCmd_IosMessage(action, enTokenCMD.NULL);

            if (handsUpClientInfo.viewKind === "SCREEN") { // 20260310 스크린 모드일 경우에만 동작하도록 수정
                handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
                return; // 스크린일 경우 아래 sendAudioStream 체크하지 않도록 반환 ... by hjkim
            }
        }

        // 20260313 sendAudioStream 이 null 이 아니고, isMuteMode = false인 경우 audio track 을 enabled 해야 한다.
        if (!handsUpClientInfo.isMuteMode && handsUpClientInfo.sendAudioStream !== null) {
            console.log("setHandsUpMicEnable case 1 - call enableAudioTrack()");
            enableAudioTrack();

            // 20260313 isMuteMode = false인 경우 마이크 상태값도 보내야 한다 ... by hjkim
            console.log("setHandsUpMicEnable case 1-1 - call enableAudioTrack()");
            initHandsUpMicVolumeSendProc(handsUpClientInfo.sendAudioStream);

            console.log("setHandsUpMicEnable case 1-2 - call sendP2PSoundOn(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOn(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 켜진 것처럼 선생님께 메시지는 그대로 보냄

            // 현재 마이크 상태에 맞는 마이크 UI 업데이트 요청
            console.log("call changeHandsUpStatusInfo case 11-1");
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
        } else {
            // 20260310 sendAudioStream 이 null이면 굳이 마이크를 켜지 않고, 현재 마이크 상태인 off 메시지를 보내야 한다 ... by hjkim
            console.log("setHandsUpMicEnable case 2 - call sendP2PSoundOff(" + lSeq + ", " + handsUpClientInfo.userSeq + ")");
            sendP2PSoundOff(lSeq, handsUpClientInfo.userSeq); // 실제로 마이크가 꺼진 것처럼 선생님께 메시지는 그대로 보냄

            // 현재 마이크 상태에 맞는 마이크 UI 업데이트 요청
            console.log("call changeHandsUpStatusInfo case 11-2");
            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
        }
    }
}

/**
 * 내가 보내는 오디오 스트림을 선생님이 듣고 있지 않음을
 * 나에게 알려준 경우를 표시하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
/* export const setHandsUpSoundMuteMode = (lSeq, uSeq) => {
    console.log(`setHandsUpSoundMuteMode() - lSeq[${lSeq}], uSeq[${uSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq && !handsUpClientInfo.isMuteMode) {
        handsUpClientInfo.isMuteMode = true;

        console.log("setHandsUpSoundMuteMode - call disableAudioTrack()");
        disableAudioTrack();

        console.log("call changeHandsUpStatusInfo case 13");
        let store = window.hiclasstv.store;
        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
    }
} */

/**
 * 내가 보내는 오디오 스트림을 선생님이 듣고 있음을
 * 나에게 알려준 경우를 표시하는 메서드.
 * 
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 */
/* export const setHandsUpSoundListenMode = (lSeq, uSeq) => {
    // console.log(`setHandsUpSoundListenMode() - lSeq[${lSeq}], uSeq[${uSeq}]`);
    if (lSeq === handsUpClientInfo.liveSeq && uSeq === handsUpClientInfo.userSeq && handsUpClientInfo.isMuteMode) {
        handsUpClientInfo.isMuteMode = false;

        console.log("setHandsUpSoundListenMode - call enableAudioTrack()");
        enableAudioTrack();

        console.log("call changeHandsUpStatusInfo case 14");
        let store = window.hiclasstv.store;
        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "listen" }));
    }
} */

/** media source */
/**
 * 사용할 수 있는 미디어 장치 정보 목록을 요청한다.
 * 
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용 
 */
const updateMediaDevices = async (isHandsUpInit) => {
    console.log(`updateMediaDevices - isHandsUpInit[${isHandsUpInit}]..... window.isHandsUpInit[${window.isHandsUpInit}]`);

    // 20260730 ... Android WebView 핸즈업 초기화 시 카메라 권한 획득 후 재조회 상태를 초기화 ... by hjkim
    if (isHandsUpInit === true && isAndroidWebView()) {
        handsUpClientInfo.videoInputInfo.androidDevicesRefreshed = false;
        handsUpClientInfo.videoInputInfo.androidFacingMode = null;
        handsUpClientInfo.videoInputInfo.androidFrontDeviceId = null;
    }

    if (isHandsUpInit === true && isIOSWebView()) {
        handsUpClientInfo.videoInputInfo.iosDevicesRefreshed = false;
    }

    const changeButton = document.getElementById("btnChangeViewKind");
    if (isIOSWebView() && changeButton && changeButton.disabled && !window.isHandsUpInit) return;
    console.log("너 여기서 불리니?");

    if (navigator !== undefined && navigator !== null) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            alert("enumerateDevices()를 지원하지 않습니다.");
            handsUpClientInfo.videoInputInfo.list_videoInput = [];
            handsUpClientInfo.videoInputInfo.selectedIndex = -1;
            handsUpClientInfo.viewKind = "SCREEN";
            // return;

            await initHandsUpMic(isHandsUpInit);
            setUpVideoStream(isHandsUpInit);
        } else {
            let mediaDevices = null;

            try {
                // getSupportedConstraints();
                mediaDevices = await navigator.mediaDevices.enumerateDevices();
            } catch (err) {
                handleDOMException("updateMediaDevices()", err);
            } finally {
                setMediaDevicesInfo(mediaDevices, isHandsUpInit);
            }
        }
    } else {
        handleLogMessage("updateMediaDevices()", "navigator", navigator);
        alert("비대면 기능을 지원하지 않는 브라우저입니다. 관리자에게 문의 바랍니다. (Code.HC001.1)");
    }
}

/**
 * 사용할 수 있는 미디어 장치 정보 목록을 handsUpClientInfo에 저장.
 * 
 * @param {MediaDeviceInfo[]} mediaDevices - 미디어 디바이스 배열
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용
 */
const setMediaDevicesInfo = async (mediaDevices, isHandsUpInit) => {
    if (handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
        if (isHandsUpInit === undefined || isHandsUpInit === null) { // ondevicechange event 발생한 case ... by hjkim 20220311
            if (handsUpClientInfo.viewKind === "SCREEN" && handsUpClientInfo.videoInputInfo.selectedIndex === -1) { // screen 보내는 case ... by hjkim 20220311
                if (handsUpClientInfo.videoInputInfo.isMyCamRunning && handsUpClientInfo.videoInputInfo.myCamIndex > -1) { // myCam 실행 중에 ondevicechange event 발생한 case ... by hjkim 20220311
                    // 이 경우에는 초기화하기 전에 myCam index 기억하고 있어야 한다...
                    handsUpClientInfo.videoInputInfo.myCamMediaInfo = handsUpClientInfo.videoInputInfo.list_videoInput[handsUpClientInfo.videoInputInfo.myCamIndex];
                } else {
                    handsUpClientInfo.videoInputInfo.selectedMediaInfo = { deviceId: null, groupId: null, label: null };
                    handsUpClientInfo.videoInputInfo.myCamMediaInfo = { deviceId: null, groupId: null, label: null };
                }
            } else {
                if (handsUpClientInfo.viewKind === "CAMERA" && handsUpClientInfo.videoInputInfo.selectedIndex > -1) { // camera 보내는 case ... by hjkim 20220311
                    // 이 경우에는 초기화하기 전에 selectedIndex 기억하고 있어야 한다...
                    handsUpClientInfo.videoInputInfo.selectedMediaInfo = handsUpClientInfo.videoInputInfo.list_videoInput[handsUpClientInfo.videoInputInfo.selectedIndex];
                } else {
                    handsUpClientInfo.videoInputInfo.selectedMediaInfo = { deviceId: null, groupId: null, label: null };
                    handsUpClientInfo.videoInputInfo.myCamMediaInfo = { deviceId: null, groupId: null, label: null };
                }
            }
        }
    }

    // 값 초기화...
    handsUpClientInfo.videoInputInfo.list_videoInput = [];
    handsUpClientInfo.videoInputInfo.selectedIndex = -1;
    handsUpClientInfo.videoInputInfo.myCamIndex = -1;
    handsUpClientInfo.audioInputInfo.currentAudioInput = { deviceId: null, groupId: null, label: null };

    let isChangedDefaultAudioInput = false;
    //console.log(mediaDevices);
    
    if (mediaDevices && mediaDevices.length > 0) {
        //console.log(mediaDevices);
        for (let index = 0; index < mediaDevices.length; index++) {
            const device = mediaDevices[index];
            if (device.kind === "audioinput") {
                if (device.deviceId === "default") { // for chrome(pc, android)
                    if (!checkDefaultAudioInput(device)) { // default 시스템 오디오 변경 체크 by hjkim 20220315
                        console.log("ios log 11111 -------------- ");
                        isChangedDefaultAudioInput = true;
                        let option = { deviceId: device.deviceId, groupId: device.groupId, label: device.label };
                        handsUpClientInfo.audioInputInfo.defaultAudioInput = option;
                    } else {
                        console.log("ios log 1-1111 -------------- ");
                    }
                } else {
                    if (index === 0 && !isChangedDefaultAudioInput) { // audio input 0번째에 있지만 deviceId가 default가 아닌 경우... (ex.ios) by hjkim 20220315
                        // alert(`deviceId[${device.deviceId}], label[${device.label}], groupId[${device.groupId}]`);
                        if (!checkDefaultAudioInput(device)) { // default 시스템 오디오 변경 체크 by hjkim 20220316
                            console.log("ios log 22222 -------------- ");
                            // if (isHandsUpInit && isIOSWebView()) {
                            //     window.iosMicEventDoNotWork = false;
                            // }
                            isChangedDefaultAudioInput = true;
                            let option = { deviceId: device.deviceId, groupId: device.groupId, label: device.label };
                            handsUpClientInfo.audioInputInfo.defaultAudioInput = option;
                        } else {
                            // if (isHandsUpInit && isIOSWebView()) {
                            //     window.iosMicEventDoNotWork = true;
                            // }
                            console.log("ios log 2-1111 -------------- ");
                        }
                    } else {
                        if (isChangedDefaultAudioInput) { // default 시스템 오디오가 변경되었으므로 currentAudioInput 값도 변경하기 위해... by hjkim 20220315
                            if (checkDefaultAudioInput(device)) { // defaultAudioInput 값과 비교 by hjkim 20220315
                                console.log("ios log 33333 -------------- ");
                                let option = { deviceId: device.deviceId, groupId: device.groupId, label: device.label };
                                handsUpClientInfo.audioInputInfo.currentAudioInput = option;
                            } else {
                                console.log("ios log 3-1111 -------------- ");
                            }
                        } else {
                            console.log("ios log 44444 -------------- ");
                        }
                    }
                }
            } else if (device.kind === "videoinput") {
                // console.log("device.getCapabilities => ", device.getCapabilities());
                if (checkEnabledVideoInput(device)) {
                    let option = { deviceId: device.deviceId, groupId: device.groupId, label: device.label };
                    handsUpClientInfo.videoInputInfo.list_videoInput.push(option);
                }
            }
        }
    } else {
        handsUpClientInfo.videoInputInfo.list_videoInput = [];
    }

    console.log(`setMediaDevicesInfo - `, handsUpClientInfo.videoInputInfo.list_videoInput);

    if (isHandsUpInit === true) {
        if (handsUpClientInfo.viewKind === "CAMERA") {
            let idx = handsUpClientInfo.videoInputInfo.selectedIndex;
            idx++;

            if (idx < handsUpClientInfo.videoInputInfo.list_videoInput.length) {
                handsUpClientInfo.videoInputInfo.selectedIndex = idx;
                handsUpClientInfo.viewKind = "CAMERA";
            } else {
                handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                handsUpClientInfo.viewKind = "SCREEN";
            }
        } else {
            handsUpClientInfo.videoInputInfo.selectedIndex = -1;
            handsUpClientInfo.viewKind = "SCREEN";
        }

        await initHandsUpMic(isHandsUpInit);
        setUpVideoStream(isHandsUpInit);
    } else {
        if (isChangedDefaultAudioInput) {
            await initHandsUpMic(isHandsUpInit); // default 시스템 오디오가 바뀐 경우......by hjkim 20220314
        }

        if (handsUpClientInfo.videoInputInfo.list_videoInput && handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
            // console.log("(1) setMediaDevicesInfo - list_videoInput => ", handsUpClientInfo.videoInputInfo.list_videoInput);
            if (handsUpClientInfo.viewKind === "SCREEN" && handsUpClientInfo.videoInputInfo.isMyCamRunning) { // myCam 실행중이던 case ... by hjkim 20220311
                if (handsUpClientInfo.videoInputInfo.myCamMediaInfo.deviceId !== null) {
                    handsUpClientInfo.videoInputInfo.myCamIndex = handsUpClientInfo.videoInputInfo.list_videoInput.findIndex(info => info.deviceId === handsUpClientInfo.videoInputInfo.myCamMediaInfo.deviceId);
                    if (handsUpClientInfo.videoInputInfo.myCamIndex === -1) {
                        console.log("setMediaDevicesInfo - case 1 (change myCam)");
                        // 마이 캠 사용하던 카메라가 달라졌다는걸 알려주고 싶다.....
                        // 사용 가능한 0번 카메라를 사용
                        if (handsUpClientInfo.myCamEl) {
                            if (handsUpClientInfo.myCamEl.srcObject !== undefined && handsUpClientInfo.myCamEl.srcObject !== null) {
                                handsUpClientInfo.myCamEl.srcObject.getTracks().forEach(track => {
                                    track.stop();
                                });

                                handsUpClientInfo.myCamEl.srcObject = null;
                            }
                        }

                        handsUpClientInfo.videoInputInfo.myCamIndex++;
                        setUpMyCamStream();
                    } else {
                        // 마이 캠 사용하던 카메라 그대로 있음... 현상태 유지...
                        console.log("setMediaDevicesInfo - case 2 (not doing)");
                    }
                } else {
                    // 이런 경우가 있을 수 있으려나..?ㅁ?...
                    console.log("setMediaDevicesInfo - case 3 => ", handsUpClientInfo.videoInputInfo.myCamMediaInfo);
                }
            } else {
                if (handsUpClientInfo.viewKind === "CAMERA") { // camera 보내던 case ... by hjkim 20220311
                    if (handsUpClientInfo.videoInputInfo.selectedMediaInfo.deviceId !== null) {
                        handsUpClientInfo.videoInputInfo.selectedIndex = handsUpClientInfo.videoInputInfo.list_videoInput.findIndex(info => info.deviceId === handsUpClientInfo.videoInputInfo.selectedMediaInfo.deviceId);
                        if (handsUpClientInfo.videoInputInfo.selectedIndex === -1) {
                            console.log("setMediaDevicesInfo - case 4 (change camera)");
                            // 사용하던 카메라가 없어진 경우... 사용 가능한 카메라가 있으면 0번 카메라를 사용
                            // 사용하던 카메라가 없어진 경우... 사용 가능한 카메라가 없으면 screen 으로 변경...  => screen or canvas
                            await clearImgSendProc();

                            if (handsUpClientInfo.videoEl !== undefined && handsUpClientInfo.videoEl !== null) {
                                if (handsUpClientInfo.videoEl.srcObject !== undefined && handsUpClientInfo.videoEl.srcObject !== null) {
                                    handsUpClientInfo.videoEl.srcObject.getTracks().forEach(track => {
                                        track.stop();
                                    });

                                    handsUpClientInfo.videoEl.srcObject = null;
                                }
                            }

                            if (handsUpClientInfo.sendVideoStream !== undefined && handsUpClientInfo.sendVideoStream !== null) {
                                handsUpClientInfo.sendVideoStream.getTracks().forEach(track => {
                                    track.stop();
                                });

                                handsUpClientInfo.sendVideoStream = null;
                            }

                            handsUpClientInfo.videoInputInfo.selectedIndex++;
                            setUpVideoStream(isHandsUpInit);
                        } else {
                            // 사용하던 카메라 그대로 있음... 현상태 유지...
                            console.log("setMediaDevicesInfo - case 5 (not doing)");
                        }
                    } else {
                        // 이런 경우가 있을 수 있으려나...?ㅁ?...
                        console.log("setMediaDevicesInfo - case 6 => ", handsUpClientInfo.videoInputInfo.selectedMediaInfo);
                    }
                } else {
                    if (isIOSWebView()) {
                        console.log("setMediaDevicesInfo ---------- ios webview case");
                        handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                        handsUpClientInfo.viewKind = "SCREEN";
                        setUpVideoStream(isHandsUpInit);
                    }
                }
            }
        } else { // ondevicechange event 후 사용 가능한 mediaDevices(videoinput)가 없어진 경우... by hjkim 20220311
            // console.log("(2) setMediaDevicesInfo - list_videoInput => ", handsUpClientInfo.videoInputInfo.list_videoInput);
            if (handsUpClientInfo.viewKind === "SCREEN" && handsUpClientInfo.videoInputInfo.isMyCamRunning) { // myCam 실행중이던 case ... by hjkim 20220311
                // 마이 캠 사용 안 되는 걸 알려주자..... handsUpClientInfo.videoInputInfo.isMyCamRunning false 해야함...
                console.log("setMediaDevicesInfo - case 7");
                handsUpClientInfo.handsUpFunc("myCam_noLongerAvailable", handsUpClientInfo.videoInputInfo.myCamMediaInfo);
            } else {
                if (handsUpClientInfo.viewKind === "CAMERA") {
                    // 카메라 사용 안 되는 걸 알려주고 싶다....
                    console.log("setMediaDevicesInfo - case 8");
                    handsUpClientInfo.handsUpFunc("camera_noLongerAvailable", handsUpClientInfo.videoInputInfo.selectedMediaInfo);
                }
            }
        }
    }
}

/**
 * 현재 viewKind를 확인한 후 비디오 스트림 권한을 요청하는 메서드.
 * 
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용
 */
export const setUpVideoStream = (isHandsUpInit) => {
    if (relayLive.startVideo({ info: handsUpClientInfo, init: isHandsUpInit, gotVideo: gotVideoStream, gotAudio: gotAudioStream, initMyCam: initMyCamDisplayProc, viewQuality: () => setVideoResolution(handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode || getIsForPblModeBrowser(), handsUpClientInfo.viewKind === "CAMERA", getIsForPblModeBrowser(), currentP2PMode(handsUpClientInfo.localStreamingMode, handsUpClientInfo.smartTVP2PMode)), startProjection: () => sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind), legacy: () => setUpVideoStream(isHandsUpInit) })) return; // 20261020 C3 앱 스트림만 기존 표시/produce에 전달
    console.log(`setUpVideoStream - isHandsUpInit[${isHandsUpInit}], window.isHandsUpInit[${window.isHandsUpInit}]`);
    window.isHandsUpInit = isHandsUpInit;

    console.log(`setUpVideoStream - handsupClientInfo.viewKind[${handsUpClientInfo.viewKind}]`);

    // 261006 iOS 앱(Pro) 카메라 모드면 백그라운드 진입 시 교사에게 보낼 "카메라 중단/재개" 패킷을 네이티브에 맡긴다(스크린이면 해제).
    syncIOSCameraStatePackets(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, handsUpClientInfo.viewKind === "CAMERA");

    if (navigator && navigator.mediaDevices) {
        console.log("(1) --- navigator && navigator.mediaDevices 가 있는 경우 --- ");
        if (handsUpClientInfo.viewKind === "CAMERA") {
            if (handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
                console.log("start get camera stream");
                setUpCameraVideoStream(isHandsUpInit);
            } else {
                console.log("No cameras available... try screen mode");
                setUpScreenDisplayStream(isHandsUpInit);
            }
        } else {
            if (!isHandsUpInit && isIOSWebView()) { //camera -> screen 으로 전환하는 경우의 ios 처리 .. by ykhan 251031
                
            } else {
                setUpScreenDisplayStream(isHandsUpInit);
            }
        }
    } else { // camera, screen을 시도할 수 없는 경우 by hjkim 20220913
        console.log("(2) --- camera, screen을 시도할 수 없는 경우 --- ");
        if (isAndroidWebView() || isIOSWebView()) { // android 기기일 경우 app을 호출하는 process를 타게 한다.. by hjkim 20220824 + ios 케이스 추가함 by ykhan 20250925
            setUpScreenDisplayStream(isHandsUpInit);
        } else { // android 기기가 아닐 경우 canvas 웹페이지 이미지를 사용한다.. by hjkim 20220913
            if (isHandsUpInit !== true) { // ondevicechange event 발생 후에 불리는데... 혹시나.. 전에 보내고 있었을수도... clear... by hjkim 20220311
                window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                sendUnpublish("video");
            }

            startCanvasImageSendProc();

            if (isHandsUpInit === true) {
                console.log("sendHandsUpInitDone called ... case 1");
                sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
            }

            handsUpClientInfo.handsUpFunc("viewKind_screen");
            handsUpClientInfo.handsUpFunc("hImg_visible");
        }
    }
}

/**
 * MediaStreamTrack 객체 구현에서 사용자 에이전트 또는 브라우저가 지원하는
 * 제약 조건 속성 목록을 반환하는 메서드.
 * - 지원하는 제약 조건만 목록에 포함되므로 이러한 각 부울 속성의 값은 true, 아니면 false.
 * 
 * @returns {MediaTrackSupportedConstraints} 지원하는 제약 조건 속성 목록
 */
const getSupportedConstraints = () => {
    if (navigator && navigator.mediaDevices) {
        let constraints = navigator.mediaDevices.getSupportedConstraints();
        console.log(constraints);
        return constraints;
    }
}

/**
 * Android WebView에서 최초 카메라 권한 획득 후 실제 비디오 입력 장치 목록을 한 번 재조회한다.
 * - 기존 스트림과 마이캠용 0번 장치 순서는 변경하지 않는다.
 *
 * @param {MediaStream} videoStream - 권한 획득에 성공한 전면 카메라 스트림
 * @since 260730.
 */
const refreshAndroidVideoInputs = async (videoStream, intent) => { // 20261030 intent: 원래 획득의 세대 (web-relay R-261)
    if (!isAndroidWebView() || handsUpClientInfo.videoInputInfo.androidDevicesRefreshed) return;

    handsUpClientInfo.videoInputInfo.androidDevicesRefreshed = true;

    try {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        if (!isAcquireIntentOk(intent)) { console.log("refreshVideoInputs - 기다리는 사이 원래 획득이 무효가 됐다. 목록을 쓰지 않는다."); return; } // 20261030 (R-261)
        const refreshedVideoInputs = [];

        mediaDevices.forEach(device => {
            if (device.kind !== "videoinput") return;
            if (device.label.indexOf("3D Camera") !== -1 && device.label.indexOf("Virtual Driver") !== -1) return;
            if (refreshedVideoInputs.some(info => info.deviceId === device.deviceId)) return;

            refreshedVideoInputs.push({ deviceId: device.deviceId, groupId: device.groupId, label: device.label });
        });

        console.log("refreshAndroidVideoInputs - refreshedVideoInputs => ", refreshedVideoInputs);
        if (refreshedVideoInputs.length <= 0) return;

        const videoTrack = videoStream && videoStream.getVideoTracks ? videoStream.getVideoTracks()[0] : null;
        const currentDeviceId = videoTrack && videoTrack.getSettings ? videoTrack.getSettings().deviceId : null;
        const currentIndex = currentDeviceId ? refreshedVideoInputs.findIndex(info => info.deviceId === currentDeviceId) : -1;

        // 20260730 ... Android WebView 마이캠이 0번 전면 카메라를 사용하도록 현재 전면 스트림 장치를 목록 맨 앞으로 이동 ... by hjkim
        if (currentIndex > 0) {
            const currentFrontInput = refreshedVideoInputs.splice(currentIndex, 1)[0];
            refreshedVideoInputs.unshift(currentFrontInput);
        }

        handsUpClientInfo.videoInputInfo.list_videoInput = refreshedVideoInputs;
        handsUpClientInfo.videoInputInfo.selectedIndex = 0;
        handsUpClientInfo.videoInputInfo.androidFrontDeviceId = currentDeviceId || refreshedVideoInputs[0].deviceId;
        console.log(`refreshAndroidVideoInputs - currentDeviceId[${currentDeviceId}], selectedIndex[${handsUpClientInfo.videoInputInfo.selectedIndex}]`);
    } catch (err) {
        handleDOMException("refreshAndroidVideoInputs()", err);
    }
}

/**
 * iOS WebView에서 최초 카메라 권한 획득 후 실제 비디오 입력 장치 목록을 한 번 재조회한다.
 * - 기존 스트림과 마이캠용 0번 장치 순서는 변경하지 않는다.
 *
 * @param {MediaStream} videoStream - 권한 획득에 성공한 전면 카메라 스트림
 * @since 260806.
 */
const refreshIOSVideoInputs = async (videoStream, intent) => { // 20261030 intent: 원래 획득의 세대 (web-relay R-261)
    if (!isIOSWebView() || handsUpClientInfo.videoInputInfo.iosDevicesRefreshed) return;
    
    handsUpClientInfo.videoInputInfo.iosDevicesRefreshed = true;

    try {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        if (!isAcquireIntentOk(intent)) { console.log("refreshVideoInputs - 기다리는 사이 원래 획득이 무효가 됐다. 목록을 쓰지 않는다."); return; } // 20261030 (R-261)
        const refreshedVideoInputs = [];

        mediaDevices.forEach(device => {
            if (device.kind !== "videoinput") return;
            if (refreshedVideoInputs.some(info => info.deviceId === device.deviceId)) return;

            refreshedVideoInputs.push({ deviceId: device.deviceId, groupId: device.groupId, label: device.label });
        });

        console.log("refreshIOSVideoInputs - refreshedVideoInputs =>", refreshedVideoInputs);
        if (refreshAndroidVideoInputs.length <= 0) return;

        const videoTrack = videoStream && videoStream.getVideoTracks ? videoStream.getVideoTracks()[0] : null;
        const currentDeviceId = videoTrack && videoTrack.getSettings ? videoTrack.getSettings().deviceId : null;
        const currentIndex = currentDeviceId ? refreshedVideoInputs.findIndex(info => info.deviceId === currentDeviceId) : -1;

        if (currentIndex > 0) {
            const currentFrontInput = refreshedVideoInputs.splice(currentIndex, 1)[0];
            refreshedVideoInputs.unshift(currentFrontInput);
        }

        handsUpClientInfo.videoInputInfo.list_videoInput = refreshedVideoInputs;
        handsUpClientInfo.videoInputInfo.selectedIndex = 0;
        console.log(`refreshIOSVideoInputs - currentDeviceId[${currentDeviceId}], selectedIndex[${handsUpClientInfo.videoInputInfo.selectedIndex}]`);
    } catch (err) {
        handleDOMException("refreshIOSVideoInputs()", err);
    }
}

/**
 * 카메라 비디오 스트림 권한 요청 메서드.
 * - 사용할 수 있는 카메라 비디오 입력 장치의 권한 획득 후 비디오 스트림으로 사용.
 * 
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용
 */
const setUpCameraVideoStream = async (isHandsUpInit) => {
    if (handsUpClientInfo.videoInputInfo.list_videoInput.length <= 0 || handsUpClientInfo.videoInputInfo.selectedIndex === -1) {
        console.log("can not use camera...! try screen mode (1)");
        return;
    }

    console.log(`setUpCameraVideoStream [${isHandsUpInit}]`);

    let currSelectedIndex = handsUpClientInfo.videoInputInfo.selectedIndex;
    console.log(`setUpCameraVideoStream - currSelectedIndex[${currSelectedIndex}], list_videoInput => `, handsUpClientInfo.videoInputInfo.list_videoInput);
    console.log(`setUpCameraVideoStream - list_videoInput[currSelectedIndex(${currSelectedIndex})] => `, handsUpClientInfo.videoInputInfo.list_videoInput[currSelectedIndex]);
    const deviceId = handsUpClientInfo.videoInputInfo.list_videoInput[currSelectedIndex].deviceId;
    console.log(`setUpCameraVideoStream - deviceId[${deviceId}]`);
    if (deviceId === undefined || deviceId === null) {
        console.log("can not use camera...! try screen mode (2-2)");
        return;
    }

    let constraints = {
        audio: false,
        video: {
            deviceId: deviceId ? { exact: deviceId } : undefined,
            // 20260730 ... Android WebView의 기존 전면 카메라 요청은 유지하고 후면 전환 시에만 facingMode 사용 ... by hjkim
            facingMode: isAndroidWebView() && !deviceId && handsUpClientInfo.videoInputInfo.androidFacingMode === "environment"
                ? { exact: "environment" }
                : undefined,
            ...BandConstraints.Camera
        }
    };

    /* let constraints;
    if (isIOSDevice() || isIOSWebView()) {  // iOS 감지 함수 필요
        constraints = {
            audio: true,  // iOS는 동시에 요청
            video: {
                deviceId: deviceId ? { exact: deviceId } : undefined,
                ...BandConstraints.Camera
            }
        };
    } else {
        constraints = {
            audio: false,
            video: {
                deviceId: deviceId ? { exact: deviceId } : undefined,
                ...BandConstraints.Camera
            }
        };
    } */

    const acqTicket = beginAcquire("camera"); // 20261030 요청마다 ticket, 종료 중/뒤면 요청하지 않음 (web-relay R-238)
    if (!acqTicket) return;

    if (navigator.mediaDevices === undefined || navigator.mediaDevices === null) {
        console.log("older browser version... can not use new API for video");
        // alert("older browser version... can not use new API for video");
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

        if (navigator.getUserMedia) {
            requestLegacy(acqTicket, () => navigator.getUserMedia(constraints, (videoStream) => { // 20261030 동기 throw 시 ticket 해제 (R-240)
                if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 무효면 받은 트랙만 정지 (R-239)
                endAcquire(acqTicket); // 20261030 동기 인계 뒤 해제 (R-240)
                if (videoStream !== undefined && videoStream !== null) {
                    // 원본 스트림도 저장
                    handsUpClientInfo.rawVideoStream = videoStream;

                    handsUpClientInfo.sendVideoStream = videoStream.clone();

                    gotVideoStream(isHandsUpInit, true, acqTicket.intent); // 20261030 송출 단계에 intent 전달 (R-262)

                    /* if (isHandsUpInit === true) {
                        sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                    } */

                    handsUpClientInfo.handsUpFunc("viewKind_camera");
                } else {
                    // 이런 경우가 있을 수 있나..?ㅁ?....
                    startCanvasImageSendProc();

                    if (isHandsUpInit === true) {
                        console.log("sendHandsUpInitDone called ... case 2");
                        sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                    }

                    handsUpClientInfo.handsUpFunc("viewKind_screen");
                    handsUpClientInfo.handsUpFunc("hImg_visible");

                    if (handsUpClientInfo.isP2PMode) {
                        if (isHandsUpInit !== true) {
                            window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                            sendUnpublish("video");
                        }
                    }

                    let str = "카메라와 스크린 캡처를 지원하지 않는 브라우저이기에\n";
                    if (handsUpClientInfo.localStreamingMode !== 0) {
                        if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                            str += "WebRTC 모드를 실행할 수 없습니다.\n";
                        } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                            str += "P2P 모드를 실행할 수 없습니다.\n";
                        }
                    } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                        str += "카메라 전송 모드를 실행할 수 없습니다.\n";
                    }

                    str += "카메라와 스크린 캡처 모드가 지원되기 위해서는\n";
                    str += "최신 웹 브라우저로 접속한 후에 해당 기능을 사용할 수 있습니다. (Code.HC300.1)";
                    console.log("(1) str => ", str);
                    alert(str);
                }
            }, (err) => {
                if (dropIfInvalid(acqTicket)) return; // 20261030 무효면 canvas·152·UI·alert 없음 (R-239)
                endAcquire(acqTicket); // 20261030 (R-240)
                handleLogMessage("setUpCameraVideoStream(old)", "selectedIndex", handsUpClientInfo.videoInputInfo.selectedIndex);
                handleDOMException("setUpCameraVideoStream(old)", err);

                startCanvasImageSendProc();

                if (isHandsUpInit === true) {
                    console.log("sendHandsUpInitDone called ... case 3");
                    sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                }

                handsUpClientInfo.handsUpFunc("viewKind_screen");
                handsUpClientInfo.handsUpFunc("hImg_visible");

                if (handsUpClientInfo.isP2PMode) {
                    if (isHandsUpInit !== true) {
                        window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                        sendUnpublish("video");
                    }
                }

                let str = "카메라와 스크린 캡처를 지원하지 않는 브라우저이기에\n";
                if (handsUpClientInfo.localStreamingMode !== 0) {
                    if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                        str += "WebRTC 모드를 실행할 수 없습니다.\n";
                    } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                        str += "P2P 모드를 실행할 수 없습니다.\n";
                    }
                } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                    str += "카메라 전송 모드를 실행할 수 없습니다.\n";
                }

                str += "카메라와 스크린 캡처 모드가 지원되기 위해서는\n";
                str += "최신 웹 브라우저로 접속한 후에 해당 기능을 사용할 수 있습니다. (Code.HC300.2)";
                console.log("(2) str => ", str);
                alert(str);
            })); // 20261030 requestLegacy 닫기 (R-240)
        } else {
            if (dropIfInvalid(acqTicket)) return; // 20261030 (R-239)
            endAcquire(acqTicket); // 20261030 (R-240)
            startCanvasImageSendProc();

            if (isHandsUpInit === true) {
                console.log("sendHandsUpInitDone called ... case 4");
                sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
            }

            handsUpClientInfo.handsUpFunc("viewKind_screen");
            handsUpClientInfo.handsUpFunc("hImg_visible");

            if (handsUpClientInfo.isP2PMode) {
                if (isHandsUpInit !== true) {
                    window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                    sendUnpublish("video");
                }
            }

            let str = "카메라와 스크린 캡처를 지원하지 않는 브라우저이기에\n";
            if (handsUpClientInfo.localStreamingMode !== 0) {
                if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                    str += "WebRTC 모드를 실행할 수 없습니다.\n";
                } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                    str += "P2P 모드를 실행할 수 없습니다.\n";
                }
            } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                str += "카메라 전송 모드를 실행할 수 없습니다.\n";
            }

            str += "카메라와 스크린 캡처 모드가 지원되기 위해서는\n";
            str += "최신 웹 브라우저로 접속한 후에 해당 기능을 사용할 수 있습니다. (Code.HC300.3)";
            console.log("(3) str => ", str);
            alert(str);
        }
    } else {
        console.log("can use new API browser version... for video");
        // alert("can use new API browser version... for video");
        let videoStream = null;

        try {
            // getSupportedConstraints();
            videoStream = (await getRelayCameraStream(handsUpClientInfo.videoInputInfo.androidFacingMode)) || (isAcquireIntentOk(acqTicket.intent) ? await navigator.mediaDevices.getUserMedia(constraints) : null); // 20261030 relay→gUM 사이 판정 (R-239) // 20261020 web-relay phase1 2차: 개발 버전·앱 relay 있을 때만 앱 카메라, 아니면 기존 gUM
        } catch (err) {
            handleLogMessage("setUpCameraVideoStream(new)", "selectedIndex", handsUpClientInfo.videoInputInfo.selectedIndex);
            handleDOMException("setUpCameraVideoStream(new)", err);

            // 20260730 ... Android WebView 후면 카메라가 exact/영상 제약으로 실패하면 ideal facingMode로 한 번 재시도 ... by hjkim
            if (isAndroidWebView() && handsUpClientInfo.videoInputInfo.androidFacingMode === "environment" && isAcquireIntentOk(acqTicket.intent)) { // 20261030 무효면 완화 재시도 없음 (R-239)
                const relaxedConstraints = {
                    audio: false,
                    video: {
                        deviceId: deviceId ? { exact: deviceId } : undefined,
                        facingMode: deviceId ? undefined : { ideal: "environment" }
                    }
                };

                try {
                    console.log(`setUpCameraVideoStream - Android WebView rear camera relaxed retry, selectedIndex[${currSelectedIndex}], deviceId[${deviceId}]`);
                    videoStream = await navigator.mediaDevices.getUserMedia(relaxedConstraints);
                } catch (retryErr) {
                    handleLogMessage("setUpCameraVideoStream(new-relaxed)", "selectedIndex", handsUpClientInfo.videoInputInfo.selectedIndex);
                    handleDOMException("setUpCameraVideoStream(new-relaxed)", retryErr);
                }
            }
        } finally {
            if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 반환·실패 직후 판정, 무효면 받은 트랙만 정지 (R-239)
            if (videoStream !== null) {
                try { // 20261030 refresh·인계 중 예외에도 ticket 을 1회 해제한다(오류 전달은 기존대로) (R-268)
                // 20260730 ... Android WebView의 최초 전면 카메라 권한 획득 후 실제 장치 목록을 한 번 재조회 ... by hjkim
                if (isAndroidWebView() && handsUpClientInfo.videoInputInfo.androidFacingMode === "user") {
                    await refreshAndroidVideoInputs(videoStream, acqTicket.intent); // 20261030 (R-261)
                } else if (isIOSWebView() && currSelectedIndex === 0) {
                    await refreshIOSVideoInputs(videoStream, acqTicket.intent); // 20261030 (R-261)
                }
                if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 refresh 대기 뒤 재판정 — 아직 지역 stream 이라 ticket 유지 중 (R-261)

                // 원본 스트림도 저장
                handsUpClientInfo.rawVideoStream = videoStream;

                handsUpClientInfo.sendVideoStream = videoStream.clone();
                } finally {
                    endAcquire(acqTicket); // 20261030 전역 인계 뒤 해제 (R-240·R-268)
                }

                gotVideoStream(isHandsUpInit, true, acqTicket.intent); // 20261030 송출 단계에 intent 전달 (R-262)

                /* if (isHandsUpInit === true) {
                    sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                } */

                handsUpClientInfo.handsUpFunc("viewKind_camera");
            } else {
                endAcquire(acqTicket); // 20261030 유효 owner 의 정상 실패 — 기존 fallback 은 새 ticket 으로 (R-240)
                let idx = handsUpClientInfo.videoInputInfo.selectedIndex;
                idx++;

                if (idx < handsUpClientInfo.videoInputInfo.list_videoInput.length) {
                    handsUpClientInfo.videoInputInfo.selectedIndex = idx;
                    handsUpClientInfo.viewKind = "CAMERA";
                } else {
                    handsUpClientInfo.videoInputInfo.selectedIndex = -1;
                    handsUpClientInfo.viewKind = "SCREEN";
                    // 20260730 ... Android WebView 후면 카메라 요청이 모두 실패한 경우 facingMode 순환 상태 초기화 ... by hjkim
                    if (isAndroidWebView()) handsUpClientInfo.videoInputInfo.androidFacingMode = null;
                }

                if (handsUpClientInfo.viewKind === "SCREEN") {
                    console.log("can not use camera.. try screen (3)");
                    window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                    if (checkAndroidScreenValue() || (isIOSWebView() && handsUpClientInfo.viewKind === "SCREEN")) sendUnpublish("video");    // viewKind 값을 바꿨는데 만족한다는 건 기존에 camera stream 사용 중이었단 뜻이므로 unpublish 한다 ... by hjkim 20231113
                    setUpScreenDisplayStream(isHandsUpInit);
                } else {
                    console.log(`can not use currSelectedIndex[${currSelectedIndex}] camera.. try next selectedIndex[${handsUpClientInfo.videoInputInfo.selectedIndex}] camera`);
                    setUpCameraVideoStream(isHandsUpInit);
                }
            }
        }
    }
}

/**
 * 화면 공유 권한 요청 메서드.
 * - 사용할 수 있는 화면 공유 비디오 스트림 권한 획득 후 비디오 스트림으로 사용.
 * - 선택한 디스플레이에서 오디오가 지원되고 사용 가능한 경우 시스템 오디오 스트림으로 사용. (※ 모바일 제외)
 * 
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용
 */
const setUpScreenDisplayStream = async (isHandsUpInit) => {
    if (isAndroidWebView()) {
        if (window.isNeedCallOnScreen) {
            // 이 경우 mic를 사용하고 있기 때문에 sendUnpublish는 change할때 이미 'audio'를 보냈을 것임 ... !
            // 그래서 unpublishAfter 단계에서 앱 호출 프로세스를 처리해야함! ... by hjkim
            // console.log("case 1:) call sendUnpublish('audio')");
            // sendUnpublish("audio");
        } else {
            console.log("case 2:) call sendStartPentalkOnScreenForAndroid ...");
            sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

            setScreenModeImage("connect");
        }
    } else if (isIOSWebView()) {
        console.log("setUpScreenDisplayStream isConnectediOSApp value is ", handsUpClientInfo.isConnectediOSApp);
        if (!handsUpClientInfo.isStreamingiOSApp) {
            sendStartPentalkOnScreenForIOS(handsUpClientInfo.isP2PMode, handsUpClientInfo.configFPSKind);
        }

        // 기존 소스
        // if (handsUpClientInfo.isConnectediOSApp) {
        // } else {
        //     sendStartPentalkOnScreenForIOS(handsUpClientInfo.isP2PMode, handsUpClientInfo.configFPSKind);
        // }
    } else {
        const acqTicket = beginAcquire("screen"); // 20261030 (web-relay R-238)
        if (!acqTicket) return;
        if (navigator.mediaDevices === undefined || navigator.mediaDevices === null) {
            if (dropIfInvalid(acqTicket)) return; // 20261030 (R-239)
            endAcquire(acqTicket); // 20261030 (R-240)
            // alert("can not use screen stream mode....");
            let str = "스크린 캡처를 지원하지 않는 브라우저이기에\n";
            if (handsUpClientInfo.localStreamingMode !== 0) {
                if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                    str += "WebRTC 모드를 실행할 수 없습니다.\n";
                } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                    str += "P2P 모드를 실행할 수 없습니다.\n";
                }
            } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                str += "화면 전송 모드를 실행할 수 없습니다.\n";
            }

            str += "스크린 캡처 모드가 지원되기 위해서는\n";
            str += "최신 웹 브라우저로 접속한 후에 해당 기능을 사용할 수 있습니다. (Code.HC302.1)";
            console.log("(3) str => ", str);
            alert(str);
            return;
        }

        let constraints = {
            // audio: true,
            // video: BandConstraints.Screen
            // audio: {
            //     noiseSuppression: true,
            //     echoCancellation: true,
            // },
            audio: {
                // 20261015 시스템 소리는 음성 처리를 하지 않도록 명시
                echoCancellation: false,
                noiseSuppression: false,
                autoGainControl: false,
            },
            video: {
                cursor: "always",           // 마우스 커서 포함 여부
                displaySurface: "monitor",  // 전체 화면 선택
                ...BandConstraints.Screen
            }
        };

        let videoStream = null;

        console.log("(★) setUpScreenDisplayStream----", constraints);
        try {
            videoStream = await navigator.mediaDevices.getDisplayMedia(constraints);
        } catch (err) {
            handleDOMException("setUpScreenDisplayStream()", err);
        } finally {
            if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 반환·실패 직후 판정, 무효면 받은 트랙만 정지 (R-239)
            if (videoStream !== null) {
                try { // 20261030 인계 중 예외에도 ticket 을 1회 해제한다(오류 전달은 기존대로) (R-268)
                // 원본 스트림도 저장
                handsUpClientInfo.rawVideoStream = videoStream;

                // 20260908 화면은 원본 트랙으로 송출하고, 방향 보정값만 producer 정보로 전달한다.
                handsUpClientInfo.sendVideoStream = videoStream.clone();

                // 수정 코드 ... by hjkim 20251106
                console.log("setUpDisplayStream - handsUpClientInfo.isSysConnectFlag[", handsUpClientInfo.isSysConnectFlag, "]");
                replaceSystemMixerInputForScreen(); // 20261030 flag 무관 동기 교체 폐기, 기존 sendAudioStream 정리 조건 보존 (R-249·R-263) — 기존: if (isSysConnectFlag) await clearSystemStreamSource();

                let hasSystemAudio = false;
                videoStream.getTracks().forEach((track) => {
                    console.log("videoStream track => ", track);
                    if (track.kind === "audio") {
                        // 수정 코드 ... by hjkim 20251106
                        // GainNode를 통해 연결하도록 수정함 ... by hjkim
                        handsUpClientInfo.systemStreamSource = createMixerInput(handsUpClientInfo.audioCtx, videoStream, "system"); // 20261029 clone/node 쌍 등록, 생성 실패 시 clone 반환 (R-254·R-256)
                        handsUpClientInfo.systemStreamSource.connect(handsUpClientInfo.systemGainNode);  // GainNode에 연결

                        handsUpClientInfo.isSysConnectFlag = true;
                        hasSystemAudio = true;
                    }
                });

                console.log("setUpDisplayStream - hasSystemAudio[", hasSystemAudio, "], isMicOn[", handsUpClientInfo.isMicOn, "]");
                if (hasSystemAudio) {
                    // 시스템 오디오가 있는 경우
                    handsUpClientInfo.hasSystemAudio = true;
                } else {
                    // 시스템 오디오가 없는 경우
                    handsUpClientInfo.hasSystemAudio = false;
                }

                } finally {
                    endAcquire(acqTicket); // 20261030 전역 인계 뒤 해제 (R-240·R-268)
                }

                // console.log("isMicOn - ", handsUpClientInfo.isMicOn);
                // 크롬 업데이트 이슈로 인해 micOn 상태가 아니어도, 오디오를 produce 하도록 수정 ... by hjkim 20251105
                // mic stream 또는 system audio stream이 없는 경우 destination.stream의 기본 빈 스트림이 전송된다.
                // if (handsUpClientInfo.isMicOn) gotAudioStream();
                // await gotAudioStream("display");
                if (handsUpClientInfo.isMicOn) {
                    await gotAudioStream("mic+display", acqTicket.intent); // 20261030 (R-262)
                } else {
                    await gotAudioStream("display", acqTicket.intent); // 20261030 (R-262)
                }
                if (!isAcquireIntentOk(acqTicket.intent)) return; // 20261030 송출 대기 중 무효면 video·UI 없음 (R-262)

                gotVideoStream(isHandsUpInit, false, acqTicket.intent); // 20261030 (R-262)

                /* if (isHandsUpInit === true) {
                    sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                } */

                handsUpClientInfo.handsUpFunc("viewKind_screen");
            } else {
                endAcquire(acqTicket); // 20261030 유효 owner 의 정상 실패 (R-240)
                startCanvasImageSendProc();

                if (isHandsUpInit === true) {
                    console.log("sendHandsUpInitDone called ... case 7");
                    sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                }

                handsUpClientInfo.handsUpFunc("viewKind_screen");
                handsUpClientInfo.handsUpFunc("hImg_visible");

                if (handsUpClientInfo.isP2PMode) {
                    if (isHandsUpInit !== true) {
                        window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                        sendUnpublish("video");
                    }
                }

                let str = "스크린 캡처를 지원하지 않는 브라우저이기에\n";
                if (handsUpClientInfo.localStreamingMode !== 0) {
                    if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                        str += "WebRTC 모드를 실행할 수 없습니다.\n";
                    } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                        str += "P2P 모드를 실행할 수 없습니다.\n";
                    }
                } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                    str += "화면 전송 모드를 실행할 수 없습니다.\n";
                }

                str += "스크린 캡처 모드가 지원되기 위해서는\n";
                str += "최신 웹 브라우저로 접속한 후에 해당 기능을 사용할 수 있습니다. (Code.HC302.2)";
                console.log("(4) str => ", str);
                alert(str);
            }
        }
    }

    // 기존 코드 주석 처리 ... by hjkim
    /* // 안드로이드 웹뷰 케이스 처리 추가 ... by hjkim 20260127
    if (handsUpClientInfo.isAndroidDevice || isAndroidWebView()) { // android 용 screen capture 프로그램 실행을 위해서 따로 처리.. by hjkim 20211108
        if (handsUpClientInfo.isAvailableApp) {
            // window.isHandsUpInit = isHandsUpInit;

            if (window.isNeedCallOnScreen) {
                // 이 경우 mic를 사용하고 있기 때문에 sendUnpublish는 change할때 이미 'audio'를 보냈을 것임 ... !
                // 그래서 unpublishAfter 단계에서 앱 호출 프로세스를 처리해야함! ... by hjkim
                // sendUnpublish("audio");
            } else {
                // 이 경우 mic를 사용하지 않고 있기 때문에 바로 앱을 호출 할 수 있음 ... by hjkim 20250915
                if (getIsAlivePenCamService()) {
                    console.log("sendStartPentalkOnScreenForAndroid called ... case 2");
                    sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

                    setScreenModeImage("connect");
                } else {
                    console.log("sendStartPentalkOnScreenForAndroid called ... case 3");
                    sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

                    handsUpClientInfo.timerProc = setTimeout((isHandsUpInit) => {
                        if (document.webkitHidden || document.hidden) {
                            console.log("앱 설치되지 않은 케이스! (1)");
                            handsUpClientInfo.isAvailableApp = false; // 앱 설치되지 않은 케이스

                            startCanvasImageSendProc();

                            if (isHandsUpInit === true) {
                                console.log("sendHandsUpInitDone called ... case 5");
                                sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                            }

                            console.log("call setScreenModeImage(not-connect) case 1");
                            setScreenModeImage("not-connect");

                            if (!isAndroidWebView()) {
                                if (isHandsUpInit) {
                                    handsUpClientInfo.tempTimerProc = setTimeout(() => {
                                        let str = "스크린 캡처를 지원하지 않는 브라우저이기에\n";
                                        if (handsUpClientInfo.localStreamingMode !== 0) {
                                            if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                                                str += "WebRTC 모드를 실행할 수 없습니다.\n";
                                            } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                                                str += "P2P 모드를 실행할 수 없습니다.\n";
                                            }
                                        } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                                            str += "화면 전송 모드를 실행할 수 없습니다.\n";
                                        }

                                        str += "스크린 캡처 모드가 지원되기 위해서는\n";
                                        // str += "반드시 [Pentalk onScreen] 앱이 설치되어야 합니다.\n";
                                        str += "[Pentalk onScreen] 앱을 설치한 후에 해당 기능을 사용할 수 있습니다. (Code.HC301.1)";
                                        console.log("(1) str => ", str);
                                        alert(str);

                                        clearTimerProc(true);
                                    }, timerProcDelayTime);
                                } else {
                                    console.log("isHandsUpInit is false... 이때는 tempTimerProc 호출하지 않기!");
                                }
                            }
                        } else {
                            console.log("앱 설치된 케이스! 앱 정상적으로 실행됨!");
                            console.log("call setScreenModeImage(not-connect) case 2");
                            setScreenModeImage("not-connect");
                        }

                        clearTimerProc(false);
                    }, timerProcDelayTime, isHandsUpInit);
                }
            }
        } else {
            console.log("앱 설치되지 않은 케이스! (2)");
            startCanvasImageSendProc();

            if (isHandsUpInit === true) {
                console.log("sendHandsUpInitDone called ... case 6");
                sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
            }

            console.log("call setScreenModeImage(not-connect) case 3");
            setScreenModeImage("not-connect");

            if (!isAndroidWebView()) {
                let str = "스크린 캡처를 지원하지 않는 브라우저이기에\n";
                if (handsUpClientInfo.localStreamingMode !== 0) {
                    if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                        str += "WebRTC 모드를 실행할 수 없습니다.\n";
                    } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                        str += "P2P 모드를 실행할 수 없습니다.\n";
                    }
                } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                    str += "화면 전송 모드를 실행할 수 없습니다.\n";
                }

                str += "스크린 캡처 모드가 지원되기 위해서는\n";
                // str += "반드시 [Pentalk onScreen] 앱이 설치되어야 합니다.\n";
                str += "[Pentalk onScreen] 앱을 설치한 후에 해당 기능을 사용할 수 있습니다. (Code.HC301.2)";
                console.log("(2) str => ", str);
                alert(str);
            }
        }
    } */
}

/**
 * 마이캠(MyCam)용 카메라 비디오 스트림 권한 요청 메서드.
 * - 사용할 수 있는 카메라 비디오 입력 장치의 권한 획득 후 마이캠용 비디오 스트림으로 사용.
 */
const setUpMyCamStream = async () => {
    if (relayLive.myCam(handsUpClientInfo, initMyCamDisplayProc)) return; // 20261020 SCREEN 마이캠 입력만 앱 전면 스트림으로 대체
    if (navigator === undefined || navigator === null) return;
    const acqTicket = beginAcquire("myCam"); // 20261030 인덱스·UI 변경 전 ticket (web-relay R-238)
    if (!acqTicket) return;

    try {
        let idx = handsUpClientInfo.videoInputInfo.myCamIndex;
        idx++;

        /* // 마이캠 인덱스 기본값은 0으로 고정
        let idx = 0; */

        // ★ 가드 추가: 인덱스가 범위를 벗어나면 0으로 초기화
        if (idx < 0 || idx >= handsUpClientInfo.videoInputInfo.list_videoInput.length) {
            idx = 0;
        }

        if (idx < handsUpClientInfo.videoInputInfo.list_videoInput.length) {
            handsUpClientInfo.videoInputInfo.myCamIndex = idx;
        } else {
            idx = 0;
            handsUpClientInfo.videoInputInfo.myCamIndex = idx;
        }

        console.log("setUpMyCamStream - idx[", idx, "]");

        const deviceId = handsUpClientInfo.videoInputInfo.list_videoInput[idx].deviceId;
        if (deviceId === undefined || deviceId === null) {
            console.log("can not use camera...! try screen mode (3)");
            endAcquire(acqTicket); // 20261030 요청 전 반환 (R-240)
            return;
        }

        let constraints = {
            audio: false,
            video: {
                deviceId: deviceId ? { exact: deviceId } : undefined,
                ...BandConstraints.CameraForMyCam
            }
        };

        if (navigator.mediaDevices === undefined || navigator.mediaDevices === null) {
            // console.log("older browser version... can not use new API for video");
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

            if (navigator.getUserMedia) {
                navigator.getUserMedia(constraints, (videoStream) => {
                    if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 (R-239)
                    endAcquire(acqTicket); // 20261030 동기 인계 (R-240)
                    if (videoStream !== undefined && videoStream !== null) {
                        initMyCamDisplayProc(videoStream);
                        handsUpClientInfo.handsUpFunc("myCam_visible");
                    } else {
                        // 이런 경우가 있을 수 있나...?ㅁ?....
                        handsUpClientInfo.videoInputInfo.isMyCamRunning = false;
                        handsUpClientInfo.videoInputInfo.myCamIndex = -1;
                        handsUpClientInfo.handsUpFunc("myCam_invisible");

                        // 앱 연결 이미지 표기를 위해 한번 더 호출
                        if (isAndroidWebView() || isIOSWebView()) {
                            setScreenModeImage("connect");
                        }

                        alert("카메라를 사용할 수 없어 마이 캠을 실행할 수 없습니다. (Code.HC303.1)");
                    }
                }, (err) => {
                    if (dropIfInvalid(acqTicket)) return; // 20261030 (R-239)
                    endAcquire(acqTicket); // 20261030 (R-240)
                    handleLogMessage("setUpMyCamView(old)", "myCamIndex", handsUpClientInfo.videoInputInfo.myCamIndex);
                    handleDOMException("setUpMyCamView(old)", err);
                    handsUpClientInfo.videoInputInfo.isMyCamRunning = false;
                    handsUpClientInfo.videoInputInfo.myCamIndex = -1;
                    handsUpClientInfo.handsUpFunc("myCam_invisible");

                    // 앱 연결 이미지 표기를 위해 한번 더 호출
                    if (isAndroidWebView() || isIOSWebView()) {
                        setScreenModeImage("connect");
                    }

                    alert("카메라를 사용할 수 없어 마이 캠을 실행할 수 없습니다. (Code.HC303.2)");
                });
            } else {
                if (dropIfInvalid(acqTicket)) return; // 20261030 (R-239)
                endAcquire(acqTicket); // 20261030 (R-240)
                // console.log("navigator.getUserMedia...? 이런 경우가 있나요..?");
                handsUpClientInfo.videoInputInfo.isMyCamRunning = false;
                handsUpClientInfo.videoInputInfo.myCamIndex = -1;
                handsUpClientInfo.handsUpFunc("myCam_invisible");

                // 앱 연결 이미지 표기를 위해 한번 더 호출
                if (isAndroidWebView() || isIOSWebView()) {
                    setScreenModeImage("connect");
                }

                alert("카메라를 사용할 수 없어 마이 캠을 실행할 수 없습니다. (Code.HC303.3)");
            }
        } else {
            // console.log("can use new API browser version... for video");
            let videoStream = null;

            try {
                // getSupportedConstraints();
                videoStream = await navigator.mediaDevices.getUserMedia(constraints);
            } catch (err) {
                handleLogMessage("setUpCameraVideoStream(new)", "myCamIndex", handsUpClientInfo.videoInputInfo.myCamIndex);
                handleDOMException("setUpCameraVideoStream(new)", err);
            } finally {
                if (dropIfInvalid(acqTicket, videoStream)) return; // 20261030 (R-239)
                endAcquire(acqTicket); // 20261030 동기 인계 (R-240)
                if (videoStream !== null) {
                    initMyCamDisplayProc(videoStream);
                    handsUpClientInfo.handsUpFunc("myCam_visible");
                } else {
                    handsUpClientInfo.videoInputInfo.isMyCamRunning = false;
                    handsUpClientInfo.videoInputInfo.myCamIndex = -1;
                    handsUpClientInfo.handsUpFunc("myCam_invisible");

                    // 앱 연결 이미지 표기를 위해 한번 더 호출
                    if (isAndroidWebView() || isIOSWebView()) {
                        setScreenModeImage("connect");
                    }

                    alert("카메라를 사용할 수 없어 마이 캠을 실행할 수 없습니다. (Code.HC303.4)");
                }
            }
        }
    } catch (err) {
        endAcquire(acqTicket); // 20261030 동기 throw·콜백 전 예외 (R-240)
        handleLogMessage("setUpCameraVideoStream(new)", "myCamIndex", handsUpClientInfo.videoInputInfo.myCamIndex);
        handleDOMException("setUpCameraVideoStream(new)", err);
    }
}

/**
 * 오디오 스트림 권한 요청 메서드.
 * - 사용할 수 있는 오디오 입력 장치의 권한 획득 후 마이크 오디오 스트림으로 사용.
 * - 시스템에 기본으로 설정된 오디오 입력 장치의 스트림으로 가져옴.
 * 
 * @param {Boolean} isHandsUpInit - 초기 세팅 완료 teacher에게 알리기 위해 사용
 */
export const setUpMicAudioStream = async (isHandsUpInit) => {
    if (await relayLive.setupAudio()) return true; // 20261020 C3 혼합 스트림을 사용하고 웹 마이크 gUM은 시작하지 않음
    // 수정 코드 ... by hjkim 20251031
    return new Promise(async (resolve, reject) => {
        const acqTicket = beginAcquire("mic"); // 20261030 요청·전역 쓰기 전 ticket, 종료 중/뒤면 false (web-relay R-238)
        if (!acqTicket) { resolve(false); return; }
        try {
            console.log(`setUpMicAudioStream - isHandsUpInit[${isHandsUpInit}], window.isHandsUpInit[${window.isHandsUpInit}]`);
            // 20261023 [IOS-RELAY] iOS 앱 relay 중에는 마이크를 앱이 보냄 → 웹 마이크 열지 않음(시스템 소리 보호)
            if (isIOSWebView() && isIOSRelayNativeMic()) { console.log("[IOS-RELAY] 웹 마이크 생략(앱 마이크 사용)"); resolve(false); return; }
            window.isHandsUpInit = isHandsUpInit;

            const deviceInfo = getAudioInputDeviceInfo();
            if (isHandsUpInit && (deviceInfo === undefined || deviceInfo === null)) {
                handsUpClientInfo.hasMicAudio = false;
                console.log("can not use default audioinput. (1)");
                console.log("setUpMicAudioStream - deviceInfo => ", deviceInfo);
                console.log("call changeHandsUpStatusInfo case 15");
                let store = window.hiclasstv.store;
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                alert("(2) 사용 가능한 마이크가 없거나 마이크 기능을 제공하지 않는 브라우저입니다. (Code.HC202.1)");
                resolve(false);
            }

            // console.log("setUpMicAudioStream - deviceInfo => ", deviceInfo);
            const deviceId = deviceInfo.deviceId;
            if (!checkEnabledAudioInput(deviceInfo.label)) {
                handsUpClientInfo.hasMicAudio = false;
                console.log("can not use default audioinput. (2)");
                if (isHandsUpInit !== true) {
                    window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                    sendUnpublish("audio");
                }

                console.log("call changeHandsUpStatusInfo case 16");
                let store = window.hiclasstv.store;
                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                alert("지원하지 않는 시스템 마이크를 사용하고 있습니다. 시스템 마이크를 다시 선택하세요. (Code.HC202.2)");
                resolve(false);
            }

            // let constraints = { audio: true, video: false };  // use default audio input
            let constraints = {};
            if (deviceId === "default" || deviceId === undefined || deviceId === null) {
                constraints = {
                    audio: true,
                    video: false
                };  // use default audio input
            } else {
                constraints = {
                    audio: { deviceId: deviceId ? { exact: deviceId } : undefined },
                    video: false
                };
            }

            if (navigator.mediaDevices === undefined || navigator.mediaDevices === null) {
                // console.log("older browser version... can not use new API for audio");
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

                if (navigator.getUserMedia) {
                    navigator.getUserMedia(constraints, async (audioStream) => {
                        try { // 20261030 콜백 안 예외도 바깥 Promise 를 끝낸다 (R-268)
                        if (dropIfInvalid(acqTicket, audioStream)) { resolve(false); return; } // 20261030 (R-239)
                        if (audioStream !== undefined && audioStream !== null && handsUpClientInfo.destination) replaceMicMixerInputForDevice(audioStream); // 20261030 PC 이전 mic 입력·원본 폐기 (R-249)
                        endAcquire(acqTicket); // 20261030 동기 인계 (R-240)
                        if (audioStream !== undefined && audioStream !== null) {
                            console.log("////////////////////////// mic stream 얻어 옴 !");
                            // 원본 스트림도 저장
                            handsUpClientInfo.rawAudioStream = audioStream;

                            if (handsUpClientInfo.destination) {    // android/ios webview 는 이 값이 없음
                                // 수정 코드 ... by hjkim 20251106
                                // GainNode를 통해 연결하도록 수정함 ... by hjkim
                                // 다음에 재사용시 오류 방지를 위해 audioStream의 clone을 사용하도록 수정 ... by hjkim 20251105
                                handsUpClientInfo.micStreamSource = createMixerInput(handsUpClientInfo.audioCtx, audioStream, "mic"); // 20261029 clone/node 쌍 등록, 생성 실패 시 clone 반환 (R-254·R-256)
                                handsUpClientInfo.micStreamSource.connect(handsUpClientInfo.micGainNode);  // GainNode에 연결

                                handsUpClientInfo.isMicConnectFlag = true;
                                handsUpClientInfo.hasMicAudio = true;
                            } else {
                                handsUpClientInfo.hasMicAudio = true;

                                // android 일 경우 기존 그대로 audio stream 사용 ... by hjkim 20250909
                                // 다음에 재사용시 오류 방지를 위해 audioStream의 clone을 사용하도록 수정 ... by hjkim 20251105
                                handsUpClientInfo.sendAudioStream = audioStream.clone();
                            }

                            await gotAudioStream("mic", acqTicket.intent); // 20261030 (R-262)
                            resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 송출 대기 중 무효면 false (R-262)
                        } else {
                            // 마이크가 없는 데스크탑 등의 기기를 위한 처리 추가 ... by hjkim 20251017
                            console.log("////////////////////////// mic stream 얻어오지 못함 !");
                            if (handsUpClientInfo.destination) {
                                handsUpClientInfo.isMicConnectFlag = false;
                                handsUpClientInfo.hasMicAudio = false;

                                // audio mixer의 destination.stream의 기본 빈 스트림이 사용되도록 gotAudioStream 바로 호출 ... by hjkim 20251017
                                await gotAudioStream("empty", acqTicket.intent); // 20261030 (R-262)
                                resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 (R-262)
                            } else {
                                handsUpClientInfo.isMicConnectFlag = false;
                                handsUpClientInfo.hasMicAudio = false;

                                // 이런 경우가 있을 수 있나..?ㅁ?....
                                if (isHandsUpInit !== true) {
                                    window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                                    sendUnpublish("audio");
                                }

                                console.log("call changeHandsUpStatusInfo case 17");
                                let store = window.hiclasstv.store;
                                store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                                alert("(3) 사용 가능한 마이크가 없거나 마이크 기능을 제공하지 않는 브라우저입니다. (Code.HC200.1)");
                                resolve(false);
                            }
                        }
                        } catch (cbErr) {
                            endAcquire(acqTicket); // 20261030 (R-268)
                            handleDOMException("setUpMicAudioStream(old-success)", cbErr);
                            resolve(false);
                        }
                    }, async (err) => {
                        try { // 20261030 콜백 안 예외도 바깥 Promise 를 끝낸다 (R-268)
                        if (dropIfInvalid(acqTicket)) { resolve(false); return; } // 20261030 (R-239)
                        endAcquire(acqTicket); // 20261030 (R-240)
                        handleDOMException("setUpMicAudioStream(old)", err);

                        // 마이크가 없는 데스크탑 등의 기기를 위한 처리 추가 (오류 발생 시에도 똑같이 처리) ... by hjkim 20251017
                        if (handsUpClientInfo.destination) { // android/ios webview 는 이 값이 없음
                            handsUpClientInfo.isMicConnectFlag = false;
                            handsUpClientInfo.hasMicAudio = false;

                            // audio mixer의 destination.stream의 기본 빈 스트림이 사용되도록 gotAudioStream 바로 호출 ... by hjkim 20251017
                            await gotAudioStream("empty", acqTicket.intent); // 20261030 (R-262)
                            resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 (R-262)
                        } else {
                            handsUpClientInfo.isMicConnectFlag = false;
                            handsUpClientInfo.hasMicAudio = false;

                            console.log("call changeHandsUpStatusInfo case 18");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                            alert("(4) 사용 가능한 마이크가 없거나 마이크 기능을 제공하지 않는 브라우저입니다. (Code.HC200.2)");
                            resolve(false);
                        }
                        } catch (cbErr) {
                            endAcquire(acqTicket); // 20261030 (R-268)
                            handleDOMException("setUpMicAudioStream(old-error)", cbErr);
                            resolve(false);
                        }
                    });
                } else {
                    if (dropIfInvalid(acqTicket)) { resolve(false); return; } // 20261030 (R-239)
                    endAcquire(acqTicket); // 20261030 (R-240)
                    // 마이크가 없는 데스크탑 등의 기기를 위한 처리 추가 (navigator.getUserMedia가 없는 경우에도 똑같이 처리) ... by hjkim 20251017
                    if (handsUpClientInfo.destination) { // android/ios webview 는 이 값이 없음
                        handsUpClientInfo.isMicConnectFlag = false;
                        handsUpClientInfo.hasMicAudio = false;

                        // audio mixer의 destination.stream의 기본 빈 스트림이 사용되도록 gotAudioStream 바로 호출 ... by hjkim 20251017
                        await gotAudioStream("empty", acqTicket.intent); // 20261030 (R-262)
                        resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 (R-262)
                    } else {
                        handsUpClientInfo.isMicConnectFlag = false;
                        handsUpClientInfo.hasMicAudio = false;

                        if (isHandsUpInit !== true) {
                            window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                            sendUnpublish("audio");
                        }

                        console.log("call changeHandsUpStatusInfo case 19");
                        let store = window.hiclasstv.store;
                        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                        alert("(5) 사용 가능한 마이크가 없거나 마이크 기능을 제공하지 않는 브라우저입니다. (Code.HC200.3)");
                        resolve(false);
                    }
                }
            } else {
                // console.log("can use new API browser version... for audio");
                let audioStream = null;

                try {
                    audioStream = await navigator.mediaDevices.getUserMedia(constraints);
                } catch (err) {
                    if (dropIfInvalid(acqTicket)) { resolve(false); return; } // 20261030 무효면 mic disable dispatch 없음 (R-239)
                    handleDOMException("setUpMicAudioStream(new)", err);

                    console.log("call changeHandsUpStatusInfo case 20");
                    let store = window.hiclasstv.store;
                    store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                } finally {
                    if (dropIfInvalid(acqTicket, audioStream)) { resolve(false); return; } // 20261030 반환 직후 판정 (R-239)
                    if (audioStream !== null && handsUpClientInfo.destination) replaceMicMixerInputForDevice(audioStream); // 20261030 PC 이전 mic 입력·원본 폐기 (R-249)
                    endAcquire(acqTicket); // 20261030 동기 인계 (R-240)
                    if (audioStream !== null) {
                        // 원본 스트림도 저장
                        handsUpClientInfo.rawAudioStream = audioStream;

                        if (handsUpClientInfo.destination) { // android/ios webview 는 이 값이 없음
                            // 수정 코드 ... by hjkim 20251106
                            // GainNode를 통해 연결하도록 수정함 ... by hjkim
                            // 다음에 재사용시 오류 방지를 위해 audioStream의 clone을 사용하도록 수정 ... by hjkim 20251105
                            handsUpClientInfo.micStreamSource = createMixerInput(handsUpClientInfo.audioCtx, audioStream, "mic"); // 20261029 clone/node 쌍 등록, 생성 실패 시 clone 반환 (R-254·R-256)
                            handsUpClientInfo.micStreamSource.connect(handsUpClientInfo.micGainNode);  // GainNode에 연결

                            handsUpClientInfo.isMicConnectFlag = true;
                            handsUpClientInfo.hasMicAudio = true;
                        } else {
                            handsUpClientInfo.hasMicAudio = true;

                            // android/ios webview 일 경우 기존 그대로 audio stream 사용 ... by hjkim 20250909
                            // 다음에 재사용시 오류 방지를 위해 audioStream의 clone을 사용하도록 수정 ... by hjkim 20251105
                            handsUpClientInfo.sendAudioStream = audioStream.clone();
                        }

                        await gotAudioStream("mic", acqTicket.intent); // 20261030 (R-262)
                        resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 (R-262)
                    } else {
                        // console.log("handsupClientInfo - ", handsUpClientInfo);
                        // 마이크가 없는 데스크탑 등의 기기를 위한 처리 추가 ... by hjkim 20251017
                        if (handsUpClientInfo.destination) { // android/ios webview 는 이 값이 없음
                            handsUpClientInfo.isMicConnectFlag = false;
                            handsUpClientInfo.hasMicAudio = false;

                            // audio mixer의 destination.stream의 기본 빈 스트림이 사용되도록 gotAudioStream 바로 호출 ... by hjkim 20251017
                            await gotAudioStream("empty", acqTicket.intent); // 20261030 (R-262)
                            resolve(isAcquireIntentOk(acqTicket.intent)); // 20261030 (R-262)
                        } else {
                            if (isHandsUpInit !== true) {
                                window.isNeedCallOnScreen = false; // 임시 ... by hjkim 20250912
                                sendUnpublish("audio");
                            }

                            console.log("call changeHandsUpStatusInfo case 21");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                            alert("(6) 사용 가능한 마이크가 없거나 마이크 기능을 제공하지 않는 브라우저입니다.  (Code.HC201.2)");
                            resolve(false);
                        }
                    }
                }
            }
        } catch (err) {
            endAcquire(acqTicket); // 20261030 동기 throw·콜백 전 예외 (R-240)
            handleDOMException("setUpMicAudioStream()", err);
            resolve(false);
        }
    });
}

/**
 * 획득한 비디오 스트림을 미디어 서버에 프로듀스하는 메서드.
 */
const gotVideoStream = async (isHandsUpInit, isCameraStream, intent) => { // 20261030 intent: 이번 웹 획득에서 이어진 호출만 전달, 없으면 기존 그대로 (web-relay R-262)
    // 수정 코드 ... by hjkim 20251031
    return new Promise(async (resolve, reject) => {
        try {
            if (!isAcquireIntentOk(intent)) { console.log("gotVideoStream - 원래 획득이 무효라 표시·송출하지 않는다."); resolve(false); return; } // 20261030 (R-262)
            console.log("gotVideoStream() --- 000");
            if (handsUpClientInfo.sendVideoStream instanceof MediaStream) {
                console.log("gotVideoStream() --- 111-1");
                if (handsUpClientInfo.videoEl) {
                    console.log("gotVideoStream() --- 111-2");
                    handsUpClientInfo.videoEl.srcObject = handsUpClientInfo.sendVideoStream;
                    handsUpClientInfo.videoEl.play().catch(err => {
                        if (err.name !== "AbortError") handleDOMException("gotVideoStream() - videoEl.play()", err);
                    });
                    console.log("gotVideoStream() --- 111-3");

                    const vTrack = handsUpClientInfo.sendVideoStream.getVideoTracks()[0];
                    setUpImageSendSize(vTrack.getSettings());
                    console.log("gotVideoStream() --- 111-4");

                    let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode;
                    console.log(`gotVideoStream() - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);

                    const params = new URLSearchParams(window.location.search);
                    const displayRotation = !isCameraStream && params.get("rotateCapture") === "-90" ? -90 : 0;
                    const sendVideoTrack = relayLive.sendVideoTrack(vTrack); // 20261030 이 호출이 만든 clone 을 회수 판정에 쓴다 (R-266)
                    const videoResult = await produceVideo(sendVideoTrack, isHighQualityMode, isCameraStream, displayRotation, intent).catch((err) => { if (intent !== undefined && sendVideoTrack !== vTrack) reclaimLiveSendTrack(sendVideoTrack, "video-clone"); throw err; }); // 20261030 거절 뒤에도 자기 clone 회수 판정, 오류는 기존대로 전달 (R-269) // 20260908 화면 공유 회전값 전달, 20261021 C3 동일 원본 송출 // 20261030 intent 전달 (R-262)
                    if (intent !== undefined && videoResult !== "ok" && sendVideoTrack !== vTrack) reclaimLiveSendTrack(sendVideoTrack, "video-clone"); // 20261030 쓰이지 않는 자기 clone 만 회수 (R-266·R-267)
                    if (!isAcquireIntentOk(intent)) { console.log("gotVideoStream - 송출 대기 중 원래 획득이 무효가 됐다. 152 를 보내지 않는다."); resolve(false); return; } // 20261030 (R-262)
                    console.log("gotVideoStream() --- 111-5");

                    if (isHandsUpInit === true) {
                        console.log("gotVideoStream() --- 111-5-1 call sendHandsUpInitDone...");
                        console.log("sendHandsUpInitDone called ... case 8");
                        sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                    }

                    console.log("gotVideoStream() --- 111-6");

                    resolve(true);
                } else {
                    console.log("gotVideoStream() --- 111-7");
                    resolve(false);
                }
            } else {
                console.log("gotVideoStream() --- 111-8");
                resolve(false);
            }
        } catch(err) {
            handleDOMException("gotVideoStream()", err);
            resolve(false);
        }
    });
}

/**
 * 획득한 비디오 스트림을 미디어 서버에 프로듀스하는 것을 도와주는 헬퍼 메서드.
 * 
 * @param {MediaStream} stream - 프로듀스할 비디오 스트림
 * @param {Boolean} isHighQualityMode - 스트림을 고화질 해상도로 보내야하는지 여부
 * @param {Boolean} isCameraStream - 카메라 스트림인지 여부
 * @since 2025-07-15.
 */
export const gotVideoStreamHelper = async (stream, isHighQualityMode, isCameraStream) => {
    try {
        handsUpClientInfo.sendVideoStream = stream;

        if (handsUpClientInfo.videoEl) {
            handsUpClientInfo.videoEl.srcObject = handsUpClientInfo.sendVideoStream;
            handsUpClientInfo.videoEl.play().catch(err => {
                if (err.name !== "AbortError") handleDOMException("gotVideoStreamHelper() - videoEl.play()", err);
            });

            const vTrack = handsUpClientInfo.sendVideoStream.getVideoTracks()[0];
            setUpImageSendSize(vTrack.getSettings());

            console.log(`gotVideoStreamHelper() - isHighQualityMode[${isHighQualityMode}], isCameraStream[${isCameraStream}]`);

            await produceVideo(relayLive.sendVideoTrack(vTrack), isHighQualityMode, isCameraStream); // 20261021 C3 동일 원본
        }
    } catch (err) {
        handleDOMException("gotVideoStreamHelper()", err);
    }
}

/**
 * 획득한 오디오 스트림을 미디어 서버에 프로듀스하는 메서드.
 * 
 * @param {String} kind - 프로듀스할 오디오 스트림 유형 또는 메서드를 호출한 유형
 */
const gotAudioStream = async (kind, intent) => { // 20261030 intent: 이번 웹 획득에서 이어진 호출만 전달, 없으면 기존 그대로 (web-relay R-262)
    // 수정 코드 ... by hjkim 20251031
    return new Promise(async (resolve, reject) => {
        try {
            if (!isAcquireIntentOk(intent)) { console.log("gotAudioStream - 원래 획득이 무효라 연결·송출하지 않는다."); resolve(false); return; } // 20261030 (R-262)
            console.log("gotAudioStream() --- 000");
            console.log("gotAudioStream() --- kind[", kind, "]");
            if (handsUpClientInfo.destination) { // android/ios webview 는 이 값이 없음
                if (handsUpClientInfo.destination.stream instanceof MediaStream) {
                    console.log("gotAudioStream() --- 111-1 - isMicOn[", handsUpClientInfo.isMicOn, "], isMuteMode[", handsUpClientInfo.isMuteMode, "]");
                    // 20251119 on/off 버튼을 눌렀을 경우 & isHandsUpInit인 경우에만 true가 되도록 여기서는 주석 처리 ... by hjkim
                    // if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;

                    console.log("gotAudioStream() --- 111-2");

                    // 수정 코드 ... by hjkim 20251106
                    // GainNode를 통해 연결하도록 수정함 ... by hjkim
                    if (handsUpClientInfo.systemStreamSource !== null && !handsUpClientInfo.isSysConnectFlag) {
                        console.log("gotAudioStream() --- 111-2-1");
                        handsUpClientInfo.isSysConnectFlag = true;
                        console.log("gotAudioStream() --- 111-2-2");
                        handsUpClientInfo.systemStreamSource.connect(handsUpClientInfo.systemGainNode);  // GainNode에 연결
                        console.log("gotAudioStream() --- 111-2-3 - 🔊 System audio reconnected through GainNode ...");
                    }

                    console.log("gotAudioStream() --- 111-3");

                    if (handsUpClientInfo.micStreamSource !== null && !handsUpClientInfo.isMicConnectFlag) {
                        console.log("gotAudioStream() --- 111-3-1");
                        handsUpClientInfo.isMicConnectFlag = true;
                        console.log("gotAudioStream() --- 111-3-2");
                        handsUpClientInfo.micStreamSource.connect(handsUpClientInfo.micGainNode);  // GainNode에 연결
                        console.log("gotAudioStream() --- 111-3-3 - 🎤 Mic reconnected through GainNode ...");
                    }

                    console.log("gotAudioStream() --- 111-4");

                    // clone 하지 않으면.. 스트림 클리어할 때 영향받아서 안된다.. by ykhan 241212
                    handsUpClientInfo.sendAudioStream = handsUpClientInfo.destination.stream.clone();

                    console.log("gotAudioStream() --- 111-5 - sendAudioStream => ", handsUpClientInfo.sendAudioStream);

                    const track = handsUpClientInfo.sendAudioStream.getAudioTracks()[0];
                    const mixedAudioStream = handsUpClientInfo.sendAudioStream; // 20261030 이 호출이 만든 destination clone (R-266)
                    const sendAudioTrack = track.clone(); // 20261030 (R-266)
                    const audioResult = await produceAudio(sendAudioTrack, intent).catch((err) => { if (intent !== undefined) { reclaimLiveSendTrack(sendAudioTrack, "audio-clone"); if (!isAcquireIntentOk(intent) && handsUpClientInfo.sendAudioStream !== mixedAudioStream) stopAcquiredStream(mixedAudioStream); } throw err; }); // 20261030 intent 전달 (R-262) · 거절 뒤에도 자기 clone 회수 (R-269)
                    if (intent !== undefined && audioResult !== "ok") reclaimLiveSendTrack(sendAudioTrack, "audio-clone"); // 20261030 쓰이지 않는 자기 clone 만 회수 (R-266·R-267)
                    if (!isAcquireIntentOk(intent)) { if (handsUpClientInfo.sendAudioStream !== mixedAudioStream) stopAcquiredStream(mixedAudioStream); console.log("gotAudioStream - 송출 대기 중 원래 획득이 무효가 됐다."); resolve(false); return; } // 20261030 볼륨 감시·dispatch 없음 (R-262·R-266)
                    console.log("gotAudioStream() --- 111-6");

                    // 20260313 isMuteMode = false인 경우에만 볼륨 상태값을 보내도록 수정 ... by hjkim
                    if (!handsUpClientInfo.isMuteMode) {
                        console.log("gotAudioStream() --- 111-7-1 - call initHandsUpMicVolumeSendProc");
                        initHandsUpMicVolumeSendProc(handsUpClientInfo.sendAudioStream);
                    } else {
                        console.log("gotAudioStream() --- 111-7-2 - don't call initHandsUpMicVolumeSendProc");
                    }

                    // 20251119 ...isMicOn 인 경우에만 바뀌도록 수정 ... by hjkim
                    if (handsUpClientInfo.isMicOn) {
                        console.log("gotAudioStream() --- 111-7 - case 1");
                        console.log("call changeHandsUpStatusInfo case 22");
                        let store = window.hiclasstv.store;
                        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
                    } else {
                        if (handsUpClientInfo.isMicDisable) {
                            console.log("gotAudioStream() --- 111-7 - case 2");
                            console.log("call changeHandsUpStatusInfo case 23");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                        } else {
                            console.log("gotAudioStream() --- 111-7 - case 3");
                            console.log("call changeHandsUpStatusInfo case 24");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
                        }
                    }

                    console.log("gotAudioStream() --- 111-8");

                    resolve(true);
                } else {
                    console.log("gotAudioStream() --- 111-0");
                    resolve(false);
                }
            } else {
                if (handsUpClientInfo.sendAudioStream instanceof MediaStream) {
                    console.log("gotAudioStream() --- 222-1 - isMicOn[", handsUpClientInfo.isMicOn, "]");
                    // 20251119 on/off 버튼을 눌렀을 경우 & isHandsUpInit인 경우에만 true가 되도록 여기서는 주석 처리 ... by hjkim
                    // if (!handsUpClientInfo.isMicOn) handsUpClientInfo.isMicOn = true;

                    console.log("gotAudioStream() --- 222-2 - sendAudioStream => ", handsUpClientInfo.sendAudioStream);

                    // android 일 경우 기존 그대로 audio stream 사용 ... by hjkim 20250909
                    const track = handsUpClientInfo.sendAudioStream.getAudioTracks()[0];
                    const sendAudioTrack = track.clone(); // 20261030 (R-266)
                    const audioResult = await produceAudio(sendAudioTrack, intent).catch((err) => { if (intent !== undefined) reclaimLiveSendTrack(sendAudioTrack, "audio-clone"); throw err; }); // 20261030 intent 전달 (R-262) · 거절 뒤에도 자기 clone 회수 (R-269)
                    if (intent !== undefined && audioResult !== "ok") reclaimLiveSendTrack(sendAudioTrack, "audio-clone"); // 20261030 (R-266·R-267)
                    if (!isAcquireIntentOk(intent)) { console.log("gotAudioStream - 송출 대기 중 원래 획득이 무효가 됐다."); resolve(false); return; } // 20261030 볼륨 감시·dispatch 없음 (R-262)
                    console.log("gotAudioStream() --- 222-3");

                    // 20260313 isMuteMode = false인 경우에만 볼륨 상태값을 보내도록 수정 ... by hjkim
                    if (!handsUpClientInfo.isMuteMode) {
                        console.log("gotAudioStream() --- 222-4-1 - call initHandsUpMicVolumeSendProc");
                        initHandsUpMicVolumeSendProc(handsUpClientInfo.sendAudioStream);
                    } else {
                        console.log("gotAudioStream() --- 222-4-2 - don't call initHandsUpMicVolumeSendProc");
                    }

                    // 20251119 ...isMicOn 인 경우에만 바뀌도록 수정 ... by hjkim
                    if (handsUpClientInfo.isMicOn) {
                        console.log("gotAudioStream() --- 222-4 - case 1");
                        console.log("call changeHandsUpStatusInfo case 25");
                        let store = window.hiclasstv.store;
                        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" }));
                    } else {
                        if (handsUpClientInfo.isMicDisable) {
                            console.log("gotAudioStream() --- 222-4 - case 2");
                            console.log("call changeHandsUpStatusInfo case 26");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "disable" }));
                        } else {
                            console.log("gotAudioStream() --- 222-4 - case 3");
                            console.log("call changeHandsUpStatusInfo case 27");
                            let store = window.hiclasstv.store;
                            store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
                        }
                    }

                    console.log("gotAudioStream() --- 222-5");

                    resolve(true);
                } else {
                    console.log("gotAudioStream() --- 222-0");
                    resolve(false);
                }
            }
        } catch (err) {
            handleDOMException("gotAudioStream()", err);
            resolve(false);
        }
    });
}

/**
 * 획득한 오디오 스트림을 미디어 서버에 프로듀스하는 것을 도와주는 헬퍼 메서드.
 * 
 * @param {MediaStream} stream - 프로듀스할 오디오 스트림
 * @param {Boolean} isPblGroupProAudio - PBL Group에서 전달한 Pro audio stream 여부
 * @since 2025-07-15.
 */
export const gotAudioStreamHelper = async (stream, isPblGroupProAudio = false) => {
    try {
        // 20260910 PBLGroup: 별도 producer helper 없이 기존 audio producer 흐름에 PBL 원본만 표시한다.
        handsUpClientInfo.isPblGroupProAudioMode = isPblGroupProAudio;
        handsUpClientInfo.sendAudioStream = stream;

        // 20260917 PBL Group: 
        if (window.isHandsUpInit) {
            // 초기값은 항상 mic off 상태로 시작하도록 수정 ... by hjkim
            handsUpClientInfo.isMicOn = false;
            handsUpClientInfo.isMuteMode = true;
        } else {
            // 20260917 PBL Group: 기존 mic on/off 상태를 유지 ... by hjkim
        }

        const track = handsUpClientInfo.sendAudioStream.getAudioTracks()[0];
        await produceAudio(track.clone());

        initHandsUpMicVolumeSendProc(handsUpClientInfo.sendAudioStream);

        /* console.log("call changeHandsUpStatusInfo case 28");
        let store = window.hiclasstv.store;
        store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "mute" })); */
    } catch (err) {
        handleDOMException("gotAudioStreamHelper()", err);
    }
}

/**
 * PBL Group Master 오버레이가 기존 Pro audio producer track 송신 상태를 변경한다.
 *
 * @param {Boolean} isEnabled - audio track 활성화 여부
 * @returns {Promise<Boolean>} 상태 변경 성공 여부
 * @since 2026-09-10.
 */
export const setPblGroupAudioTrackEnabled = async (isEnabled) => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("setPblGroupAudioTrackEnabled - enabled => ", isEnabled);

            // 20260910 PBLGroup: 기존 producer를 유지하고 audio track enabled만 변경한다.
            if (isEnabled) {
                console.log("setPblGroupAudioTrackEnabled() - enabling audio track...");
                await enableAudioTrack();
            } else {
                console.log("setPblGroupAudioTrackEnabled() - disabling audio track...");
                await disableAudioTrack();
            }

            resolve(true);
        } catch (err) {
            handleDOMException("setPblGroupAudioTrackEnabled()", err);
            resolve(false);
        }
    });
}

/** clear media source */
/**
 * 핸즈업 모드에서 사용하는 오디오 스트림을 정리.
 */
export const clearAudioInput = async () => {
    if (relayLive.keepsAudio()) return true; // 20261020 영상 전환은 공통 혼합 오디오 수명을 끝내지 않음
    return new Promise(async (resolve, reject) => {
        try {
            console.log(`clearAudioInput() - isMicDisable[${handsUpClientInfo.isMicDisable}], isMicOn[${handsUpClientInfo.isMicOn}], isMuteMode[${handsUpClientInfo.isMuteMode}]`);

            // console.log("clearAudioInput() --- 000");
            await clearMicVolumeSendProc();
            if ((await clearStreamSource()) === false) noteMixerCleanupFailure("clearStreamSource"); // 20261029 내부 false 를 종료 결과까지 전달 (R-252)

            // 20260313 isAndroidWebView()/isIOSWebView()인 경우 스크린/카메라 전환해서 status 오류 발생하므로 주석 처리 ... by hjkim
            // handsUpClientInfo.isMuteMode = true; // mic를 끄는 경우 mute값 초기화
            // handsUpClientInfo.isMicOn = false; // mic를 끄는 경우 micOn값 초기화

            if (handsUpClientInfo.sendAudioStream instanceof MediaStream) {
                console.log("clearAudioInput() - try clear sendAudioStream");
                handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                    console.log("(1) clearAudioInput() - audio track.stop()");
                    track.stop();
                });

                handsUpClientInfo.sendAudioStream = null;
                handsUpClientInfo.hasMicAudio = false;
                handsUpClientInfo.hasSystemAudio = false;
            }

            // 원본 스트림도 정리
            if (handsUpClientInfo.rawAudioStream instanceof MediaStream) {
                console.log("clearAudioInput() - try clear rawAudioStream");
                handsUpClientInfo.rawAudioStream.getTracks().forEach(track => {
                    console.log("(2) clearAudioInput() - audio track.stop()");
                    track.stop();
                });

                handsUpClientInfo.rawAudioStream = null;
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearAudioInput()", err);
            resolve(false);
        }
    });
}

/**
 * 핸즈업 모드에서 사용하는 비디오 스트림을 정리.
 */
export const clearVideoInput = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            discardMixerInput("system"); // 20261029 화면 입력을 버릴 때 그 clone 으로 만든 시스템 소리 입력도 반환 (R-248)
            // console.log("clearVideoInput()---000");
            await clearImgSendProc();

            if (handsUpClientInfo.videoEl !== undefined && handsUpClientInfo.videoEl !== null) {
                if (handsUpClientInfo.videoEl.srcObject !== undefined && handsUpClientInfo.videoEl.srcObject !== null) {
                    handsUpClientInfo.videoEl.srcObject.getTracks().forEach(track => {
                        console.log("(1) clearVideoInput() - video track.stop()");
                        track.stop();
                    });

                    handsUpClientInfo.videoEl.srcObject = null;
                }

                // 클래스 페이지에 그대로 있는 경우가 있기 때문에 null을 해선 안 됨 ... by hjkim 20210215
                // handsUpClientInfo.videoEl = null;
            }

            if (handsUpClientInfo.sendVideoStream instanceof MediaStream) {
                console.log("clearVideoInput() - try clear sendVideoStream");
                handsUpClientInfo.sendVideoStream.getTracks().forEach(track => {
                    if (track.kind === "audio") {
                        console.log("sendVideoStream에 audio track 있음 ... ");
                        console.log("(2) clearVideoInput() - video track.stop()");
                        track.stop();
                    } else {
                        console.log("(2) clearVideoInput() - video track.stop()");
                        track.stop();
                    }
                });

                handsUpClientInfo.sendVideoStream = null;
            }

            // 원본 스트림도 정리
            if (handsUpClientInfo.rawVideoStream instanceof MediaStream) {
                console.log("clearVideoInput() - try clear rawVideoStream");
                handsUpClientInfo.rawVideoStream.getTracks().forEach(track => {
                    console.log("(3) clearVideoInput() - video track.stop()");
                    track.stop();
                });

                handsUpClientInfo.rawVideoStream = null;
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearVideoInput()", err);
            resolve(false);
        }
    });
}

/**
 * 비디오 스트림을 1초에 4번씩 캡처하여 이미지로 선생님께 보내는 프로세스를 멈춤.
 */
const clearImgSendProc = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (handsUpClientInfo.imageSendProc && handsUpClientInfo.imageSendProc.current) {
                clearInterval(handsUpClientInfo.imageSendProc.current);
                handsUpClientInfo.imageSendProc.current = null;
                handsUpClientInfo.isImageProcRunning = false;
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearImgSendProc()", err);
            resolve(false);
        }
    });
}

/**
 * 마이크 오디오 스트림의 볼륨 변화를 감지하여 선생님께 보내는 프로세스를 멈춤.
 */
const clearMicVolumeSendProc = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (handsUpClientInfo.micVolumeSendProc && handsUpClientInfo.micVolumeSendProc.current) {
                clearInterval(handsUpClientInfo.micVolumeSendProc.current);
                handsUpClientInfo.micVolumeSendProc.current = null;
            }

            if (handsUpClientInfo.audioSoundMeter) {
                handsUpClientInfo.audioSoundMeter.stop();
                handsUpClientInfo.audioSoundMeter = null;
            }

            if (handsUpClientInfo.audioContext) {
                console.log("clearMicVolumeSendProc - audioContext not null.");
                if (handsUpClientInfo.audioContext.state !== "closed") {
                    console.log("clearMicVolumeSendProc - audioContex(for the mic volume proc) was not closed.");
                    console.log("clearMicVolumeSendProc - call await handsUpClientInfo.audioContext.close().");
                    await handsUpClientInfo.audioContext.close();
                } else {
                    console.log("clearMicVolumeSendProc - audioContext.state[", handsUpClientInfo.audioContext.state, "]");
                }

                console.log("clearMicVolumeSendProc - set the value handsUpClientInfo.audioContext = null.");
                handsUpClientInfo.audioContext = null;
            }

            // mic를 끄고 다시 켤 때 soundLevel를 보내지 않는 문제로 인해 추가 by hjkim 20210104
            handsUpClientInfo.soundLevel = -1;

            resolve(true);
        } catch (err) {
            handleDOMException("clearMicVolumeSendProc()", err);
            resolve(false);
        }
    });
}

const clearVoicDetectionTimeout = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (handsUpClientInfo.voiceDetectionTimeout) {
                clearTimeout(handsUpClientInfo.voiceDetectionTimeout);
                handsUpClientInfo.voiceDetectionTimeout = null;
            }
            // handsUpClientInfo.isSpeaking = false;

            resolve(true);
        } catch (err) {
            handleDOMException("clearVoicDetectionTimeout()", err);
            resolve(false);
        }
    });
}

/**
 * 마이크 스트림 / 시스템 스트림 소스를 오디오 믹서에서 disconnect 한다.
 * mic / stream 오디오 믹서 disconnect
 * 
 * @returns 마이크 스트림 소스 오디오 믹서 disconnect 성공 여부
 * @since 2025-11-22.
 */
const clearStreamSource = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            // 수정 코드 ... by hjkim 20251106
            // GainNode를 고려하여 disconnect하도록 수정함 ... by hjkim
            if (handsUpClientInfo.micStreamSource && handsUpClientInfo.micGainNode && canReleaseMixerInput(handsUpClientInfo.micStreamSource)) { // 20261029 종료 중이면 스냅샷 입력만 (R-258)
                console.log("======> mic stream source = ", handsUpClientInfo.micStreamSource);
                if (handsUpClientInfo.micStreamSource.numberOfOutputs > 0) {
                    handsUpClientInfo.micStreamSource.disconnect(handsUpClientInfo.micGainNode);  // GainNode에서 disconnect
                    handsUpClientInfo.isMicConnectFlag = false;
                }

                releaseMixerInput(handsUpClientInfo.micStreamSource); // 20261029 버리는 mic 입력의 clone 반환 (R-248)
                handsUpClientInfo.micStreamSource = null;
                handsUpClientInfo.hasMicAudio = false;
            }

            if (handsUpClientInfo.systemStreamSource && handsUpClientInfo.systemGainNode && canReleaseMixerInput(handsUpClientInfo.systemStreamSource)) { // 20261029 종료 중이면 스냅샷 입력만, 시스템 입력은 재사용 유지 (R-258)
                console.log("======> sys stream source = ", handsUpClientInfo.systemStreamSource);
                if (handsUpClientInfo.systemStreamSource.numberOfOutputs > 0) {
                    handsUpClientInfo.systemStreamSource.disconnect(handsUpClientInfo.systemGainNode);  // GainNode에서 disconnect
                    handsUpClientInfo.isSysConnectFlag = false;
                }

                // 시스템 소리 stream과 hasSystemAudio 플래그는 초기화하지 않도록 수정
                // handsUpClientInfo.systemStreamSource = null;
                // handsUpClientInfo.hasSystemAudio = false;
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearStreamSource()", err);
            resolve(false);
        }
    });
}

/**
 * 마이크 스트림 소스를 오디오 믹서에서 disconnect 한다.
 * - 시스템 오디오 스트림 소스가 없는 경우 sendAudioStream도 정리한다.
 * 
 * @returns 마이크 스트림 소스 오디오 믹서 disconnect 성공 여부
 * @since 2025-11-05.
 */
const clearMicStreamSource = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            // 수정 코드 ... by hjkim 20251106
            // GainNode를 고려하여 disconnect하도록 수정함 ... by hjkim
            if (handsUpClientInfo.micStreamSource && handsUpClientInfo.micGainNode && canReleaseMixerInput(handsUpClientInfo.micStreamSource)) { // 20261029 종료 중이면 스냅샷 입력만 (R-258)
                console.log("clearMicStreamSource ======> mic stream source = ", handsUpClientInfo.micStreamSource);
                if (handsUpClientInfo.micStreamSource.numberOfOutputs > 0) {
                    handsUpClientInfo.micStreamSource.disconnect(handsUpClientInfo.micGainNode);  // GainNode에서 disconnect
                    handsUpClientInfo.isMicConnectFlag = false;
                }

                releaseMixerInput(handsUpClientInfo.micStreamSource); // 20261029 버리는 mic 입력의 clone 반환 (R-248)
                handsUpClientInfo.micStreamSource = null;
                handsUpClientInfo.hasMicAudio = false;
            }

            // 20251105 ... 시스템 오디오 스트림 소스가 없는 경우 sendAudioStream도 정리하도록 수정 ... by hjkim
            if (handsUpClientInfo.systemStreamSource === null && !handsUpClientInfo.isSysConnectFlag) {
                if (handsUpClientInfo.sendAudioStream) {
                    console.log("clearMicStreamSource ======> try clear sendAudioStream = ", handsUpClientInfo.sendAudioStream);
                    handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                        track.stop();
                    });

                    handsUpClientInfo.sendAudioStream = null;
                    handsUpClientInfo.hasMicAudio = false;
                    handsUpClientInfo.hasSystemAudio = false;
                }
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearMicStreamSource()", err);
            resolve(false);
        }
    });
}

/**
 * 시스템 오디오 스트림 소스를 오디오 믹서에서 disconnect 한다.
 * - 마이크 스트림 소스가 없는 경우 sendAudioStream도 정리한다.
 * 
 * @returns 시스템 스트림 소스 오디오 믹서 disconnect 성공 여부
 * @since 2025-11-05.
 */
const clearSystemStreamSource = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            // 수정 코드 ... by hjkim 20251106
            // GainNode를 고려하여 disconnect하도록 수정함 ... by hjkim
            if (handsUpClientInfo.systemStreamSource && handsUpClientInfo.systemGainNode && canReleaseMixerInput(handsUpClientInfo.systemStreamSource)) { // 20261029 종료 중이면 스냅샷 입력만 (R-258)
                console.log("clearSystemStreamSource ======> sys stream source = ", handsUpClientInfo.systemStreamSource);
                if (handsUpClientInfo.systemStreamSource.numberOfOutputs > 0) {
                    handsUpClientInfo.systemStreamSource.disconnect(handsUpClientInfo.systemGainNode);  // GainNode에서 disconnect
                    handsUpClientInfo.isSysConnectFlag = false;
                }

                releaseMixerInput(handsUpClientInfo.systemStreamSource); // 20261029 버리는 시스템 입력의 clone(화면 video 포함) 반환 (R-248)
                handsUpClientInfo.systemStreamSource = null;
                handsUpClientInfo.hasSystemAudio = false;
            }

            // 20251105 ... 마이크 스트림 소스가 없는 경우 sendAudioStream도 정리하도록 수정 ... by hjkim
            if (handsUpClientInfo.micStreamSource === null && !handsUpClientInfo.isMicConnectFlag) {
                if (handsUpClientInfo.sendAudioStream) {
                    console.log("clearSystemStreamSource ======> try clear sendAudioStream = ", handsUpClientInfo.sendAudioStream);
                    handsUpClientInfo.sendAudioStream.getTracks().forEach(track => {
                        track.stop();
                    });

                    handsUpClientInfo.sendAudioStream = null;
                    handsUpClientInfo.hasMicAudio = false;
                    handsUpClientInfo.hasSystemAudio = false;
                }
            }

            resolve(true);
        } catch (err) {
            handleDOMException("clearSystemStreamSource()", err);
            resolve(false);
        }
    });
}

/** etc */
/**
 * 메서드명과 오류를 함께 로그 메시지로 출력하는 메서드.
 * 
 * @param {String} func - 메서드명
 * @param {Error} err - 오류
 */
const handleDOMException = (func, err) => {
    if (err instanceof DOMException) {
        console.log(`handleDOMException [${func}] - DOMException name[${err.name}], message: ${err.message}`);
    } else if (err instanceof Error) {
        console.log(`handleDOMException [${func}] - Error name[${err.name}], message: ${err.message}`);
    } else {
        console.log(`handleDOMException [${func}] - An error occurred ... err => `, err);
    }
}

/**
 * 메서드명과 변수명, 변수의 값을 함께 로그 메시지로 출력하는 메서드.
 * 
 * @param {String} func - 메서드명
 * @param {String} name - value 변수명
 * @param {any} value - 로그 메시지로 출력할 변수
 */
const handleLogMessage = (func, name, value) => {
    // console.log(`[${func}] ${name} => ${value}`);
    console.log(`[${func}] ${name} => `, value);
}

/**
 * Pentalk에서 지원할 수 있는 비디오 입력 장치인지 여부를 확인하는 메서드
 * 
 * @param {MediaDeviceInfo} device - 비디오 입력 장치 정보
 * @returns {Boolean} Pentalk에서 지원할 수 있는 비디오 입력 장치인지 여부
 */
const checkEnabledVideoInput = (device) => {
    if (device.label.indexOf("3D Camera") !== -1 && device.label.indexOf("Virtual Driver") !== -1) {
        return false;
    }

    /* if (device.label.indexOf("CyberLink") !== -1 && device.label.indexOf("Splitter") !== -1) {
       return false;
    } */

    /* if (device.label.indexOf("Splitter") !== -1) {
       return false;
    } */

    if (handsUpClientInfo.videoInputInfo.list_videoInput.length > 0) {
        const check_info = handsUpClientInfo.videoInputInfo.list_videoInput.find(info => info.deviceId === device.deviceId);
        if (check_info !== undefined && check_info !== null) {
            console.log("checkEnabledVideoInput() - already has this video input");
            return false;
        }
    }

    return true;
}

/**
 * Pentalk에서 지원할 수 있는 오디오 입력 장치인지 여부를 확인하는 메서드
 * - 오디오 입력 장치의 deviceLabel에 VB-Audio / CABLE Output 포함 여부로 판단
 * 
 * @param {String} deviceLabel - 오디오 입력 장치 라벨 문자열
 * @returns {Boolean} Pentalk에서 지원할 수 있는 오디오 입력 장치인지 여부
 */
const checkEnabledAudioInput = (deviceLabel) => {
    if (deviceLabel !== undefined && deviceLabel !== null) {
        if (deviceLabel.indexOf("CABLE Output") !== -1 && deviceLabel.indexOf("VB-Audio") !== -1 && deviceLabel.indexOf("Virtual Cable")) {
            return false;
        }
    }

    return true;
}

/**
 * deviceId가 기본 오디오 입력 장치인지 여부를 확인하는 메서드
 * 
 * @param {MediaDeviceInfo} device - 오디오 입력 장치 정보
 * @returns {Boolean} deviceId가 기본 오디오 입력 장치인지 여부
 */
const checkDefaultAudioInput = (device) => {
    if (handsUpClientInfo.audioInputInfo.defaultAudioInput.deviceId === null || handsUpClientInfo.audioInputInfo.defaultAudioInput.groupId === null) {
        return false;
    }

    if (device === undefined || device === null) {
        return false;
    }

    if (handsUpClientInfo.audioInputInfo.defaultAudioInput.deviceId === "default") {
        if (handsUpClientInfo.audioInputInfo.defaultAudioInput.groupId !== device.groupId) {
            return false;
        }
    } else { // dafult deviceId가 default가 아닌 경우... by hjkim 20220316
        if (handsUpClientInfo.audioInputInfo.defaultAudioInput.deviceId !== device.deviceId) {
            return false;
        }
    }

    if (handsUpClientInfo.audioInputInfo.defaultAudioInput.label.indexOf(device.label) === -1) {
        return false;
    }

    return true;
}

/**
 * 사용할 수 있는 오디오 입력 장치가 있는지를 확인 후 반환하는 메서드
 * - currentAudioInput 또는 defaultAudioInput를 반환.
 * 
 * @returns {MediaDeviceInfo} - 오디오 입력 장치 정보
 */
const getAudioInputDeviceInfo = () => {
    console.log("getAudioInputDeviceInfo - audioInputInfo.currentAudioInput.deviceId => ", handsUpClientInfo.audioInputInfo.currentAudioInput.deviceId);
    const currentDeviceId = handsUpClientInfo.audioInputInfo.currentAudioInput.deviceId;
    console.log("getAudioInputDeviceInfo - currentDeviceId => ", currentDeviceId);
    if (currentDeviceId === undefined || currentDeviceId === null) {
        const defaultDeviceId = handsUpClientInfo.audioInputInfo.defaultAudioInput.deviceId;
        if (defaultDeviceId === undefined || defaultDeviceId === null) {
            return { deviceId: null, groupId: null, label: null };
        } else {
            return handsUpClientInfo.audioInputInfo.defaultAudioInput;
        }
    } else {
        return handsUpClientInfo.audioInputInfo.currentAudioInput;
    }
}

/**
 * 현재 p2p mode 인지를 체크하기 위한 메서드.
 * 
 * @returns {Boolean} p2p모드 여부
 */
const getIsP2PMode = () => {
    return handsUpClientInfo.isP2PMode;
}

/**
 * 안드로이드에서 화면 공유 시 선생님에게 별도 프로세스로 handsUp init done을
 * 보내기 위한 메서드.
 */
export const androidHandsUpInitDone = async () => {
    console.log("androidHandsUpInitDone - isAndroidWebView[" + isAndroidWebView() + "]");
    if (isAndroidWebView()) {
        // 혹시라도 앱 설치 후 첫 실행이거나 권한 제거 등으로 인해 앱은 설치되어 있으나 앱 권한 재부여 이슈로 인해 timer 설정 시간이 지나서 img send process가 실행 중일 수도 있으므로 clear function 호출 ... by hjkim 20230519
        await clearImgSendProc();

        console.log("androidHandsUpInitDone - call sendHandsUpInitDone");
        console.log("sendHandsUpInitDone called ... case 9");
        sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

        /* // 20251124 ... init done 메시지 보낸 후, 다시 false로 변경
        window.isHandsUpInit = false; */
    } else {
        console.log("androidHandsUpInitDone - not android webview devide!");
    }
}

/**
 * 실행 중이던 timerProc와 tempTimerProc를 clear하는 메서드.
 * 
 * @param isClearTempTimer - tempTimerProc도 정리할지 여부
 * @returns {Promise<Boolean>} 
 */
export const clearTimerProc = async (isClearTempTimer) => {
    return new Promise(async (resolve) => {
        console.log("clearTimerProc - isClearTempTimer[", isClearTempTimer, "]");
        if (handsUpClientInfo.timerProc !== undefined && handsUpClientInfo.timerProc !== null) {
            clearTimeout(handsUpClientInfo.timerProc);
        }

        handsUpClientInfo.timerProc = null;

        if (isClearTempTimer) {
            if (handsUpClientInfo.tempTimerProc) {
                clearTimeout(handsUpClientInfo.tempTimerProc);
            }

            handsUpClientInfo.tempTimerProc = null;

            // console.log("call setScreenModeImage(not-connect) case 4");
            // setScreenModeImage("not-connect");
        }

        // 20251208 ... clear timer proc 후에 send image proc도 존재하는 경우 정리하기 추가
        if (handsUpClientInfo.imageSendProc) {
            await clearImgSendProc();

            // console.log("call setScreenModeImage(not-connect) case 5");
            // setScreenModeImage("not-connect");
        }

        resolve(true);
    });
}

/**
 * 안드로이드 Pro용 앱 웹뷰로 실행되었는지 여부를 반환
 * 
 * @returns {Boolean} 안드로이드 Pro용 앱 웹뷰로 실행되었는지 여부
 * @since 2025-12-16.
 */
export const isAndroidWebView = () => {
    if (typeof window.isPentalkAndr === "function") {
        let _isAndroidWebView = window.isPentalkAndr();
        return _isAndroidWebView;
    } else {
        return false;
    }
}

/**
 * android device 인지 여부를 체크 후 그 값을 반환한다.
 * 
 * @returns {Boolean} android device 여부
 */
export const getIsAndroidDevice = () => {
    return handsUpClientInfo.isAndroidDevice;
}

/**
 * 현재 영상 공유 모드가 카메라 모드이고,
 * Android 용 Pentalk OnScreen 앱이 사용 가능한 상태인지
 * 확인하기 위한 메서드.
 * 
 * @returns {Boolean} 카메라 모드 여부 및 Android용 Pentalk OnScreen 앱 사용 가능 여부
 * @since 2025-09-12.
 */
export const checkAndroidCameraValue = () => {
    return handsUpClientInfo.viewKind === "CAMERA" && isAndroidWebView();
}

/**
 * 현재 영상 공유 모드가 스크린 모드이고,
 * Android 용 Pentalk OnScreen 앱이 사용 가능한 상태인지
 * 확인하기 위한 메서드.
 * 
 * @returns {Boolean} 스크린 모드 여부 및 Android용 Pentalk OnScreen 앱 사용 가능 여부
 * @since 2021-10-18. (@modify 2025-10-14. 메서드명 변경)
 */
export const checkAndroidScreenValue = () => {
    return handsUpClientInfo.viewKind === "SCREEN" && isAndroidWebView();
}

/**
 * 
 * @param {Boolean} isHandsUpInit - 
 */
export const checkAndroidPenCamService = (isHandsUpInit) => {
    console.log("checkAndroidPenCamService - isHandsUpInit[", isHandsUpInit, "], window.isHandsUpInit[", window.isHandsUpInit, "]");

    if (isAndroidWebView()) {
        console.log("case 4:) call sendStartPentalkOnScreenForAndroid ... ");
        sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

        setScreenModeImage("connect");
    }

    /* // 20260310 기존 코드 주석 처리 ... by hjkim
    if (getIsAlivePenCamService()) {
        console.log("sendStartPentalkOnScreenForAndroid called ... case 4");
        sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

        setScreenModeImage("connect");
    } else {
        console.log("sendStartPentalkOnScreenForAndroid called ... case 5");
        sendStartPentalkOnScreenForAndroid(false, isReconnMode, handsUpClientInfo.isP2PMode, isHandsUpInit, handsUpClientInfo.configFPSKind);

        handsUpClientInfo.timerProc = setTimeout((isHandsUpInit) => {
            if (document.webkitHidden || document.hidden) {
                console.log("앱 설치되지 않은 케이스! (1)");
                handsUpClientInfo.isAvailableApp = false; // 앱 설치되지 않은 케이스

                startCanvasImageSendProc();

                if (isHandsUpInit === true) {
                    console.log("sendHandsUpInitDone called ... case 10");
                    sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                }

                console.log("call setScreenModeImage(not-connect) case 6");
                setScreenModeImage("not-connect");

                let str = "스크린 캡처를 지원하지 않는 브라우저이기에\n";
                if (handsUpClientInfo.localStreamingMode !== 0) {
                    if (handsUpClientInfo.localStreamingMode === 1) {     // 1 ... 1명 보기 / PT / SmartTV Group mode ( 1920 x 1080 )
                        str += "WebRTC 모드를 실행할 수 없습니다.\n";
                    } else {                            // 2 ... 2명 보기 mode ( 1280 x 720 ) & 4 ... 4명 보기 / 6명 보기 / 8명 보기 / 9명 보기 mode ( 960 x 540 )
                        str += "P2P 모드를 실행할 수 없습니다.\n";
                    }
                } else {                                // 0 ... Thumbnail ( 640 x 360 ) mode
                    str += "화면 전송 모드를 실행할 수 없습니다.\n";
                }

                str += "스크린 캡처 모드가 지원되기 위해서는\n";
                // str += "반드시 [Pentalk onScreen] 앱이 설치되어야 합니다.\n";
                str += "[Pentalk onScreen] 앱을 설치한 후에 해당 기능을 사용할 수 있습니다. (Code.HC304.1)";
                console.log("(1) str => ", str);
                alert(str);

                // if (handsUpClientInfo.isP2PMode) {
                //     if (isHandsUpInit !== true) {
                //         // mediaSoup server 에 알려주고... sendUnpublish("video") .....
                //     }

                //     alert("스크린 캡처를 지원하지 않는 브라우저이기에 P2P 모드를 실행할 수 없습니다. (Code.HC304.1)");
                // }
            } else {
                console.log("앱 설치된 케이스! 앱 정상적으로 실행됨!");
                console.log("call setScreenModeImage(not-connect) case 7");
                setScreenModeImage("not-connect");
            }

            clearTimerProc();
        }, timerProcDelayTime, isHandsUpInit);
    } */
}

/**
 * iOS Camera ---> Screen Mode
 */
export const checkIOSPenCamService = (isHandsUpInit) => {
    console.log("checkAndroidPenCamService - isHandsUpInit[", isHandsUpInit, "], window.isHandsUpInit[", window.isHandsUpInit, "]");
    console.log("sendStartPentalkOnScreenForIOS called ... case 1");
    sendStartPentalkOnScreenForIOS(handsUpClientInfo.isP2PMode, handsUpClientInfo.configFPSKind);
    setScreenModeImage("connect");
}

/**
 * 현재 마이크 상태값을 선생님에게 전송하는 메서드.
 */
export const sendMicStatus = () => {
    if (handsUpClientInfo.isMicDisable) {
        console.log("sendMicStatus case 1 - call sendP2PSoundOff");
        // let store = window.hiclasstv.store;
        // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "muteDisable" }));
        sendP2PSoundOff(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
    } else {
        /* if (window.isHandsUpInit) {
            if (handsUpClientInfo.isMicOn) {
                console.log("sendMicStatus case 2");
                // sendP2PSoundOn(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

                // let store = window.hiclasstv.store;
                // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "on" }));
            } else {
                if (ConstData.IS_LOCAL_VERSION) {
                    console.log("sendMicStatus case 3");
                    sendP2PSoundReadyLocal(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

                    // let store = window.hiclasstv.store;
                    // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
                } else {
                    console.log("sendMicStatus case 4");
                    sendP2PSoundOff(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

                    // let store = window.hiclasstv.store;
                    // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
                }
            }
        } */

        if (handsUpClientInfo.isMicOn) {
            console.log("sendMicStatus case 2 - sendP2PSoundOn");

            sendP2PSoundOn(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

            // let store = window.hiclasstv.store;
            // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "on" }));
        } else {
            console.log("sendMicStatus case 3 - call sendP2PSoundOff");
            sendP2PSoundOff(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);

            // let store = window.hiclasstv.store;
            // store.dispatch(changeHandsUpStatusInfo({ kind: "mic", status: "off" }));
        }
    }
}

/**
 * 현재 마이크의 상태값을 반환한다.
 * 
 * @returns 마이크의 상태값
 * @since 2025-10-30.
 */
export const getMicStatusEnabled = () => {
    // 20260917 PBL Group audio track은 허용 상태와 실제 MIC_ON 상태가 모두 있어야만 송출한다.
    if (handsUpClientInfo.isPblGroupProAudioMode) {
        return !handsUpClientInfo.isMicDisable && handsUpClientInfo.isMicOn;
    }

    /* if (handsUpClientInfo.isMicDisable) {
        console.log("getMicStatusEnabled case 1");
        return false;
    } else {
        if (handsUpClientInfo.isMicOn) {
            console.log("getMicStatusEnabled case 2");
            return true;
        } else {
            console.log("getMicStatusEnabled case 3");
            return false;
        }
    } */

    if (handsUpClientInfo.isMicOn) {
        console.log("getMicStatusEnabled case 1");
        return true;
    } else {
        console.log("getMicStatusEnabled case 2");
        return false;
    }
}

/** PBL Group에서 전달한 Pro audio producer 사용 여부를 반환한다. */
export const getIsPblGroupProAudioMode = () => {
    return handsUpClientInfo.isPblGroupProAudioMode;
}

/**
 * 안드로이드용 앱 호출시 user gesture가 필요하기에
 * handsUp이 시작되지 않았더라도 Pentalk on Screen 앱을 호출하는 메서드.
 */
export const initialize = () => {
    // console.log(`initialize - handsUpClientInfo.viewKind[${handsUpClientInfo.viewKind}]`);
    // handsUpClientInfo.viewKind = "SCREEN"; // 임시
    if (navigator && navigator.userAgent) {
        let userAgent = navigator.userAgent.toLowerCase();
        console.log("initialize - userAgent[" + userAgent + "]");

        if (userAgent.indexOf("mobile") > -1 || userAgent.indexOf("iphone") > -1 || userAgent.indexOf("android") > -1
            || ((userAgent.indexOf("windows") > -1 || userAgent.indexOf("cros") > -1 || userAgent.indexOf("macintosh") > -1) && navigator.maxTouchPoints > 2)) {
            handsUpClientInfo.isMobile = true;
        }

        let isAndroid = userAgent.indexOf("android") > -1;
        if (isAndroid) {
            handsUpClientInfo.isAndroidDevice = true;
        }

        let isPentalkAndr = isAndroidWebView();
        if (isPentalkAndr) {
            console.log("initialize - Android WebView 페이지 로드 완료");
            handsUpClientInfo.isAndroidDevice = true;
        }

        console.log("initialize - isMobile[" + handsUpClientInfo.isMobile + "]");
        console.log("initialize - isAndroidDevice[" + handsUpClientInfo.isAndroidDevice + "]");
        console.log("initialize - isPentalkAndr[" + isPentalkAndr + "]");
    }

    if (checkAndroidScreenValue()) {
        console.log("case 6:) call sendStartPentalkOnScreenForAndroid called ... ");
        // console.log("initialize - call connect pentalk on screen app");
        sendStartPentalkOnScreenForAndroid(false, false, false, false, handsUpClientInfo.configFPSKind);

        /* handsUpClientInfo.timerProc = setTimeout(() => {
            if (document.webkitHidden || document.hidden) {
                handsUpClientInfo.isAvailableApp = false;
            }

            clearTimerProc(true);
        }, 2000); */
    }
}

/**
 * 믹스드 클래스 멤버인지 여부를 설정하는 메서드
 * 
 * @param {Boolean} isMixedClassMember - 믹스드 클래스 멤버 여부
 */
export const setIsMixedClassMember = (isMixedClassMember) => {
    console.log(`setIsMixedClassMember - isMixedClassMember[${isMixedClassMember}], handsUpClientInfo.isMixedClassMember[${handsUpClientInfo.isMixedClassMember}]`);
    handsUpClientInfo.isMixedClassMember = isMixedClassMember;
}

/**
 * 공유할 비디오 스트림의 해상도를 설정하는 메서드.
 * 
 * @param {Number} width - 공유할 비디오 스트림 해상도의 너비
 * @param {Number} height - 공유할 비디오 스트림 해상도의 높이
 */
export const setScreenVideoResolution = (width, height) => {
    console.log(`setScreenVideoResolution - width[${width}], height[${height}]`);
    let isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode;
    let isCameraStream = handsUpClientInfo.viewKind === "CAMERA";
}

/**
 * 현재 설정된 topKind를 반환하는 메서드.
 * - p2pMode와 동일.
 * 
 * @returns {String} topKind
 */
export const getTopKind = () => {
    return handsUpClientInfo.topKind;
}

/**
 * LG 스마트TV와 인터넷 속도를 고려한 맞춤 프레임 속도 값을 선생님에게 전송받아서
 * 설정하는 메서드.
 *  
 * @param {Number} lSeq - 클래스 시퀀스 번호
 * @param {String} configFPS - 프레임
 */
export const setConfigFPS = (lSeq, configFPS) => {
    console.log("setConfigFPS - configFPS => ", handsUpClientInfo.configFPS, ", new_configFPS => ", configFPS);

    if (handsUpClientInfo.liveSeq === lSeq) {
        if (handsUpClientInfo.configFPS !== configFPS) {
            handsUpClientInfo.configFPS = configFPS;

            if (configFPS === 0) {
                handsUpClientInfo.configFPSKind = stTimeKind.TWELVE_FRAMES;
            } else if (configFPS === 1) {
                handsUpClientInfo.configFPSKind = stTimeKind.TEN_FRAMES;
            } else if (configFPS === 2) {
                handsUpClientInfo.configFPSKind = stTimeKind.SEVEN_FRAMES;
            } else {
                handsUpClientInfo.configFPSKind = stTimeKind.FOUR_FRAMES;
            }

            // 안드로이드 WebView이면 앱에 전달 — 앱에서 모드별 해상도/fps 계산 후 Producer 업데이트
            if (relayLive.nativeScreen(isAndroidWebView())) { // 20261021 C3 사양 변경은 웹 sender만 조절
                window.callNetImageFrames(configFPS);
            }

            // PC 브라우저 → MediaSoupClient를 통해 직접 해상도/fps 적용
            if (relayLive.keepsAudio() || handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode) { // 20261021 C3 전체보기에서도 사양 반영
                const isHighQualityMode = handsUpClientInfo.isP2PMode || handsUpClientInfo.isSmartTVMode;
                // const p2pMode = handsUpClientInfo.p2pMode();  // 현재 활성 p2pMode
                const p2pMode = currentP2PMode(
                    handsUpClientInfo.localStreamingMode,
                    handsUpClientInfo.smartTVP2PMode
                );  // 현재 활성 p2pMode

                console.log(`setConfigFPS - PC 환경 applyConfigFPS 호출: configFPS[${configFPS}], p2pMode[${p2pMode}]`);
                applyConfigFPS(configFPS, p2pMode, isHighQualityMode);
            }
        }
    }
}

/**
 * 2가지 p2pMode를 비교 후 더 우선시되는 p2pMode를 반환한다.
 * 
 * @param {Number} p2pMode1 - 비교할 p2pMode 1
 * @param {Number} p2pMode2 - 비교할 p2pMode 2
 * @returns {Number} 우선시되는 p2pMode
 */
const currentP2PMode = (p2pMode1, p2pMode2) => {
    if (p2pMode1 === enP2PMode.P1P) {
        return p2pMode1;
    } else {
        // 원래 'p2pMode1 == enP2PMode.Thumbnail'로 되어있었는데,
        // 오타인가 해서 'p2pMode1 === enP2PMode.Thumbnail'로 수정함 ... by hjkim 20251106
        if (p2pMode1 === enP2PMode.Thumbnail) {
            if (p2pMode2 !== enP2PMode.Thumbnail) {
                return p2pMode2;
            }
        } else if (p2pMode1 === enP2PMode.P2P) {
            if (p2pMode2 === enP2PMode.P1P) {
                return p2pMode2;
            } else {
                return p2pMode1;
            }
        } else { // enP2PMode.P4P
            if (p2pMode2 === enP2PMode.P1P) {
                return p2pMode2;
            } else {
                return p2pMode1;
            }
        }
    }

    return enP2PMode.Thumbnail;
}

/**
 * Pentalk onScreen 앱 연결 이미지 설정 및 viewKind를 screen으로 설정
 * for android
 * 
 * @param {String} kind - 앱 연결 이미지 유형
 */
export const setScreenModeImage = (kind) => {
    if (relayLive.screenImage(handsUpClientInfo)) return; // 20261020 C3 화면 스트림을 앱 연결 이미지로 덮지 않음
    if (handsUpClientInfo.handsUpFunc) {
        handsUpClientInfo.handsUpFunc("viewKind_screen");
        
        if (kind === "connect") {
            console.log("setScreenModeImage - android_appConnect");
            handsUpClientInfo.handsUpFunc("android_appConnect");

            if (isIOSWebView()) {
                handsUpClientInfo.isStreamingiOSApp = true;
                startIOSRelaySession("screen-connect"); // 20261022 [IOS-RELAY] 앱 relay 로컬 연결 준비(미지원 앱은 무동작)
            }
        } else if (kind === "not-connect") {
            console.log("setScreenModeImage - android_appNotConnect");
            handsUpClientInfo.handsUpFunc("android_appNotConnect");
            handsUpClientInfo.isStreamingiOSApp = false;
        }
        // handsUpClientInfo.handsUpFunc("mic_disable"); // 20250221 여러번 클릭되는 경우 오류가 없도록 우선 disable 처리 ... by hjkim
        // handsUpClientInfo.handsUpFunc("hImg_visible");
    }
}

/**
 * Pbl 모드 브라우저 구분 값 반환
 * 
 * @returns {Boolean} Pbl 모드 브라우저 여부
 * @since 2025-07-11.
 */
export const getIsForPblModeBrowser = () => {
    return handsUpClientInfo.isForPblMode && handsUpClientInfo.isForPblModeBrowser;
}

/**
 * Pbl 모드 브라우저 구분 값 설정
 * 
 * @param {Boolean} isForPblBrowser - Pbl 모드 브라우저 여부
 * @since 2025-07-07.
 */
export const setIsForPblModeBrowser = (isForPblBrowser) => {
    // 20250707 Pbl 모드 브라우저 구분 ... by hjkim
    if (isForPblBrowser) {
        handsUpClientInfo.isForPblModeBrowser = true;
        handsUpClientInfo.isForPblMode = true;
    } else {
        handsUpClientInfo.isForPblModeBrowser = false;
        handsUpClientInfo.isForPblMode = false;
    }
}

/**
 * iOS 기기 여부를 확인하는 함수
 * iPhone, iPad, iPod touch를 감지
 * 
 * @returns {Boolean} iOS 기기 여부
 * @since 2025-11-28.
 */
const isIOSDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iPad, iPhone, iPod 감지
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    // iOS 13+ iPad는 userAgent에서 "Macintosh"로 표시되므로 터치 이벤트로 추가 확인
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    return isIOS || isIPadOS;
};

/**
 * iOS Safari 브라우저 여부를 확인하는 함수
 * 
 * @returns {Boolean} iOS Safari 여부
 * @since 2025-11-28.
 */
const isIOSSafari = () => {
    if (!isIOSDevice()) return false;

    const userAgent = navigator.userAgent;

    // Safari이지만 Chrome, Firefox 등이 아닌 경우
    const isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(userAgent);

    return isSafari;
};

/**
 * iOS 버전을 반환하는 함수
 * 
 * @returns {Number|null} iOS 버전 (예: 15.4) 또는 null
 * @since 2025-11-28.
 */
const getIOSVersion = () => {
    if (!isIOSDevice()) return null;

    const userAgent = navigator.userAgent;
    const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);

    if (match) {
        const major = parseInt(match[1], 10);
        const minor = parseInt(match[2], 10);
        const patch = match[3] ? parseInt(match[3], 10) : 0;
        return parseFloat(`${major}.${minor}${patch}`);
    }

    return null;
};

/**
 * iOS WebView 접속 여부
 */
export const isIOSWebView = () => {
    // console.log("is ios webview check - ");
    // if (window.webkit) {
    //     console.log("webkit 있음");
    //     if (window.webkit.messageHandlers) {
    //         console.log("message handler 있음");
    //         if (window.webkit.messageHandlers.screenShareHandler) {
    //             console.log("screen share handler 있음");
    //         }
    //     }
    // } 
    // return true;
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.screenShareHandler) {
        return true;
    } else {
        return false;
    }
}

/**
 * ViewKind 변경 시, App <----> Web 메시지 처리
 */
export const sendChangeViewKindToApp = () => {
    // 261006 스크린으로 전환하면 카메라 중단/재개 패킷 해제 (카메라 전환은 setUpVideoStream에서 등록)
    if (handsUpClientInfo.viewKind !== "CAMERA") {
        syncIOSCameraStatePackets(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq, false);
    }
    let message = {
        action: "changeViewKind",
        data: { kind: handsUpClientInfo.viewKind }
    }

    window.webkit.messageHandlers.screenShareHandler.postMessage(message);
}

/**
 * iOS WebView Handler
 * iOS App --> Web 으로 보내는 메시지 콜백 처리
 */
window.handleiOSScreenShareMessage = async function (message) {
    const { action, data } = message;
    //console.log("📨 iOS ScreenShare Message: ", action, data);

    if (action !== "pro-rcvRbmqMessage") console.log("📨 iOS ScreenShare Message: ", action, data);
    
    let store = window.hiclasstv.store;

    switch (action) {
        /**
         * 기능과 관련된 부분 
         */
        case "pro-startedScreenShare":
            setScreenModeImage("connect");

            if (window.isHandsUpInit) {
                sendHandsUpInitDone(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
                sendP2PSoundOff(handsUpClientInfo.liveSeq, handsUpClientInfo.userSeq);
            }
            break;

        case "pro-stoppedScreenShare":
            console.log("🔌 stoppedScreenShare:");
            setScreenModeImage("not-connect");
            break;

        case "pro-micOn":
            rcvCmd_AndroidMicStatus(handsUpClientInfo.userSeq, true);
            //handsUpClientInfo.handsUpFunc("android_appMic", true);
            break;

        case "pro-micOff":
            rcvCmd_AndroidMicStatus(handsUpClientInfo.userSeq, false);
            //handsUpClientInfo.handsUpFunc("android_appMic", false);
            break;

        // 261015 iOS 앱(ProAudioMixDevice)의 소리 설정(마이크/시스템 소리 포함) 결과 → 공통 소리 설정 이벤트로 전달
        case "pro-audioSourceSettingsResult":
            window.dispatchEvent(new CustomEvent("handsUpAudioSourceSettingsResult", { detail: data }));
            break;

        // 261015 교사 요청을 앱이 직접 적용·회신한 경우 학생 소리 설정 패널에도 반영
        case "pro-audioSourceSettingsApplied":
            window.dispatchEvent(new CustomEvent("handsUpAudioSourceSettingsApplied", { detail: data }));
            break;

        // [261015-IOS-COMPAT] 하위호환: 앱이 소리 설정 지원을 알려온 경우에만 새 iOS 소리 설정 동작을 사용한다.
        // (이전 앱은 이 응답이 없어 기존 동작 유지) 모든 사용자가 새 앱으로 업데이트되면 [261015-IOS-COMPAT] 검색해 일괄 제거.
        case "pro-audioSourceSupported":
            window.isIOSNativeAudioSourceSupported = data?.supported === true;
            console.log("[261015-IOS-COMPAT] isIOSNativeAudioSourceSupported => ", window.isIOSNativeAudioSourceSupported);
            break;

        case "changedViewKind": 
            if (handsUpClientInfo.viewKind === "CAMERA") {
                await initHandsUpMic(false);
                setUpVideoStream(false);
            } else {
                setScreenModeImage("connect");
            }
            break;

        /**
         * RBMQ 연결 및 주고받는 메시지 관련된 부분
         */
        case "pro-connectedRbmq":
            if (data.kind === "mixed-class") {
                handsUpClientInfo.isConnectediOSApp = true;
                store.dispatch(onSuccessConnectForMixedClass());
                //store.dispatch(onSuccessSubscribeTempKeyForMixedClass());
            } else {
                handsUpClientInfo.isConnectediOSApp = true;
                store.dispatch(onSuccessConnect());
                //store.dispatch(rbmqServerConnected());
            }
            break;

        case "pro-disconnectedRbmq":
                setIsAlivePenCamService(false, handsUpClientInfo.userSeq);
                setIsIntentionalDisconnect(true); // PC mqtt 라이브러리 변경으로 인해 정상 동작을 위한 처리 추가 ... by hjkim 20260413
                onConnectionLost({ errorCode: enRbmqError.OK });    // 다음 로그인을 위한 처리 추가
            break;

        case "pro-successedSubscribeWeb":
            console.log("웹 바인딩 완료: ", data.bindKeys);
            if (handsUpClientInfo.isMixedClassMember) {
                console.log("✅ 웹 구독 성공 - 믹스드 클래스 멤버인 경우");
                store.dispatch(onSuccessSubscribeForMixedClass());
            } else {
                console.log("✅ 웹 구독 성공");
                store.dispatch(onSuccessSubscribe());
            }
            break;

        case "pro-successedUnsubscribeWeb":
            console.log("웹 바인딩 해제 완료: ");
            store.dispatch(onSuccessUnsubscribe());
            break;
        
        case "pro-successedSubscribeLive":
            console.log("Live 바인딩 완료: ", data.bindKeys);
            store.dispatch(onSuccessSubscribeLive());
            break;

        case "pro-successedUnsubscribeLive":
            console.log("Live 바인딩 해제 완료");
            store.dispatch(onSuccessUnsubscribeLive());
            break;

        case "pro-successedSubscribeSmallGroup":
            console.log("SmallGroup 바인딩 완료: ", data.bindKeys);
            store.dispatch(onSuccessSubscribeSmallGroup());
            break;

        case "pro-successedUnsubscribeSmallGroup":
            console.log("SmallGroup 바인딩 해제 완료: ", data.bindKeys);
            break;

        case "pro-successedSubscribeTempKey":
            console.log("Temp 키 구독 완료: ", data.bindKeys);
            store.dispatch(onSuccessSubscribeTempKeyForMixedClass());
            break;

        case "pro-successedUnsubscribeTempKey":
            console.log("Temp 키 구독 해제 완료: ", data.bindKeys);
            onSuccessUnsubscribeTempKeyForMixedClass();
            break;

        case "pro-rcvRbmqMessage":
            store.dispatch(onMessageArrivedFromIOSWebView(data));
            break;

        /**
         * mediasoup 관련 액션
         */
        case "pro-otherAudioState": // 20261104 [iOS] 다른 앱(유튜브 PiP 등) 소리 사용 여부 → 선생님 화면(LiveMediaSoupRcv)으로 전달
            if (isIOSWebView()) {
                window.__hiclassIOSOtherAudioBusy = !!(data && data.otherAudioBusy); // 20261104 MediaSoupClient.playAudio 소리 재생 보류 판단용
                window.dispatchEvent(new CustomEvent("hiclass-ios-other-audio", { detail: data || {} }));
            }
            break;

        case "pro-reconnectMediasoup": // 선생님 화면 연결이 끊어진 경우, 재연결 시도하는 부분
            //store.dispatch(reconnectLive());
            // 20261104 [iOS] 앱 복귀 때마다 무조건 다시 받지 않고, 수신 연결이 실제로 끊겼을 때만 다시 받는다
            if (isIOSWebView()) {
                checkLiveReceiveAliveIOS().then((res) => {
                    if (res && res.alive) {
                        console.log(`[iOS] 수신 연결 정상 → 재수신 생략 (${res.reason})`);
                    } else {
                        console.log(`[iOS] 수신 연결 끊김 판단 → 재수신 (${res && res.reason})`);
                        store.dispatch(unsubscribe(false, true, false, true));
                    }
                });
                break;
            }
            store.dispatch(unsubscribe(false, true, false, true));
            //store.dispatch(onSuccessSubscribeLive());
            break;

        // App 에서 mediasoup 연결 및 producer 와 관련된 부분
        case "rbmq-live-connectProducerTransport":
            sendAppConnectProducerTransport(data.dtlsParameters);
            break;

        case "rbmq-live-produce":
            sendAppProduce(data.mediaKind, data.rtpParameters);
            break;

        case "rbmq-live-endProduceCallback":
            sendAppEndProduceCallback(data.mediaKind);
            break;

        case "rbmq-live-unpublish":
            sendAppUnpublish(data.mediaKind);
            break;

        case "mediasoup-unpublish-done":
            if (window._mediasoupUnpublishResolve) {
                window._mediasoupUnpublishResolve();
                window._mediasoupUnpublishResolve = null;
            }
            break;

        case "error":
            console.error("❌ iOS screen share error:", data);
            //showErrorMessage(data.error || 'Unknown error occurred');
            //rollbackToCamera();
            break;

        default:
            console.log("❓ Unknown iOS message action:", action);
            break;
    }

    // 기존 콜백 호환성 유지
    if (window.screenShareCallback) {
        window.screenShareCallback(action, data || {});
    }
};
